{
  "decorations": [
    {
      "id": "warfish-logo-outline",
      "shape": "M 135.10 1375.20 C 134.95 1375.25 134.54 1375.44 134.18 1375.61 C 133.83 1375.79 133.42 1375.98 133.27 1376.02 C 132.98 1376.11 132.20 1376.61 131.47 1377.17 C 130.49 1377.92 129.52 1379.40 129.12 1380.75 C 128.81 1381.84 128.42 1382.13 127.38 1382.05 C 126.71 1381.99 126.42 1382.03 125.81 1382.21 C 125.10 1382.43 124.86 1382.44 121.29 1382.42 C 118.11 1382.40 117.46 1382.42 117.06 1382.56 C 116.48 1382.78 115.97 1382.78 115.29 1382.57 C 114.62 1382.37 110.25 1382.35 108.92 1382.54 C 108.16 1382.65 107.93 1382.65 107.25 1382.49 C 106.82 1382.38 106.01 1382.24 105.45 1382.17 C 103.96 1381.96 103.73 1381.77 103.88 1380.82 C 104.25 1378.49 103.75 1377.22 102.30 1376.76 C 101.38 1376.47 94.03 1376.35 93.15 1376.61 C 92.06 1376.93 91.77 1376.96 90.78 1376.74 C 89.95 1376.56 89.41 1376.54 86.92 1376.56 C 83.94 1376.58 83.48 1376.63 82.65 1377.05 C 82.10 1377.34 81.85 1377.31 80.89 1376.85 C 79.82 1376.34 73.16 1376.25 71.91 1376.72 C 71.25 1376.97 70.53 1377.65 70.26 1378.30 C 69.96 1379.01 70.16 1384.80 70.54 1386.60 C 70.69 1387.27 70.82 1388.54 70.91 1390.25 C 71.02 1392.26 71.12 1393.17 71.33 1394.07 C 71.51 1394.91 71.62 1395.75 71.68 1396.97 C 71.79 1399.70 72.32 1400.61 74.03 1401.06 C 75.12 1401.36 81.60 1401.26 82.72 1400.94 C 83.86 1400.61 83.87 1400.61 84.93 1400.95 C 85.88 1401.24 85.72 1401.24 92.67 1400.95 C 94.01 1400.90 95.02 1400.16 95.62 1398.80 C 96.09 1397.75 96.38 1397.77 97.25 1398.92 C 98.89 1401.09 102.33 1402.19 104.80 1401.32 C 105.84 1400.95 106.20 1400.93 107.24 1401.15 C 108.38 1401.38 112.13 1401.32 113.22 1401.05 C 113.98 1400.87 114.12 1400.86 114.77 1401.00 C 116.61 1401.36 121.90 1401.23 122.91 1400.79 C 124.01 1400.31 124.58 1398.84 124.88 1395.73 C 125.06 1393.91 125.43 1393.15 126.14 1393.15 C 126.75 1393.15 126.88 1394.06 126.44 1395.38 C 125.12 1399.41 126.15 1401.08 130.00 1401.19 C 132.66 1401.25 135.95 1401.06 136.90 1400.77 C 137.67 1400.53 137.70 1400.53 138.25 1400.72 C 139.61 1401.18 144.35 1401.29 147.13 1400.92 C 148.58 1400.73 148.88 1400.76 151.05 1401.29 C 152.38 1401.61 154.95 1401.55 156.47 1401.17 C 157.95 1400.78 159.01 1400.75 160.67 1401.03 C 162.06 1401.25 166.35 1401.29 167.53 1401.08 C 168.17 1400.97 168.42 1400.99 169.23 1401.14 C 170.83 1401.46 176.17 1401.17 177.86 1400.67 C 178.18 1400.59 178.44 1400.62 179.58 1400.95 C 181.27 1401.45 182.70 1401.51 183.63 1401.12 C 184.31 1400.85 185.07 1400.82 186.09 1401.06 C 186.75 1401.21 187.13 1401.22 189.88 1401.08 C 193.34 1400.92 193.51 1400.92 198.08 1401.10 C 202.01 1401.26 202.68 1401.18 203.48 1400.44 C 204.41 1399.59 204.73 1399.57 205.85 1400.30 C 206.24 1400.57 206.75 1400.80 206.95 1400.83 C 207.17 1400.88 207.73 1401.03 208.20 1401.18 C 209.62 1401.65 212.74 1401.67 214.16 1401.23 C 214.72 1401.05 215.35 1400.88 215.56 1400.85 C 215.76 1400.80 216.21 1400.61 216.56 1400.39 C 217.64 1399.73 218.12 1399.72 218.85 1400.35 C 219.89 1401.25 226.31 1401.72 228.07 1401.01 C 229.33 1400.50 230.13 1399.51 230.28 1398.29 C 230.34 1397.88 230.50 1397.15 230.65 1396.67 C 230.80 1396.18 230.97 1395.32 231.04 1394.77 C 231.09 1394.21 231.17 1393.64 231.20 1393.51 C 231.27 1393.11 231.88 1392.51 232.50 1392.22 C 233.53 1391.73 234.04 1390.92 234.24 1389.44 C 234.29 1388.96 234.47 1388.11 234.62 1387.53 C 235.16 1385.44 235.03 1384.47 234.08 1383.46 C 233.44 1382.80 233.45 1382.85 233.50 1381.58 C 233.53 1380.22 232.53 1378.75 231.37 1378.45 C 230.61 1378.25 223.41 1378.46 222.97 1378.70 C 222.00 1379.20 221.25 1380.09 221.25 1380.74 C 221.24 1381.32 220.87 1381.91 219.94 1382.81 C 218.88 1383.84 218.59 1383.93 217.86 1383.40 C 216.72 1382.58 215.75 1382.29 213.38 1382.09 C 211.98 1381.97 209.66 1382.22 208.82 1382.58 C 208.60 1382.68 208.16 1382.84 207.84 1382.96 C 207.52 1383.07 206.95 1383.39 206.57 1383.67 C 205.03 1384.80 205.05 1384.80 204.11 1383.87 C 203.28 1383.06 202.28 1382.47 201.45 1382.32 C 200.37 1382.12 198.25 1382.05 197.62 1382.20 C 197.21 1382.29 195.76 1382.34 192.84 1382.35 C 188.68 1382.37 188.64 1382.37 188.16 1382.62 C 186.47 1383.50 185.99 1384.56 185.53 1388.66 C 185.40 1389.86 184.81 1390.23 183.89 1389.70 C 183.33 1389.37 183.22 1389.35 182.05 1389.32 C 180.48 1389.29 180.28 1389.13 180.16 1387.92 C 179.84 1384.68 178.08 1382.68 175.17 1382.24 C 173.31 1381.97 172.95 1381.57 173.34 1380.20 C 173.86 1378.36 173.55 1376.99 172.46 1376.20 C 171.11 1375.23 164.34 1375.20 162.76 1376.18 C 162.12 1376.57 161.63 1377.44 161.51 1378.35 C 161.42 1379.12 160.64 1382.41 160.49 1382.64 C 160.30 1382.95 159.90 1382.95 159.17 1382.64 C 158.10 1382.17 156.90 1382.04 154.77 1382.19 C 152.38 1382.35 152.45 1382.38 152.22 1380.80 C 151.81 1377.83 150.70 1376.51 147.61 1375.35 C 146.85 1375.06 145.09 1375.20 144.23 1375.62 C 143.24 1376.11 142.63 1376.10 141.55 1375.57 C 140.75 1375.17 136.01 1374.90 135.10 1375.20 Z",
      "fill": "#252b2d",
      "role": "warfish-logo"
    },
    {
      "id": "warfish-logo-lettering",
      "shape": "M 136.14 1378.12 C 133.87 1378.52 132.27 1380.47 131.60 1383.63 C 131.36 1384.74 131.21 1384.96 130.42 1385.31 C 129.52 1385.72 129.45 1385.87 129.04 1388.28 C 128.95 1388.81 129.16 1389.33 129.63 1389.76 C 130.26 1390.35 130.31 1390.55 130.06 1391.64 C 129.94 1392.14 129.79 1393.12 129.72 1393.80 C 129.65 1394.48 129.48 1395.50 129.34 1396.05 C 128.82 1398.11 128.94 1398.20 132.13 1398.27 C 135.10 1398.32 135.12 1398.30 135.38 1396.03 C 135.46 1395.26 135.65 1394.19 135.80 1393.65 C 135.94 1393.11 136.10 1392.22 136.15 1391.66 C 136.29 1390.24 136.58 1389.92 137.83 1389.72 C 138.91 1389.54 139.09 1389.31 139.28 1387.89 C 139.33 1387.39 139.42 1386.76 139.46 1386.49 C 139.54 1385.84 139.28 1385.50 138.54 1385.31 C 137.03 1384.95 137.34 1383.15 138.96 1382.90 C 139.97 1382.73 140.05 1382.65 140.51 1380.91 C 141.18 1378.38 141.01 1378.17 138.27 1378.07 C 137.38 1378.04 136.42 1378.06 136.14 1378.12 Z M 144.48 1378.23 C 142.86 1378.71 141.80 1381.13 142.55 1382.67 C 144.13 1385.90 148.79 1384.55 148.78 1380.85 C 148.78 1378.67 146.90 1377.54 144.48 1378.23 Z M 164.77 1378.50 C 164.41 1378.75 164.32 1379.00 164.14 1380.08 C 164.06 1380.63 163.92 1381.34 163.83 1381.67 C 163.75 1382.00 163.60 1382.95 163.51 1383.77 C 163.41 1384.59 163.22 1385.74 163.08 1386.33 C 162.94 1386.92 162.77 1387.97 162.71 1388.64 C 162.64 1389.32 162.45 1390.48 162.28 1391.22 C 162.11 1391.96 161.92 1393.00 161.86 1393.55 C 161.79 1394.09 161.62 1395.00 161.47 1395.56 C 160.83 1398.03 161.00 1398.20 164.09 1398.20 C 167.10 1398.20 167.00 1398.31 167.75 1393.91 C 168.29 1390.74 168.98 1389.63 170.07 1390.16 C 170.75 1390.48 170.75 1390.91 170.12 1394.67 C 169.53 1398.16 169.45 1398.03 172.19 1398.15 C 174.85 1398.26 175.39 1398.11 175.54 1397.14 C 175.58 1396.92 175.72 1396.32 175.88 1395.80 C 176.01 1395.28 176.21 1394.41 176.30 1393.86 C 176.39 1393.33 176.58 1392.29 176.73 1391.59 C 177.39 1388.33 176.96 1386.30 175.46 1385.46 C 174.56 1384.97 172.23 1384.99 171.13 1385.51 C 169.63 1386.21 169.37 1385.91 169.68 1383.89 C 169.79 1383.17 169.95 1382.01 170.01 1381.34 C 170.07 1380.66 170.16 1379.93 170.20 1379.73 C 170.32 1379.22 170.18 1378.72 169.88 1378.58 C 169.45 1378.36 165.05 1378.31 164.77 1378.50 Z M 96.05 1379.18 C 94.09 1379.28 93.80 1379.46 93.25 1380.94 C 93.08 1381.37 92.75 1382.24 92.49 1382.90 C 92.25 1383.54 91.99 1384.29 91.91 1384.56 C 91.40 1386.62 90.71 1388.04 90.27 1387.98 C 89.81 1387.91 89.77 1387.61 89.77 1383.92 C 89.77 1378.93 89.93 1379.21 87.05 1379.20 C 84.16 1379.20 84.16 1379.20 83.01 1382.47 C 81.45 1386.90 81.18 1387.54 80.77 1387.63 C 80.36 1387.74 80.18 1387.47 80.14 1386.64 C 80.11 1386.24 80.02 1384.94 79.94 1383.75 C 79.85 1382.57 79.76 1381.25 79.74 1380.81 C 79.69 1379.44 79.61 1379.40 76.38 1379.40 C 72.92 1379.40 72.81 1379.49 73.27 1381.88 C 73.35 1382.32 73.45 1383.09 73.49 1383.59 C 73.52 1384.10 73.62 1385.09 73.71 1385.80 C 73.78 1386.50 73.88 1387.42 73.91 1387.84 C 73.95 1388.25 74.05 1389.27 74.14 1390.09 C 74.29 1391.54 74.66 1395.55 74.77 1396.85 C 74.88 1398.12 75.21 1398.24 78.62 1398.18 C 81.15 1398.15 81.15 1398.15 81.45 1397.88 C 81.92 1397.44 83.29 1394.51 84.08 1392.19 C 84.78 1390.15 85.57 1390.42 85.69 1392.74 C 85.98 1398.19 85.93 1398.11 88.75 1398.21 C 89.77 1398.26 90.81 1398.32 91.04 1398.36 C 92.23 1398.56 92.50 1398.22 94.06 1394.66 C 94.23 1394.27 94.78 1393.06 95.29 1391.95 C 95.79 1390.86 96.21 1389.92 96.21 1389.89 C 96.21 1389.86 96.52 1389.19 96.90 1388.41 C 97.85 1386.43 99.01 1383.85 99.52 1382.57 C 99.76 1381.98 100.08 1381.22 100.23 1380.87 C 100.97 1379.18 100.42 1378.96 96.05 1379.18 Z M 224.72 1381.50 C 224.26 1381.70 224.10 1381.99 223.88 1383.06 C 223.62 1384.36 223.39 1384.75 222.55 1385.19 C 221.85 1385.56 221.57 1385.95 221.57 1386.52 C 221.57 1386.66 221.44 1387.19 221.29 1387.71 C 220.94 1388.91 220.99 1389.23 221.60 1389.78 C 222.40 1390.49 222.46 1390.75 222.11 1392.08 C 221.99 1392.52 221.82 1393.49 221.73 1394.23 C 221.64 1394.97 221.48 1395.89 221.36 1396.29 C 220.83 1398.04 220.96 1398.12 224.11 1398.07 C 227.30 1398.03 226.96 1398.32 227.74 1395.03 C 227.94 1394.14 228.19 1392.89 228.30 1392.24 C 228.57 1390.43 228.87 1389.96 229.95 1389.73 C 230.98 1389.50 231.12 1389.32 231.39 1387.89 C 231.48 1387.39 231.62 1386.77 231.69 1386.52 C 231.87 1385.87 231.69 1385.57 230.95 1385.29 C 229.97 1384.94 229.77 1384.38 230.06 1382.82 C 230.21 1382.06 230.08 1381.70 229.58 1381.50 C 229.06 1381.27 225.22 1381.27 224.72 1381.50 Z M 126.39 1384.99 C 126.24 1385.03 125.71 1385.25 125.21 1385.47 L 124.31 1385.88 L 123.45 1385.59 C 122.40 1385.25 118.69 1385.16 117.96 1385.46 C 117.36 1385.72 117.05 1386.96 116.25 1392.35 C 116.09 1393.35 115.87 1394.86 115.74 1395.70 C 115.38 1398.11 115.41 1398.14 118.51 1398.15 C 120.57 1398.15 120.71 1398.14 120.92 1397.92 C 121.21 1397.64 121.82 1395.56 122.04 1394.17 C 122.51 1391.06 123.56 1389.82 125.47 1390.12 C 126.89 1390.35 127.27 1389.77 127.46 1387.10 C 127.57 1385.63 127.49 1385.19 127.08 1385.01 C 126.78 1384.87 126.77 1384.87 126.39 1384.99 Z M 210.41 1385.10 C 205.18 1386.24 202.60 1393.12 206.04 1396.79 C 207.67 1398.55 211.22 1399.17 213.95 1398.20 C 215.70 1397.57 216.47 1397.02 217.26 1395.84 C 218.08 1394.60 217.84 1394.13 216.33 1394.00 C 214.24 1393.82 213.79 1393.86 212.74 1394.35 C 211.61 1394.86 211.15 1394.82 210.82 1394.14 C 210.28 1393.09 211.27 1392.81 215.99 1392.66 C 219.08 1392.55 219.29 1392.31 218.74 1389.36 C 218.10 1386.04 214.53 1384.22 210.41 1385.10 Z M 213.20 1388.95 C 213.81 1389.57 213.47 1390.09 212.50 1390.08 C 211.42 1390.06 211.02 1389.48 211.70 1388.92 C 212.17 1388.52 212.79 1388.54 213.20 1388.95 Z M 103.62 1385.21 C 98.99 1385.94 96.60 1394.27 100.10 1397.50 C 101.61 1398.90 103.08 1399.09 105.02 1398.12 C 106.33 1397.46 106.60 1397.44 107.45 1397.89 C 108.48 1398.43 112.10 1398.25 112.42 1397.63 C 112.61 1397.25 113.16 1395.20 113.39 1393.95 C 113.51 1393.30 113.71 1392.41 113.83 1391.97 C 113.95 1391.53 114.10 1390.53 114.16 1389.77 C 114.21 1389.00 114.37 1387.94 114.49 1387.43 C 114.91 1385.58 114.77 1385.45 112.27 1385.37 C 109.98 1385.28 109.80 1385.31 109.10 1385.91 C 108.42 1386.48 108.19 1386.50 107.59 1386.00 C 106.61 1385.18 105.35 1384.93 103.62 1385.21 Z M 107.17 1390.09 C 108.48 1390.77 108.12 1392.90 106.58 1393.63 C 105.30 1394.24 104.02 1392.41 104.69 1390.94 C 105.08 1390.06 106.30 1389.64 107.17 1390.09 Z M 153.70 1385.21 C 151.84 1385.46 150.17 1387.26 150.05 1389.12 C 149.93 1390.92 150.76 1392.25 152.53 1393.11 C 153.39 1393.52 153.57 1393.70 153.57 1394.14 C 153.57 1394.79 152.85 1394.82 151.63 1394.23 C 150.13 1393.51 149.98 1393.56 148.78 1395.20 C 147.68 1396.71 147.95 1397.20 150.42 1398.17 C 153.83 1399.51 157.87 1398.59 159.30 1396.15 C 160.65 1393.84 159.55 1390.53 157.26 1390.03 C 156.28 1389.80 155.79 1389.23 156.22 1388.81 C 156.46 1388.56 156.89 1388.61 157.50 1388.96 C 158.50 1389.57 158.92 1389.33 159.75 1387.71 C 160.42 1386.41 160.38 1386.28 159.34 1385.80 C 158.05 1385.21 155.55 1384.95 153.70 1385.21 Z M 198.26 1385.16 C 197.61 1385.28 197.10 1385.46 196.68 1385.75 C 195.95 1386.26 195.67 1386.27 194.97 1385.79 C 194.37 1385.37 194.37 1385.37 192.14 1385.33 C 188.96 1385.29 188.88 1385.33 188.69 1387.49 C 188.64 1388.15 188.44 1389.30 188.26 1390.04 C 188.09 1390.78 187.84 1392.00 187.73 1392.78 C 187.62 1393.54 187.40 1394.87 187.25 1395.72 C 186.81 1398.17 186.84 1398.20 190.08 1398.20 C 192.92 1398.20 192.68 1398.41 193.31 1395.57 C 193.48 1394.80 193.65 1393.88 193.70 1393.53 C 193.94 1391.13 194.45 1390.15 195.44 1390.15 C 196.54 1390.15 196.70 1390.83 196.22 1393.42 C 195.54 1396.95 195.50 1397.60 195.93 1397.99 C 196.31 1398.34 200.70 1398.31 201.11 1397.96 C 201.43 1397.68 202.16 1395.13 202.29 1393.80 C 202.33 1393.41 202.52 1392.42 202.69 1391.60 C 203.68 1387.05 201.92 1384.51 198.26 1385.16 Z M 143.46 1385.30 C 142.07 1385.45 141.76 1386.05 141.33 1389.50 C 141.26 1390.06 141.07 1391.22 140.90 1392.08 C 139.61 1398.76 139.43 1398.20 142.93 1398.20 C 146.02 1398.20 146.03 1398.19 146.32 1395.79 C 146.42 1394.96 146.63 1393.63 146.81 1392.83 C 146.98 1392.04 147.15 1391.07 147.18 1390.68 C 147.23 1390.30 147.38 1389.45 147.50 1388.80 C 148.00 1386.45 147.97 1385.71 147.37 1385.42 C 147.03 1385.25 144.56 1385.18 143.46 1385.30 Z M 180.75 1392.42 C 178.99 1392.92 178.01 1395.03 178.81 1396.65 C 180.15 1399.36 183.81 1399.14 185.23 1396.25 C 186.45 1393.80 183.81 1391.55 180.75 1392.42 Z",
      "fill": "#ffffff",
      "role": "warfish-logo"
    }
  ],
  "id": "island-of-the-dead",
  "name": "Island of the Dead",
  "legacy": "warfish",
  "addedOn": "2026-10-29",
  "viewBox": {
    "x": 39.12,
    "y": 0,
    "width": 980.88,
    "height": 1490
  },
  "edgeConfig": {
    "internalBorderWidth": 3.531168,
    "regionBorderWidth": 17.8,
    "bridgeStrokeWidth": 0
  },
  "selectionInnerGlow": true,
  "backdropColor": {
    "light": "#dfe3e1",
    "dark": "#262c2e",
    "topBar": true
  },
  "gameLayout": {
    "playerBarPosition": "right",
    "topBarOverlap": 0.25
  },
  "regions": [
    {
      "id": "crown",
      "name": "Crown",
      "bonus": 6,
      "color": "#6259B3",
      "territoryIds": [
        "crypt-001",
        "crypt-002",
        "crypt-003",
        "crypt-004",
        "crypt-006",
        "crypt-007",
        "crypt-010",
        "crypt-012",
        "crypt-015"
      ],
      "shape": "M 490.0 101.0 L 490.0 103.0 L 498.0 110.0 L 497.0 120.0 L 495.0 125.0 L 494.0 134.0 L 499.0 136.0 L 502.0 139.0 L 545.0 139.0 L 549.0 143.0 L 555.0 141.0 L 554.0 145.0 L 557.0 148.0 L 558.0 153.0 L 552.0 155.0 L 544.0 155.0 L 540.0 157.0 L 541.0 160.0 L 542.0 160.0 L 542.0 162.0 L 542.0 163.0 L 543.0 163.0 L 543.0 165.0 L 543.0 166.0 L 544.0 166.0 L 544.0 167.0 L 544.0 169.0 L 545.0 170.0 L 551.0 171.0 L 554.0 168.0 L 558.0 167.0 L 563.0 169.0 L 570.0 177.0 L 576.0 178.0 L 579.0 180.0 L 590.0 179.0 L 595.0 177.0 L 611.0 177.0 L 611.0 178.0 L 625.0 178.0 L 633.0 181.0 L 639.0 182.0 L 643.0 187.0 L 643.0 193.0 L 645.0 193.0 L 654.0 197.0 L 657.0 197.0 L 673.0 206.0 L 677.0 207.0 L 678.0 210.0 L 687.0 214.0 L 693.0 221.0 L 693.0 223.0 L 698.0 228.0 L 699.0 232.0 L 710.0 241.0 L 716.0 248.0 L 719.0 249.0 L 721.0 254.0 L 724.0 254.0 L 724.0 255.0 L 734.0 255.0 L 738.0 258.0 L 741.0 258.0 L 745.0 261.0 L 753.0 263.0 L 755.0 265.0 L 770.0 269.0 L 779.0 275.0 L 785.0 276.0 L 785.0 277.0 L 794.0 280.0 L 796.0 282.0 L 803.0 283.0 L 806.0 283.0 L 815.0 283.0 L 820.0 285.0 L 824.0 285.0 L 828.0 284.0 L 838.0 278.0 L 848.0 278.0 L 855.0 280.0 L 860.0 278.0 L 866.0 273.0 L 872.0 271.0 L 873.0 264.0 L 886.0 256.0 L 890.0 255.0 L 890.0 240.0 L 891.0 240.0 L 891.0 222.0 L 888.0 205.0 L 885.0 203.0 L 883.0 198.0 L 880.0 196.0 L 878.0 191.0 L 872.0 185.0 L 870.0 180.0 L 867.0 177.0 L 867.0 167.0 L 866.0 167.0 L 866.0 158.0 L 841.0 134.0 L 839.0 136.0 L 839.0 133.0 L 836.0 132.0 L 830.0 125.0 L 829.0 122.0 L 819.0 119.0 L 808.0 107.0 L 795.0 102.0 L 787.0 98.0 L 781.0 91.0 L 779.0 91.0 L 774.0 85.0 L 767.0 82.0 L 763.0 79.0 L 758.0 79.0 L 749.0 76.0 L 744.0 72.0 L 737.0 70.0 L 733.0 67.0 L 730.0 67.0 L 717.0 59.0 L 716.0 57.0 L 711.0 57.0 L 703.0 55.0 L 696.0 51.0 L 691.0 50.0 L 688.0 46.0 L 677.0 45.0 L 662.0 39.0 L 654.0 37.0 L 647.0 35.0 L 643.0 32.0 L 640.0 32.0 L 635.0 29.0 L 624.0 28.0 L 618.0 24.0 L 612.0 24.0 L 601.0 20.0 L 589.0 19.0 L 589.0 18.0 L 562.0 18.0 L 557.0 20.0 L 543.0 20.0 L 543.0 19.0 L 529.0 19.0 L 511.0 19.0 L 511.0 20.0 L 489.0 20.0 L 484.0 18.0 L 456.0 18.0 L 453.0 20.0 L 445.0 21.0 L 439.0 23.0 L 428.0 30.0 L 416.0 34.0 L 416.0 35.0 L 407.0 35.0 L 407.0 36.0 L 395.0 36.0 L 390.0 40.0 L 385.0 42.0 L 386.0 52.0 L 388.0 58.0 L 389.0 69.0 L 410.0 89.0 L 412.0 103.0 L 421.0 109.0 L 423.0 112.0 L 435.0 111.0 L 446.0 103.0 L 452.0 105.0 L 470.0 105.0 L 478.0 100.0 L 490.0 101.0 Z"
    },
    {
      "id": "left-parietal",
      "name": "Left Parietal",
      "bonus": 5,
      "color": "#DD66FF",
      "territoryIds": [
        "crypt-005",
        "crypt-008",
        "crypt-011",
        "crypt-013",
        "crypt-018",
        "crypt-025",
        "crypt-029",
        "crypt-037"
      ],
      "shape": "M 337.0 137.0 L 337.0 136.0 L 347.0 136.0 L 353.0 117.0 L 358.0 117.0 L 363.0 112.0 L 371.0 112.0 L 374.0 116.0 L 377.0 116.0 L 382.0 116.0 L 382.0 114.0 L 382.0 108.0 L 380.0 105.0 L 383.0 103.0 L 383.0 95.0 L 378.0 91.0 L 378.0 89.0 L 373.0 85.0 L 373.0 83.0 L 367.0 78.0 L 367.0 76.0 L 362.0 72.0 L 359.0 65.0 L 360.0 51.0 L 357.0 48.0 L 342.0 48.0 L 336.0 51.0 L 333.0 51.0 L 324.0 61.0 L 317.0 63.0 L 311.0 67.0 L 308.0 67.0 L 302.0 71.0 L 295.0 73.0 L 291.0 78.0 L 253.0 96.0 L 253.0 98.0 L 251.0 98.0 L 246.0 103.0 L 232.0 110.0 L 231.0 112.0 L 224.0 115.0 L 212.0 128.0 L 198.0 135.0 L 186.0 148.0 L 185.0 148.0 L 185.0 150.0 L 154.0 180.0 L 150.0 189.0 L 148.0 190.0 L 146.0 196.0 L 138.0 207.0 L 137.0 211.0 L 129.0 219.0 L 126.0 224.0 L 123.0 232.0 L 121.0 233.0 L 119.0 239.0 L 116.0 242.0 L 114.0 250.0 L 97.0 266.0 L 98.0 267.0 L 90.0 272.0 L 89.0 283.0 L 86.0 292.0 L 74.0 303.0 L 74.0 312.0 L 76.0 314.0 L 76.0 321.0 L 74.0 325.0 L 69.0 330.0 L 69.0 346.0 L 68.0 346.0 L 68.0 362.0 L 65.0 365.0 L 65.0 377.0 L 66.0 377.0 L 66.0 389.0 L 63.0 394.0 L 60.0 400.0 L 59.0 405.0 L 59.0 449.0 L 60.0 449.0 L 60.0 492.0 L 62.0 496.0 L 66.0 493.0 L 73.0 492.0 L 83.0 492.0 L 83.0 493.0 L 97.0 493.0 L 101.0 490.0 L 109.0 489.0 L 113.0 486.0 L 119.0 478.0 L 125.0 473.0 L 125.0 471.0 L 133.0 467.0 L 143.0 455.0 L 148.0 452.0 L 152.0 452.0 L 156.0 448.0 L 160.0 447.0 L 167.0 441.0 L 170.0 441.0 L 171.0 441.0 L 173.0 439.0 L 202.0 439.0 L 202.0 438.0 L 213.0 438.0 L 227.0 430.0 L 233.0 425.0 L 247.0 425.0 L 252.0 424.0 L 258.0 415.0 L 260.0 414.0 L 262.0 408.0 L 264.0 407.0 L 268.0 395.0 L 268.0 379.0 L 265.0 373.0 L 265.0 368.0 L 261.0 361.0 L 261.0 355.0 L 259.0 351.0 L 255.0 350.0 L 252.0 346.0 L 242.0 346.0 L 233.0 343.0 L 229.0 338.0 L 228.0 329.0 L 231.0 329.0 L 238.0 323.0 L 238.0 314.0 L 235.0 310.0 L 235.0 302.0 L 237.0 300.0 L 237.0 291.0 L 233.0 288.0 L 230.0 283.0 L 231.0 274.0 L 238.0 268.0 L 240.0 262.0 L 244.0 259.0 L 245.0 253.0 L 247.0 251.0 L 250.0 238.0 L 260.0 232.0 L 270.0 231.0 L 271.0 225.0 L 277.0 221.0 L 286.0 220.0 L 295.0 223.0 L 298.0 226.0 L 307.0 226.0 L 314.0 227.0 L 315.0 223.0 L 322.0 217.0 L 329.0 215.0 L 329.0 207.0 L 321.0 196.0 L 323.0 190.0 L 329.0 189.0 L 340.0 189.0 L 347.0 188.0 L 349.0 185.0 L 356.0 184.0 L 359.0 182.0 L 367.0 181.0 L 372.0 179.0 L 372.0 173.0 L 368.0 171.0 L 363.0 166.0 L 355.0 166.0 L 351.0 162.0 L 350.0 155.0 L 350.0 146.0 L 348.0 140.0 L 345.0 138.0 L 337.0 137.0 Z"
    },
    {
      "id": "right-lacrimal",
      "name": "Right Lacrimal",
      "bonus": 2,
      "color": "#D45D98",
      "territoryIds": [
        "crypt-019",
        "crypt-020",
        "crypt-027"
      ],
      "shape": "M 600.0 297.0 L 593.0 297.0 L 591.0 299.0 L 593.0 315.0 L 590.0 320.0 L 590.0 331.0 L 595.0 339.0 L 595.0 342.0 L 599.0 348.0 L 596.0 355.0 L 594.0 356.0 L 594.0 364.0 L 604.0 373.0 L 607.0 379.0 L 611.0 382.0 L 614.0 388.0 L 618.0 391.0 L 621.0 397.0 L 625.0 400.0 L 628.0 405.0 L 635.0 405.0 L 641.0 398.0 L 642.0 400.0 L 644.0 400.0 L 647.0 396.0 L 655.0 392.0 L 659.0 387.0 L 659.0 386.0 L 658.0 383.0 L 650.0 376.0 L 649.0 371.0 L 645.0 366.0 L 645.0 358.0 L 649.0 356.0 L 651.0 352.0 L 651.0 346.0 L 659.0 341.0 L 660.0 339.0 L 668.0 335.0 L 670.0 335.0 L 672.0 335.0 L 678.0 333.0 L 684.0 333.0 L 693.0 327.0 L 693.0 326.0 L 704.0 316.0 L 705.0 308.0 L 697.0 303.0 L 693.0 298.0 L 695.0 297.0 L 695.0 286.0 L 691.0 283.0 L 691.0 275.0 L 702.0 265.0 L 702.0 264.0 L 703.0 264.0 L 705.0 261.0 L 711.0 260.0 L 718.0 257.0 L 720.0 254.0 L 721.0 254.0 L 719.0 249.0 L 716.0 248.0 L 710.0 241.0 L 699.0 232.0 L 698.0 228.0 L 693.0 223.0 L 693.0 221.0 L 687.0 214.0 L 678.0 210.0 L 677.0 207.0 L 673.0 206.0 L 657.0 197.0 L 654.0 197.0 L 645.0 193.0 L 643.0 193.0 L 642.0 196.0 L 637.0 200.0 L 625.0 200.0 L 619.0 214.0 L 610.0 222.0 L 610.0 229.0 L 614.0 232.0 L 614.0 240.0 L 606.0 250.0 L 605.0 254.0 L 597.0 264.0 L 597.0 276.0 L 596.0 276.0 L 596.0 288.0 L 593.0 296.0 L 600.0 297.0 Z"
    },
    {
      "id": "right-parietal",
      "name": "Right Parietal",
      "bonus": 9,
      "color": "#880E4F",
      "territoryIds": [
        "crypt-021",
        "crypt-024",
        "crypt-026",
        "crypt-030",
        "crypt-031",
        "crypt-033",
        "crypt-035",
        "crypt-036",
        "crypt-039",
        "crypt-042",
        "crypt-043",
        "crypt-044",
        "crypt-045",
        "crypt-049",
        "crypt-054",
        "crypt-058"
      ],
      "shape": "M 703.0 264.0 L 702.0 264.0 L 702.0 265.0 L 691.0 275.0 L 691.0 283.0 L 695.0 286.0 L 695.0 297.0 L 693.0 298.0 L 697.0 303.0 L 705.0 308.0 L 704.0 316.0 L 693.0 326.0 L 693.0 327.0 L 684.0 333.0 L 678.0 333.0 L 672.0 335.0 L 668.0 335.0 L 660.0 339.0 L 659.0 341.0 L 651.0 346.0 L 651.0 352.0 L 649.0 356.0 L 645.0 358.0 L 645.0 366.0 L 649.0 371.0 L 650.0 376.0 L 658.0 383.0 L 659.0 386.0 L 659.0 387.0 L 655.0 392.0 L 647.0 396.0 L 644.0 400.0 L 643.0 403.0 L 638.0 406.0 L 632.0 413.0 L 633.0 421.0 L 633.0 430.0 L 625.0 438.0 L 620.0 439.0 L 613.0 437.0 L 607.0 443.0 L 607.0 445.0 L 599.0 457.0 L 599.0 459.0 L 599.0 461.0 L 598.0 466.0 L 592.0 474.0 L 592.0 479.0 L 593.0 489.0 L 595.0 491.0 L 595.0 493.0 L 599.0 497.0 L 602.0 505.0 L 611.0 513.0 L 618.0 515.0 L 622.0 521.0 L 625.0 521.0 L 625.0 520.0 L 634.0 520.0 L 645.0 527.0 L 649.0 534.0 L 649.0 543.0 L 652.0 545.0 L 663.0 546.0 L 669.0 550.0 L 681.0 550.0 L 687.0 548.0 L 691.0 544.0 L 699.0 543.0 L 706.0 541.0 L 710.0 538.0 L 713.0 538.0 L 721.0 534.0 L 734.0 534.0 L 734.0 535.0 L 749.0 535.0 L 749.0 536.0 L 773.0 541.0 L 773.0 542.0 L 783.0 542.0 L 787.0 543.0 L 796.0 548.0 L 802.0 548.0 L 810.0 551.0 L 814.0 556.0 L 817.0 557.0 L 819.0 559.0 L 830.0 559.0 L 836.0 562.0 L 843.0 564.0 L 848.0 572.0 L 860.0 583.0 L 862.0 584.0 L 873.0 596.0 L 878.0 612.0 L 878.0 623.0 L 879.0 630.0 L 884.0 640.0 L 884.0 649.0 L 883.0 656.0 L 882.0 664.0 L 882.0 679.0 L 881.0 679.0 L 881.0 693.0 L 880.0 701.0 L 876.0 709.0 L 874.0 718.0 L 870.0 726.0 L 870.0 733.0 L 868.0 739.0 L 868.0 742.0 L 887.0 745.0 L 894.0 748.0 L 900.0 754.0 L 914.0 757.0 L 914.0 756.0 L 932.0 756.0 L 936.0 760.0 L 936.0 778.0 L 940.0 786.0 L 940.0 792.0 L 948.0 804.0 L 954.0 800.0 L 958.0 799.0 L 958.0 785.0 L 963.0 778.0 L 963.0 766.0 L 970.0 757.0 L 970.0 731.0 L 977.0 707.0 L 977.0 703.0 L 977.0 665.0 L 980.0 655.0 L 980.0 644.0 L 979.0 637.0 L 984.0 632.0 L 987.0 617.0 L 988.0 617.0 L 988.0 607.0 L 989.0 607.0 L 989.0 596.0 L 990.0 596.0 L 990.0 586.0 L 991.0 579.0 L 994.0 554.0 L 996.0 547.0 L 996.0 509.0 L 999.0 501.0 L 999.0 496.0 L 1001.0 492.0 L 1001.0 475.0 L 1002.0 475.0 L 1002.0 456.0 L 1001.0 453.0 L 1001.0 440.0 L 1000.0 440.0 L 1000.0 428.0 L 999.0 428.0 L 999.0 415.0 L 998.0 415.0 L 998.0 403.0 L 997.0 403.0 L 997.0 390.0 L 996.0 382.0 L 989.0 359.0 L 986.0 343.0 L 984.0 336.0 L 973.0 316.0 L 971.0 314.0 L 968.0 317.0 L 961.0 317.0 L 957.0 316.0 L 952.0 310.0 L 952.0 298.0 L 945.0 293.0 L 943.0 293.0 L 929.0 278.0 L 919.0 277.0 L 911.0 278.0 L 900.0 284.0 L 892.0 285.0 L 880.0 282.0 L 872.0 273.0 L 872.0 271.0 L 866.0 273.0 L 860.0 278.0 L 855.0 280.0 L 848.0 278.0 L 838.0 278.0 L 828.0 284.0 L 824.0 285.0 L 823.0 285.0 L 820.0 285.0 L 815.0 283.0 L 803.0 283.0 L 796.0 282.0 L 794.0 280.0 L 785.0 277.0 L 785.0 276.0 L 779.0 275.0 L 770.0 269.0 L 755.0 265.0 L 753.0 263.0 L 745.0 261.0 L 741.0 258.0 L 738.0 258.0 L 734.0 255.0 L 724.0 255.0 L 724.0 254.0 L 720.0 254.0 L 718.0 257.0 L 711.0 260.0 L 705.0 261.0 L 703.0 264.0 Z",
      "bonusAnchor": {
        "x": 856.41,
        "y": 448.61
      }
    },
    {
      "id": "left-orbital",
      "name": "Left Orbital",
      "bonus": 8,
      "color": "#1A237E",
      "territoryIds": [
        "crypt-023",
        "crypt-028",
        "crypt-038",
        "crypt-040",
        "crypt-041",
        "crypt-048",
        "crypt-051",
        "crypt-053",
        "crypt-059",
        "crypt-060",
        "crypt-061",
        "crypt-064",
        "crypt-065"
      ],
      "shape": "M 268.0 395.0 L 264.0 407.0 L 262.0 408.0 L 260.0 414.0 L 258.0 415.0 L 252.0 424.0 L 247.0 425.0 L 233.0 425.0 L 227.0 430.0 L 213.0 438.0 L 204.0 438.0 L 202.0 438.0 L 202.0 439.0 L 173.0 439.0 L 171.0 441.0 L 167.0 441.0 L 160.0 447.0 L 156.0 448.0 L 152.0 452.0 L 148.0 452.0 L 143.0 455.0 L 133.0 467.0 L 125.0 471.0 L 125.0 473.0 L 119.0 478.0 L 113.0 486.0 L 109.0 489.0 L 101.0 490.0 L 97.0 493.0 L 84.0 493.0 L 83.0 493.0 L 83.0 492.0 L 73.0 492.0 L 66.0 493.0 L 62.0 496.0 L 62.0 503.0 L 59.0 508.0 L 58.0 515.0 L 58.0 542.0 L 62.0 553.0 L 62.0 563.0 L 63.0 563.0 L 63.0 580.0 L 64.0 580.0 L 64.0 597.0 L 65.0 597.0 L 65.0 606.0 L 68.0 609.0 L 68.0 637.0 L 74.0 647.0 L 76.0 668.0 L 77.0 668.0 L 77.0 677.0 L 78.0 682.0 L 78.0 691.0 L 77.0 691.0 L 77.0 716.0 L 79.0 723.0 L 84.0 728.0 L 93.0 777.0 L 95.0 784.0 L 98.0 788.0 L 100.0 796.0 L 102.0 798.0 L 101.0 806.0 L 101.0 809.0 L 106.0 812.0 L 133.0 812.0 L 141.0 809.0 L 148.0 808.0 L 152.0 803.0 L 154.0 803.0 L 158.0 798.0 L 164.0 797.0 L 164.0 798.0 L 166.0 799.0 L 177.0 799.0 L 177.0 800.0 L 189.0 800.0 L 189.0 801.0 L 198.0 801.0 L 203.0 802.0 L 204.0 804.0 L 211.0 807.0 L 215.0 812.0 L 219.0 814.0 L 226.0 826.0 L 226.0 829.0 L 226.0 830.0 L 236.0 838.0 L 243.0 838.0 L 249.0 840.0 L 254.0 845.0 L 260.0 844.0 L 269.0 844.0 L 278.0 846.0 L 281.0 850.0 L 287.0 853.0 L 290.0 856.0 L 300.0 858.0 L 307.0 866.0 L 313.0 867.0 L 320.0 864.0 L 326.0 865.0 L 338.0 865.0 L 338.0 864.0 L 341.0 864.0 L 345.0 861.0 L 380.0 861.0 L 385.0 865.0 L 385.0 866.0 L 387.0 869.0 L 397.0 877.0 L 405.0 877.0 L 405.0 878.0 L 424.0 878.0 L 424.0 879.0 L 445.0 879.0 L 447.0 875.0 L 447.0 860.0 L 448.0 860.0 L 448.0 844.0 L 451.0 841.0 L 454.0 833.0 L 458.0 828.0 L 458.0 819.0 L 445.0 810.0 L 434.0 798.0 L 433.0 796.0 L 424.0 788.0 L 423.0 783.0 L 421.0 780.0 L 421.0 773.0 L 416.0 765.0 L 415.0 761.0 L 409.0 754.0 L 406.0 747.0 L 394.0 736.0 L 390.0 728.0 L 383.0 728.0 L 372.0 736.0 L 364.0 739.0 L 359.0 739.0 L 348.0 745.0 L 345.0 745.0 L 338.0 750.0 L 332.0 752.0 L 331.0 754.0 L 323.0 758.0 L 313.0 758.0 L 311.0 757.0 L 305.0 749.0 L 296.0 742.0 L 285.0 739.0 L 284.0 737.0 L 278.0 735.0 L 275.0 732.0 L 272.0 732.0 L 272.0 730.0 L 264.0 727.0 L 261.0 723.0 L 255.0 720.0 L 252.0 716.0 L 246.0 713.0 L 243.0 709.0 L 235.0 706.0 L 234.0 704.0 L 228.0 701.0 L 204.0 701.0 L 198.0 699.0 L 194.0 692.0 L 193.0 693.0 L 193.0 691.0 L 185.0 684.0 L 183.0 677.0 L 183.0 670.0 L 183.0 658.0 L 187.0 653.0 L 187.0 644.0 L 190.0 640.0 L 190.0 627.0 L 189.0 627.0 L 189.0 615.0 L 188.0 615.0 L 188.0 602.0 L 189.0 595.0 L 191.0 591.0 L 207.0 576.0 L 215.0 575.0 L 217.0 572.0 L 222.0 570.0 L 223.0 567.0 L 226.0 567.0 L 229.0 563.0 L 239.0 558.0 L 243.0 554.0 L 251.0 551.0 L 263.0 550.0 L 280.0 544.0 L 284.0 541.0 L 293.0 538.0 L 305.0 538.0 L 308.0 537.0 L 318.0 537.0 L 318.0 538.0 L 327.0 538.0 L 333.0 539.0 L 338.0 537.0 L 340.0 534.0 L 348.0 531.0 L 355.0 530.0 L 358.0 526.0 L 365.0 524.0 L 371.0 517.0 L 373.0 517.0 L 382.0 507.0 L 383.0 499.0 L 385.0 492.0 L 389.0 486.0 L 389.0 483.0 L 405.0 459.0 L 406.0 444.0 L 411.0 437.0 L 414.0 431.0 L 415.0 417.0 L 414.0 416.0 L 415.0 414.0 L 418.0 394.0 L 413.0 388.0 L 413.0 373.0 L 424.0 363.0 L 424.0 356.0 L 414.0 350.0 L 400.0 335.0 L 399.0 325.0 L 400.0 318.0 L 407.0 312.0 L 413.0 310.0 L 419.0 301.0 L 419.0 294.0 L 410.0 294.0 L 406.0 291.0 L 402.0 291.0 L 393.0 290.0 L 379.0 287.0 L 373.0 281.0 L 372.0 275.0 L 366.0 270.0 L 362.0 269.0 L 353.0 258.0 L 342.0 248.0 L 330.0 249.0 L 327.0 246.0 L 316.0 246.0 L 311.0 245.0 L 303.0 251.0 L 294.0 251.0 L 292.0 249.0 L 285.0 249.0 L 281.0 253.0 L 274.0 254.0 L 264.0 263.0 L 264.0 270.0 L 262.0 276.0 L 254.0 283.0 L 254.0 289.0 L 258.0 293.0 L 258.0 303.0 L 257.0 306.0 L 263.0 309.0 L 267.0 314.0 L 267.0 324.0 L 266.0 326.0 L 257.0 334.0 L 256.0 342.0 L 252.0 346.0 L 255.0 350.0 L 259.0 351.0 L 261.0 355.0 L 261.0 361.0 L 265.0 368.0 L 265.0 372.0 L 265.0 373.0 L 268.0 379.0 L 268.0 395.0 Z",
      "bonusAnchor": {
        "x": 237.41,
        "y": 485.91
      }
    },
    {
      "id": "right-zygomatic",
      "name": "Right Zygomatic",
      "bonus": 4,
      "color": "#7C4DFF",
      "territoryIds": [
        "crypt-062",
        "crypt-063",
        "crypt-066",
        "crypt-068",
        "crypt-069",
        "crypt-070",
        "crypt-073"
      ],
      "shape": "M 579.0 770.0 L 582.0 776.0 L 590.0 784.0 L 593.0 794.0 L 596.0 798.0 L 602.0 816.0 L 607.0 825.0 L 610.0 840.0 L 614.0 852.0 L 614.0 857.0 L 616.0 863.0 L 615.0 868.0 L 615.0 877.0 L 614.0 877.0 L 614.0 886.0 L 613.0 893.0 L 615.0 893.0 L 619.0 894.0 L 622.0 900.0 L 633.0 907.0 L 642.0 906.0 L 652.0 902.0 L 673.0 902.0 L 677.0 903.0 L 683.0 914.0 L 696.0 926.0 L 703.0 928.0 L 703.0 929.0 L 706.0 929.0 L 707.0 929.0 L 717.0 931.0 L 722.0 934.0 L 730.0 943.0 L 734.0 946.0 L 748.0 950.0 L 753.0 956.0 L 753.0 958.0 L 759.0 963.0 L 763.0 969.0 L 765.0 969.0 L 765.0 971.0 L 766.0 972.0 L 767.0 973.0 L 768.0 974.0 L 769.0 975.0 L 770.0 976.0 L 771.0 977.0 L 775.0 978.0 L 784.0 978.0 L 789.0 979.0 L 790.0 976.0 L 795.0 975.0 L 802.0 971.0 L 807.0 971.0 L 807.0 973.0 L 813.0 972.0 L 829.0 972.0 L 834.0 977.0 L 834.0 986.0 L 835.0 992.0 L 837.0 993.0 L 837.0 994.0 L 837.0 995.0 L 840.0 997.0 L 839.0 1013.0 L 847.0 1018.0 L 854.0 1019.0 L 854.0 1015.0 L 857.0 1009.0 L 860.0 995.0 L 862.0 991.0 L 875.0 979.0 L 875.0 977.0 L 892.0 961.0 L 896.0 960.0 L 906.0 949.0 L 917.0 944.0 L 918.0 942.0 L 929.0 937.0 L 934.0 930.0 L 939.0 918.0 L 941.0 917.0 L 944.0 908.0 L 947.0 904.0 L 951.0 891.0 L 954.0 887.0 L 957.0 877.0 L 962.0 871.0 L 965.0 863.0 L 967.0 862.0 L 975.0 842.0 L 975.0 834.0 L 973.0 829.0 L 970.0 826.0 L 964.0 825.0 L 957.0 820.0 L 953.0 819.0 L 948.0 813.0 L 948.0 804.0 L 940.0 792.0 L 940.0 786.0 L 936.0 778.0 L 936.0 760.0 L 932.0 756.0 L 914.0 756.0 L 914.0 757.0 L 900.0 754.0 L 894.0 748.0 L 887.0 745.0 L 868.0 742.0 L 866.0 742.0 L 862.0 748.0 L 859.0 750.0 L 857.0 755.0 L 852.0 760.0 L 847.0 773.0 L 835.0 783.0 L 831.0 789.0 L 824.0 793.0 L 817.0 801.0 L 815.0 801.0 L 809.0 808.0 L 804.0 811.0 L 795.0 814.0 L 791.0 817.0 L 773.0 820.0 L 765.0 818.0 L 758.0 818.0 L 754.0 816.0 L 749.0 816.0 L 741.0 813.0 L 736.0 813.0 L 726.0 810.0 L 721.0 809.0 L 715.0 806.0 L 704.0 804.0 L 698.0 802.0 L 691.0 797.0 L 687.0 796.0 L 674.0 786.0 L 670.0 785.0 L 664.0 781.0 L 658.0 774.0 L 656.0 774.0 L 642.0 759.0 L 638.0 754.0 L 630.0 735.0 L 620.0 718.0 L 614.0 720.0 L 613.0 722.0 L 595.0 724.0 L 592.0 730.0 L 592.0 735.0 L 586.0 743.0 L 583.0 744.0 L 570.0 744.0 L 565.0 749.0 L 565.0 751.0 L 567.0 757.0 L 579.0 770.0 Z"
    },
    {
      "id": "left-zygomatic",
      "name": "Left Zygomatic",
      "bonus": 5,
      "color": "#00D4E8",
      "territoryIds": [
        "crypt-067",
        "crypt-071",
        "crypt-072",
        "crypt-074",
        "crypt-078",
        "crypt-079",
        "crypt-087"
      ],
      "shape": "M 90.0 813.0 L 84.0 823.0 L 82.0 831.0 L 79.0 833.0 L 79.0 846.0 L 84.0 854.0 L 84.0 864.0 L 95.0 874.0 L 99.0 887.0 L 100.0 887.0 L 102.0 899.0 L 111.0 907.0 L 114.0 914.0 L 128.0 927.0 L 136.0 941.0 L 142.0 945.0 L 147.0 950.0 L 160.0 950.0 L 165.0 953.0 L 168.0 953.0 L 172.0 956.0 L 172.0 969.0 L 180.0 976.0 L 185.0 974.0 L 185.0 973.0 L 186.0 973.0 L 187.0 973.0 L 187.0 972.0 L 188.0 972.0 L 189.0 972.0 L 189.0 968.0 L 184.0 962.0 L 192.0 954.0 L 198.0 956.0 L 229.0 956.0 L 229.0 957.0 L 262.0 957.0 L 269.0 958.0 L 281.0 963.0 L 284.0 963.0 L 286.0 966.0 L 292.0 968.0 L 300.0 977.0 L 302.0 986.0 L 308.0 991.0 L 310.0 999.0 L 319.0 1007.0 L 323.0 1016.0 L 326.0 1018.0 L 330.0 1026.0 L 330.0 1034.0 L 327.0 1039.0 L 327.0 1048.0 L 328.0 1048.0 L 328.0 1057.0 L 332.0 1061.0 L 335.0 1067.0 L 335.0 1078.0 L 336.0 1078.0 L 336.0 1091.0 L 340.0 1096.0 L 341.0 1108.0 L 347.0 1116.0 L 353.0 1116.0 L 354.0 1118.0 L 362.0 1111.0 L 363.0 1109.0 L 363.0 1112.0 L 356.0 1118.0 L 350.0 1119.0 L 349.0 1122.0 L 352.0 1125.0 L 353.0 1129.0 L 378.0 1153.0 L 380.0 1153.0 L 385.0 1159.0 L 395.0 1163.0 L 403.0 1172.0 L 416.0 1170.0 L 418.0 1173.0 L 423.0 1175.0 L 425.0 1178.0 L 434.0 1180.0 L 434.0 1181.0 L 456.0 1181.0 L 455.0 1167.0 L 453.0 1166.0 L 453.0 1158.0 L 455.0 1157.0 L 454.0 1151.0 L 454.0 1141.0 L 453.0 1135.0 L 456.0 1132.0 L 457.0 1128.0 L 463.0 1124.0 L 469.0 1118.0 L 473.0 1118.0 L 473.0 1107.0 L 468.0 1100.0 L 467.0 1096.0 L 467.0 1086.0 L 470.0 1082.0 L 470.0 1081.0 L 470.0 1080.0 L 472.0 1078.0 L 472.0 1072.0 L 470.0 1067.0 L 470.0 1056.0 L 473.0 1048.0 L 475.0 1038.0 L 478.0 1034.0 L 477.0 1024.0 L 470.0 1018.0 L 469.0 1015.0 L 469.0 988.0 L 462.0 986.0 L 456.0 979.0 L 456.0 959.0 L 456.0 949.0 L 453.0 947.0 L 451.0 941.0 L 447.0 936.0 L 446.0 928.0 L 446.0 915.0 L 445.0 915.0 L 445.0 902.0 L 444.0 902.0 L 444.0 889.0 L 445.0 889.0 L 445.0 879.0 L 424.0 879.0 L 424.0 878.0 L 405.0 878.0 L 405.0 877.0 L 397.0 877.0 L 387.0 869.0 L 385.0 866.0 L 385.0 865.0 L 380.0 861.0 L 345.0 861.0 L 341.0 864.0 L 340.0 864.0 L 338.0 864.0 L 338.0 865.0 L 326.0 865.0 L 320.0 864.0 L 313.0 867.0 L 307.0 866.0 L 300.0 858.0 L 290.0 856.0 L 287.0 853.0 L 281.0 850.0 L 278.0 846.0 L 269.0 844.0 L 260.0 844.0 L 254.0 845.0 L 249.0 840.0 L 243.0 838.0 L 236.0 838.0 L 226.0 830.0 L 226.0 826.0 L 219.0 814.0 L 215.0 812.0 L 211.0 807.0 L 204.0 804.0 L 203.0 802.0 L 198.0 801.0 L 189.0 801.0 L 189.0 800.0 L 177.0 800.0 L 177.0 799.0 L 166.0 799.0 L 164.0 798.0 L 164.0 797.0 L 158.0 798.0 L 154.0 803.0 L 152.0 803.0 L 148.0 808.0 L 141.0 809.0 L 133.0 812.0 L 106.0 812.0 L 101.0 809.0 L 94.0 813.0 L 90.0 813.0 Z",
      "bonusAnchor": {
        "x": 380.49,
        "y": 970.39
      }
    },
    {
      "id": "maxilla",
      "name": "Maxilla",
      "bonus": 7,
      "color": "#C69724",
      "territoryIds": [
        "crypt-075",
        "crypt-076",
        "crypt-077",
        "crypt-080",
        "crypt-082",
        "crypt-084",
        "crypt-085",
        "crypt-086",
        "crypt-091",
        "crypt-092"
      ],
      "shape": "M 529.0 1126.0 L 534.0 1136.0 L 534.0 1171.0 L 538.0 1177.0 L 538.0 1185.0 L 543.0 1189.0 L 576.0 1189.0 L 586.0 1186.0 L 586.0 1172.0 L 583.0 1164.0 L 589.0 1157.0 L 592.0 1151.0 L 594.0 1143.0 L 594.0 1131.0 L 598.0 1139.0 L 601.0 1139.0 L 604.0 1147.0 L 603.0 1157.0 L 602.0 1157.0 L 602.0 1179.0 L 604.0 1182.0 L 609.0 1185.0 L 611.0 1188.0 L 620.0 1188.0 L 625.0 1184.0 L 629.0 1183.0 L 644.0 1175.0 L 652.0 1174.0 L 655.0 1168.0 L 672.0 1163.0 L 685.0 1148.0 L 686.0 1148.0 L 693.0 1141.0 L 699.0 1141.0 L 705.0 1139.0 L 707.0 1136.0 L 708.0 1136.0 L 714.0 1124.0 L 723.0 1116.0 L 731.0 1114.0 L 737.0 1107.0 L 738.0 1100.0 L 726.0 1089.0 L 723.0 1077.0 L 726.0 1067.0 L 726.0 1062.0 L 727.0 1062.0 L 728.0 1059.0 L 728.0 1049.0 L 727.0 1042.0 L 734.0 1032.0 L 734.0 1023.0 L 738.0 1018.0 L 738.0 1015.0 L 749.0 1014.0 L 749.0 1009.0 L 753.0 999.0 L 756.0 999.0 L 756.0 1020.0 L 762.0 1020.0 L 767.0 1013.0 L 768.0 1009.0 L 771.0 1006.0 L 772.0 999.0 L 772.0 986.0 L 773.0 979.0 L 771.0 977.0 L 770.0 977.0 L 770.0 976.0 L 769.0 976.0 L 769.0 975.0 L 768.0 975.0 L 768.0 974.0 L 767.0 974.0 L 767.0 973.0 L 766.0 973.0 L 766.0 972.0 L 765.0 972.0 L 765.0 971.0 L 763.0 969.0 L 759.0 963.0 L 753.0 958.0 L 753.0 956.0 L 748.0 950.0 L 734.0 946.0 L 730.0 943.0 L 722.0 934.0 L 717.0 931.0 L 707.0 929.0 L 703.0 929.0 L 703.0 928.0 L 696.0 926.0 L 683.0 914.0 L 677.0 903.0 L 673.0 902.0 L 652.0 902.0 L 642.0 906.0 L 633.0 907.0 L 622.0 900.0 L 619.0 894.0 L 615.0 893.0 L 612.0 893.0 L 609.0 903.0 L 609.0 913.0 L 608.0 913.0 L 608.0 922.0 L 607.0 922.0 L 607.0 932.0 L 606.0 939.0 L 601.0 951.0 L 601.0 954.0 L 593.0 966.0 L 593.0 968.0 L 588.0 972.0 L 579.0 974.0 L 576.0 976.0 L 564.0 978.0 L 556.0 975.0 L 551.0 971.0 L 545.0 964.0 L 541.0 953.0 L 534.0 941.0 L 534.0 924.0 L 532.0 919.0 L 526.0 919.0 L 521.0 930.0 L 521.0 947.0 L 522.0 954.0 L 519.0 959.0 L 518.0 964.0 L 506.0 975.0 L 496.0 978.0 L 497.0 979.0 L 492.0 980.0 L 486.0 985.0 L 470.0 989.0 L 469.0 988.0 L 469.0 1015.0 L 470.0 1018.0 L 477.0 1024.0 L 478.0 1034.0 L 475.0 1038.0 L 473.0 1048.0 L 470.0 1056.0 L 470.0 1067.0 L 472.0 1072.0 L 472.0 1075.0 L 472.0 1078.0 L 470.0 1080.0 L 470.0 1082.0 L 467.0 1086.0 L 467.0 1096.0 L 468.0 1100.0 L 473.0 1107.0 L 473.0 1118.0 L 474.0 1119.0 L 474.0 1129.0 L 473.0 1129.0 L 473.0 1146.0 L 474.0 1146.0 L 474.0 1165.0 L 475.0 1165.0 L 475.0 1175.0 L 477.0 1178.0 L 488.0 1184.0 L 489.0 1186.0 L 495.0 1189.0 L 503.0 1189.0 L 504.0 1186.0 L 511.0 1187.0 L 512.0 1184.0 L 518.0 1184.0 L 520.0 1182.0 L 520.0 1161.0 L 519.0 1161.0 L 519.0 1140.0 L 521.0 1134.0 L 529.0 1128.0 L 529.0 1126.0 Z",
      "bonusAnchor": {
        "x": 603.89,
        "y": 1056.6
      }
    },
    {
      "id": "right-mandible",
      "name": "Right Mandible",
      "bonus": 7,
      "color": "#D64B43",
      "territoryIds": [
        "crypt-081",
        "crypt-088",
        "crypt-089",
        "crypt-094",
        "crypt-095",
        "crypt-096",
        "crypt-098",
        "crypt-102",
        "crypt-103",
        "crypt-107"
      ],
      "shape": "M 798.0 981.0 L 801.0 983.0 L 801.0 989.0 L 797.0 992.0 L 794.0 998.0 L 790.0 1001.0 L 788.0 1013.0 L 783.0 1017.0 L 783.0 1026.0 L 776.0 1040.0 L 777.0 1043.0 L 775.0 1044.0 L 773.0 1053.0 L 772.0 1053.0 L 766.0 1065.0 L 762.0 1069.0 L 759.0 1076.0 L 751.0 1084.0 L 748.0 1090.0 L 744.0 1095.0 L 738.0 1100.0 L 737.0 1107.0 L 731.0 1114.0 L 723.0 1116.0 L 714.0 1124.0 L 708.0 1136.0 L 707.0 1136.0 L 705.0 1139.0 L 699.0 1141.0 L 693.0 1141.0 L 686.0 1148.0 L 685.0 1148.0 L 672.0 1163.0 L 655.0 1168.0 L 652.0 1174.0 L 656.0 1175.0 L 660.0 1180.0 L 659.0 1189.0 L 646.0 1197.0 L 636.0 1197.0 L 630.0 1191.0 L 630.0 1202.0 L 626.0 1205.0 L 608.0 1205.0 L 602.0 1213.0 L 609.0 1214.0 L 599.0 1214.0 L 595.0 1219.0 L 589.0 1218.0 L 584.0 1220.0 L 581.0 1228.0 L 581.0 1241.0 L 584.0 1246.0 L 584.0 1270.0 L 582.0 1270.0 L 582.0 1286.0 L 586.0 1293.0 L 587.0 1293.0 L 586.0 1297.0 L 586.0 1304.0 L 586.0 1311.0 L 588.0 1313.0 L 591.0 1321.0 L 596.0 1325.0 L 596.0 1327.0 L 601.0 1331.0 L 602.0 1339.0 L 600.0 1344.0 L 600.0 1351.0 L 601.0 1353.0 L 613.0 1364.0 L 615.0 1364.0 L 621.0 1373.0 L 624.0 1376.0 L 630.0 1378.0 L 644.0 1378.0 L 645.0 1387.0 L 647.0 1390.0 L 648.0 1390.0 L 656.0 1416.0 L 657.0 1416.0 L 666.0 1420.0 L 671.0 1426.0 L 679.0 1429.0 L 683.0 1432.0 L 691.0 1423.0 L 693.0 1423.0 L 702.0 1413.0 L 710.0 1410.0 L 717.0 1400.0 L 721.0 1397.0 L 727.0 1387.0 L 747.0 1368.0 L 752.0 1358.0 L 756.0 1352.0 L 768.0 1341.0 L 775.0 1327.0 L 785.0 1311.0 L 791.0 1300.0 L 793.0 1299.0 L 796.0 1293.0 L 796.0 1292.0 L 804.0 1282.0 L 807.0 1277.0 L 809.0 1269.0 L 818.0 1261.0 L 821.0 1253.0 L 830.0 1245.0 L 832.0 1237.0 L 838.0 1227.0 L 841.0 1225.0 L 842.0 1218.0 L 842.0 1206.0 L 843.0 1206.0 L 843.0 1193.0 L 844.0 1193.0 L 844.0 1181.0 L 845.0 1181.0 L 845.0 1171.0 L 845.0 1153.0 L 846.0 1153.0 L 846.0 1110.0 L 847.0 1110.0 L 847.0 1088.0 L 849.0 1083.0 L 856.0 1074.0 L 854.0 1054.0 L 855.0 1048.0 L 858.0 1044.0 L 858.0 1027.0 L 856.0 1026.0 L 854.0 1019.0 L 847.0 1018.0 L 839.0 1013.0 L 840.0 997.0 L 837.0 995.0 L 837.0 993.0 L 835.0 992.0 L 834.0 986.0 L 834.0 977.0 L 829.0 972.0 L 813.0 972.0 L 807.0 973.0 L 807.0 974.0 L 798.0 974.0 L 798.0 981.0 Z",
      "bonusAnchor": {
        "x": 741.77,
        "y": 1247.95
      }
    },
    {
      "id": "chin",
      "name": "Chin",
      "bonus": 5,
      "color": "#3674C4",
      "territoryIds": [
        "crypt-100",
        "crypt-101",
        "crypt-105",
        "crypt-106",
        "crypt-108",
        "crypt-109",
        "crypt-110"
      ],
      "shape": "M 582.0 1270.0 L 580.0 1270.0 L 580.0 1257.0 L 572.0 1257.0 L 567.0 1253.0 L 567.0 1250.0 L 564.0 1245.0 L 563.0 1238.0 L 563.0 1226.0 L 562.0 1219.0 L 566.0 1215.0 L 566.0 1207.0 L 549.0 1205.0 L 541.0 1208.0 L 541.0 1220.0 L 540.0 1220.0 L 540.0 1232.0 L 533.0 1238.0 L 528.0 1239.0 L 525.0 1234.0 L 521.0 1231.0 L 521.0 1218.0 L 520.0 1218.0 L 520.0 1206.0 L 510.0 1206.0 L 510.0 1207.0 L 500.0 1207.0 L 501.0 1216.0 L 495.0 1231.0 L 495.0 1242.0 L 496.0 1242.0 L 496.0 1254.0 L 493.0 1257.0 L 488.0 1258.0 L 486.0 1253.0 L 482.0 1248.0 L 479.0 1249.0 L 480.0 1245.0 L 477.0 1243.0 L 477.0 1233.0 L 481.0 1227.0 L 481.0 1203.0 L 475.0 1202.0 L 465.0 1202.0 L 457.0 1204.0 L 458.0 1209.0 L 458.0 1218.0 L 459.0 1224.0 L 455.0 1229.0 L 455.0 1251.0 L 452.0 1254.0 L 445.0 1255.0 L 439.0 1248.0 L 433.0 1233.0 L 434.0 1227.0 L 434.0 1217.0 L 435.0 1217.0 L 435.0 1206.0 L 436.0 1201.0 L 421.0 1201.0 L 421.0 1213.0 L 418.0 1220.0 L 418.0 1229.0 L 419.0 1229.0 L 419.0 1238.0 L 409.0 1249.0 L 409.0 1261.0 L 410.0 1261.0 L 410.0 1270.0 L 407.0 1270.0 L 407.0 1285.0 L 408.0 1285.0 L 408.0 1298.0 L 406.0 1305.0 L 404.0 1311.0 L 396.0 1318.0 L 393.0 1324.0 L 390.0 1336.0 L 390.0 1351.0 L 389.0 1351.0 L 389.0 1365.0 L 387.0 1371.0 L 388.0 1378.0 L 388.0 1401.0 L 392.0 1409.0 L 395.0 1412.0 L 395.0 1418.0 L 395.0 1419.0 L 395.0 1425.0 L 393.0 1429.0 L 396.0 1435.0 L 408.0 1440.0 L 409.0 1442.0 L 421.0 1447.0 L 421.0 1448.0 L 433.0 1448.0 L 433.0 1449.0 L 456.0 1449.0 L 456.0 1450.0 L 466.0 1450.0 L 480.0 1455.0 L 488.0 1455.0 L 495.0 1458.0 L 498.0 1458.0 L 507.0 1463.0 L 515.0 1463.0 L 523.0 1460.0 L 561.0 1460.0 L 571.0 1464.0 L 591.0 1464.0 L 591.0 1463.0 L 609.0 1463.0 L 613.0 1461.0 L 633.0 1454.0 L 635.0 1452.0 L 641.0 1451.0 L 653.0 1445.0 L 656.0 1445.0 L 660.0 1441.0 L 660.0 1432.0 L 659.0 1432.0 L 659.0 1422.0 L 657.0 1416.0 L 656.0 1416.0 L 648.0 1390.0 L 647.0 1390.0 L 645.0 1387.0 L 644.0 1378.0 L 630.0 1378.0 L 624.0 1376.0 L 621.0 1373.0 L 615.0 1364.0 L 613.0 1364.0 L 601.0 1353.0 L 600.0 1351.0 L 600.0 1349.0 L 600.0 1344.0 L 602.0 1339.0 L 601.0 1331.0 L 596.0 1327.0 L 596.0 1325.0 L 591.0 1321.0 L 588.0 1313.0 L 586.0 1311.0 L 586.0 1297.0 L 587.0 1293.0 L 586.0 1293.0 L 582.0 1286.0 L 582.0 1270.0 Z",
      "bonusAnchor": {
        "x": 481.56,
        "y": 1348.6
      }
    },
    {
      "id": "nasal-ridge",
      "name": "Nasal Ridge",
      "bonus": 7,
      "color": "#83AB35",
      "territoryIds": [
        "crypt-009",
        "crypt-014",
        "crypt-016",
        "crypt-017",
        "crypt-022",
        "crypt-032",
        "crypt-034",
        "crypt-046",
        "crypt-047",
        "crypt-050",
        "crypt-052",
        "crypt-055",
        "crypt-056",
        "crypt-057"
      ],
      "shape": "M 370.0 131.0 L 371.0 146.0 L 373.0 149.0 L 380.0 153.0 L 381.0 155.0 L 393.0 160.0 L 394.0 162.0 L 400.0 164.0 L 406.0 170.0 L 406.0 179.0 L 405.0 179.0 L 405.0 181.0 L 402.0 183.0 L 395.0 191.0 L 387.0 193.0 L 385.0 195.0 L 362.0 200.0 L 352.0 203.0 L 351.0 211.0 L 356.0 217.0 L 356.0 221.0 L 348.0 226.0 L 348.0 233.0 L 356.0 235.0 L 361.0 241.0 L 362.0 246.0 L 371.0 253.0 L 383.0 256.0 L 391.0 267.0 L 396.0 271.0 L 401.0 271.0 L 410.0 274.0 L 424.0 274.0 L 424.0 275.0 L 437.0 275.0 L 443.0 277.0 L 448.0 285.0 L 452.0 284.0 L 446.0 303.0 L 438.0 310.0 L 437.0 315.0 L 434.0 321.0 L 427.0 327.0 L 427.0 334.0 L 437.0 342.0 L 445.0 343.0 L 449.0 348.0 L 451.0 348.0 L 456.0 354.0 L 459.0 354.0 L 459.0 364.0 L 458.0 366.0 L 446.0 377.0 L 436.0 382.0 L 436.0 390.0 L 438.0 396.0 L 444.0 402.0 L 444.0 423.0 L 448.0 429.0 L 450.0 436.0 L 457.0 441.0 L 465.0 444.0 L 468.0 447.0 L 486.0 450.0 L 494.0 452.0 L 502.0 461.0 L 503.0 461.0 L 503.0 463.0 L 509.0 468.0 L 509.0 470.0 L 515.0 475.0 L 513.0 483.0 L 513.0 492.0 L 514.0 492.0 L 514.0 501.0 L 518.0 509.0 L 519.0 515.0 L 523.0 523.0 L 523.0 530.0 L 518.0 534.0 L 517.0 537.0 L 517.0 533.0 L 512.0 529.0 L 511.0 524.0 L 508.0 520.0 L 506.0 503.0 L 501.0 497.0 L 497.0 483.0 L 485.0 475.0 L 483.0 472.0 L 478.0 470.0 L 476.0 467.0 L 463.0 464.0 L 450.0 460.0 L 446.0 457.0 L 442.0 449.0 L 438.0 444.0 L 432.0 444.0 L 429.0 452.0 L 426.0 456.0 L 426.0 466.0 L 427.0 466.0 L 427.0 477.0 L 422.0 481.0 L 422.0 483.0 L 417.0 487.0 L 414.0 510.0 L 411.0 517.0 L 408.0 519.0 L 408.0 542.0 L 409.0 542.0 L 409.0 566.0 L 416.0 573.0 L 420.0 583.0 L 421.0 583.0 L 421.0 596.0 L 423.0 599.0 L 423.0 612.0 L 424.0 612.0 L 424.0 630.0 L 423.0 630.0 L 423.0 644.0 L 422.0 644.0 L 422.0 654.0 L 421.0 661.0 L 418.0 672.0 L 418.0 697.0 L 421.0 700.0 L 423.0 706.0 L 425.0 707.0 L 427.0 713.0 L 429.0 714.0 L 431.0 720.0 L 433.0 721.0 L 435.0 727.0 L 437.0 728.0 L 439.0 734.0 L 442.0 737.0 L 442.0 745.0 L 448.0 760.0 L 450.0 767.0 L 452.0 768.0 L 454.0 774.0 L 467.0 784.0 L 471.0 789.0 L 478.0 789.0 L 481.0 783.0 L 481.0 780.0 L 484.0 776.0 L 484.0 773.0 L 487.0 767.0 L 493.0 763.0 L 499.0 756.0 L 499.0 754.0 L 509.0 745.0 L 538.0 741.0 L 538.0 740.0 L 543.0 740.0 L 551.0 743.0 L 556.0 748.0 L 560.0 748.0 L 563.0 751.0 L 565.0 751.0 L 565.0 749.0 L 570.0 744.0 L 583.0 744.0 L 586.0 743.0 L 592.0 735.0 L 592.0 730.0 L 595.0 724.0 L 613.0 722.0 L 614.0 720.0 L 620.0 718.0 L 619.0 717.0 L 619.0 708.0 L 618.0 700.0 L 613.0 693.0 L 613.0 641.0 L 616.0 633.0 L 617.0 633.0 L 619.0 628.0 L 622.0 625.0 L 628.0 604.0 L 634.0 594.0 L 637.0 592.0 L 637.0 582.0 L 636.0 582.0 L 636.0 564.0 L 635.0 564.0 L 635.0 549.0 L 632.0 548.0 L 629.0 543.0 L 620.0 535.0 L 619.0 526.0 L 622.0 521.0 L 618.0 515.0 L 611.0 513.0 L 602.0 505.0 L 599.0 497.0 L 595.0 493.0 L 595.0 491.0 L 593.0 489.0 L 592.0 479.0 L 592.0 476.0 L 592.0 474.0 L 598.0 466.0 L 599.0 461.0 L 599.0 457.0 L 607.0 445.0 L 607.0 443.0 L 613.0 437.0 L 607.0 431.0 L 612.0 427.0 L 612.0 416.0 L 592.0 397.0 L 590.0 391.0 L 586.0 386.0 L 585.0 375.0 L 582.0 369.0 L 573.0 361.0 L 573.0 338.0 L 572.0 338.0 L 572.0 310.0 L 571.0 302.0 L 569.0 300.0 L 570.0 300.0 L 569.0 297.0 L 571.0 295.0 L 573.0 287.0 L 573.0 275.0 L 571.0 272.0 L 571.0 265.0 L 574.0 262.0 L 577.0 254.0 L 579.0 253.0 L 582.0 245.0 L 586.0 240.0 L 586.0 232.0 L 582.0 226.0 L 586.0 213.0 L 581.0 211.0 L 578.0 208.0 L 565.0 206.0 L 554.0 200.0 L 550.0 197.0 L 541.0 196.0 L 533.0 191.0 L 524.0 191.0 L 524.0 190.0 L 535.0 190.0 L 540.0 189.0 L 538.0 184.0 L 532.0 178.0 L 536.0 173.0 L 543.0 172.0 L 545.0 170.0 L 544.0 170.0 L 544.0 169.0 L 544.0 167.0 L 543.0 167.0 L 543.0 166.0 L 543.0 165.0 L 542.0 165.0 L 542.0 163.0 L 542.0 162.0 L 541.0 160.0 L 540.0 160.0 L 540.0 157.0 L 538.0 158.0 L 520.0 158.0 L 517.0 160.0 L 506.0 159.0 L 495.0 157.0 L 492.0 160.0 L 492.0 156.0 L 485.0 155.0 L 476.0 145.0 L 476.0 140.0 L 470.0 133.0 L 472.0 122.0 L 465.0 122.0 L 463.0 125.0 L 445.0 123.0 L 437.0 130.0 L 428.0 130.0 L 423.0 128.0 L 412.0 127.0 L 407.0 124.0 L 404.0 119.0 L 395.0 120.0 L 388.0 114.0 L 382.0 114.0 L 382.0 116.0 L 377.0 116.0 L 378.0 125.0 L 370.0 131.0 Z"
    },
    {
      "id": "left-mandible",
      "name": "Left Mandible",
      "bonus": 4,
      "color": "#C0CA33",
      "territoryIds": [
        "crypt-083",
        "crypt-090",
        "crypt-093",
        "crypt-097",
        "crypt-099",
        "crypt-104"
      ],
      "shape": "M 189.0 985.0 L 193.0 994.0 L 196.0 997.0 L 197.0 1005.0 L 197.0 1014.0 L 198.0 1014.0 L 198.0 1031.0 L 197.0 1031.0 L 197.0 1040.0 L 196.0 1046.0 L 205.0 1062.0 L 207.0 1070.0 L 207.0 1079.0 L 206.0 1079.0 L 206.0 1088.0 L 211.0 1098.0 L 211.0 1105.0 L 210.0 1113.0 L 207.0 1120.0 L 207.0 1131.0 L 210.0 1133.0 L 213.0 1143.0 L 214.0 1143.0 L 214.0 1153.0 L 212.0 1156.0 L 213.0 1164.0 L 213.0 1178.0 L 214.0 1185.0 L 217.0 1193.0 L 217.0 1205.0 L 218.0 1205.0 L 218.0 1217.0 L 224.0 1222.0 L 224.0 1224.0 L 230.0 1229.0 L 232.0 1236.0 L 236.0 1242.0 L 238.0 1249.0 L 242.0 1252.0 L 245.0 1258.0 L 252.0 1265.0 L 254.0 1272.0 L 257.0 1276.0 L 257.0 1279.0 L 260.0 1283.0 L 260.0 1286.0 L 263.0 1290.0 L 263.0 1293.0 L 267.0 1300.0 L 270.0 1302.0 L 276.0 1313.0 L 279.0 1315.0 L 282.0 1321.0 L 283.0 1325.0 L 291.0 1332.0 L 291.0 1334.0 L 299.0 1341.0 L 299.0 1343.0 L 307.0 1350.0 L 312.0 1360.0 L 320.0 1370.0 L 321.0 1374.0 L 329.0 1384.0 L 330.0 1388.0 L 338.0 1398.0 L 341.0 1405.0 L 346.0 1410.0 L 356.0 1411.0 L 363.0 1415.0 L 373.0 1418.0 L 378.0 1422.0 L 382.0 1427.0 L 390.0 1429.0 L 393.0 1429.0 L 395.0 1425.0 L 395.0 1418.0 L 395.0 1412.0 L 392.0 1409.0 L 388.0 1401.0 L 388.0 1378.0 L 387.0 1371.0 L 389.0 1365.0 L 389.0 1351.0 L 390.0 1351.0 L 390.0 1336.0 L 393.0 1324.0 L 396.0 1318.0 L 404.0 1311.0 L 406.0 1305.0 L 408.0 1298.0 L 408.0 1285.0 L 407.0 1285.0 L 407.0 1270.0 L 403.0 1269.0 L 403.0 1259.0 L 406.0 1254.0 L 406.0 1251.0 L 409.0 1246.0 L 409.0 1239.0 L 405.0 1238.0 L 401.0 1231.0 L 399.0 1230.0 L 400.0 1216.0 L 403.0 1210.0 L 403.0 1194.0 L 402.0 1191.0 L 384.0 1174.0 L 373.0 1172.0 L 371.0 1175.0 L 373.0 1169.0 L 362.0 1159.0 L 362.0 1157.0 L 350.0 1146.0 L 350.0 1144.0 L 339.0 1134.0 L 336.0 1125.0 L 332.0 1120.0 L 327.0 1116.0 L 324.0 1105.0 L 317.0 1105.0 L 314.0 1109.0 L 308.0 1109.0 L 301.0 1101.0 L 299.0 1101.0 L 299.0 1092.0 L 300.0 1085.0 L 285.0 1082.0 L 281.0 1080.0 L 268.0 1066.0 L 266.0 1059.0 L 263.0 1053.0 L 247.0 1035.0 L 245.0 1027.0 L 242.0 1022.0 L 241.0 1010.0 L 240.0 1007.0 L 232.0 1005.0 L 225.0 997.0 L 222.0 983.0 L 212.0 983.0 L 212.0 982.0 L 201.0 982.0 L 190.0 972.0 L 189.0 972.0 L 188.0 972.0 L 188.0 973.0 L 187.0 973.0 L 186.0 973.0 L 185.0 974.0 L 181.0 978.0 L 189.0 985.0 Z",
      "bonusAnchor": {
        "x": 308.9,
        "y": 1221.3
      }
    }
  ],
  "territories": [
    {
      "id": "crypt-001",
      "name": "Ashen Crypt",
      "regionId": "crown",
      "shape": "M 529.0 19.0 L 530.0 24.0 L 530.0 40.0 L 537.0 43.0 L 540.0 48.0 L 547.0 52.0 L 550.0 56.0 L 550.0 60.0 L 556.0 62.0 L 557.0 65.0 L 567.0 72.0 L 570.0 75.0 L 570.0 81.0 L 578.0 88.0 L 579.0 94.0 L 583.0 99.0 L 585.0 99.0 L 585.0 100.0 L 593.0 100.0 L 599.0 105.0 L 613.0 106.0 L 617.0 108.0 L 617.0 107.0 L 621.0 104.0 L 623.0 97.0 L 627.0 94.0 L 627.0 82.0 L 629.0 80.0 L 629.0 74.0 L 632.0 73.0 L 635.0 69.0 L 637.0 60.0 L 652.0 46.0 L 654.0 37.0 L 647.0 35.0 L 643.0 32.0 L 640.0 32.0 L 635.0 29.0 L 624.0 28.0 L 618.0 24.0 L 612.0 24.0 L 601.0 20.0 L 589.0 19.0 L 589.0 18.0 L 562.0 18.0 L 557.0 20.0 L 543.0 20.0 L 543.0 19.0 Z",
      "position": {
        "x": 597,
        "y": 57.9
      },
      "badgeAnchor": {
        "x": 597,
        "y": 57.9
      },
      "adjacencies": [
        "crypt-002",
        "crypt-003",
        "crypt-004",
        "crypt-007"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-002",
      "name": "Ashen Barrow",
      "regionId": "crown",
      "shape": "M 490.0 101.0 L 491.0 100.0 L 492.0 99.0 L 493.0 98.0 L 493.0 96.0 L 495.0 96.0 L 497.0 94.0 L 496.0 82.0 L 493.0 80.0 L 493.0 72.0 L 496.0 69.0 L 496.0 63.0 L 502.0 60.0 L 506.0 60.0 L 511.0 54.0 L 511.0 49.0 L 517.0 44.0 L 517.0 42.0 L 527.0 41.0 L 530.0 39.0 L 530.0 24.0 L 529.0 19.0 L 511.0 19.0 L 511.0 20.0 L 489.0 20.0 L 484.0 18.0 L 456.0 18.0 L 453.0 20.0 L 445.0 21.0 L 439.0 23.0 L 428.0 30.0 L 416.0 34.0 L 416.0 35.0 L 407.0 35.0 L 407.0 36.0 L 395.0 36.0 L 390.0 40.0 L 385.0 42.0 L 386.0 52.0 L 388.0 58.0 L 389.0 69.0 L 410.0 89.0 L 412.0 103.0 L 421.0 109.0 L 423.0 112.0 L 435.0 111.0 L 446.0 103.0 L 452.0 105.0 L 470.0 105.0 L 478.0 100.0 Z",
      "position": {
        "x": 445.9,
        "y": 58.2
      },
      "badgeAnchor": {
        "x": 445.9,
        "y": 58.2
      },
      "adjacencies": [
        "crypt-001",
        "crypt-004"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-003",
      "name": "Ashen Ossuary",
      "regionId": "crown",
      "shape": "M 654.0 37.0 L 652.0 46.0 L 637.0 60.0 L 635.0 69.0 L 632.0 73.0 L 629.0 74.0 L 629.0 80.0 L 627.0 82.0 L 627.0 94.0 L 623.0 97.0 L 621.0 104.0 L 617.0 107.0 L 617.0 110.0 L 623.0 113.0 L 627.0 120.0 L 634.0 124.0 L 638.0 123.0 L 650.0 130.0 L 657.0 136.0 L 663.0 138.0 L 667.0 141.0 L 668.0 144.0 L 672.0 144.0 L 676.0 143.0 L 682.0 136.0 L 686.0 133.0 L 696.0 130.0 L 704.0 125.0 L 704.0 123.0 L 709.0 119.0 L 710.0 119.0 L 710.0 114.0 L 716.0 109.0 L 718.0 101.0 L 729.0 94.0 L 732.0 94.0 L 739.0 87.0 L 739.0 80.0 L 742.0 78.0 L 744.0 72.0 L 737.0 70.0 L 733.0 67.0 L 730.0 67.0 L 717.0 59.0 L 716.0 57.0 L 711.0 57.0 L 703.0 55.0 L 696.0 51.0 L 691.0 50.0 L 688.0 46.0 L 677.0 45.0 L 662.0 39.0 Z",
      "position": {
        "x": 673.7,
        "y": 91.7
      },
      "badgeAnchor": {
        "x": 673.7,
        "y": 91.7
      },
      "adjacencies": [
        "crypt-001",
        "crypt-006",
        "crypt-007",
        "crypt-010"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-004",
      "name": "Ashen Cairn",
      "regionId": "crown",
      "shape": "M 495.0 96.0 L 493.0 98.0 L 493.0 99.0 L 492.0 99.0 L 492.0 100.0 L 491.0 100.0 L 491.0 101.0 L 490.0 101.0 L 490.0 103.0 L 498.0 110.0 L 497.0 120.0 L 495.0 125.0 L 494.0 134.0 L 499.0 136.0 L 502.0 139.0 L 545.0 139.0 L 549.0 143.0 L 555.0 141.0 L 556.0 141.0 L 557.0 141.0 L 557.0 139.0 L 558.0 139.0 L 559.0 138.0 L 560.0 137.0 L 561.0 136.0 L 562.0 128.0 L 573.0 118.0 L 573.0 115.0 L 580.0 110.0 L 585.0 103.0 L 585.0 99.0 L 583.0 99.0 L 579.0 94.0 L 578.0 88.0 L 570.0 81.0 L 570.0 75.0 L 567.0 72.0 L 557.0 65.0 L 556.0 62.0 L 550.0 60.0 L 550.0 56.0 L 547.0 52.0 L 540.0 48.0 L 537.0 43.0 L 530.0 40.0 L 530.0 39.0 L 527.0 41.0 L 517.0 42.0 L 517.0 44.0 L 511.0 49.0 L 511.0 54.0 L 506.0 60.0 L 502.0 60.0 L 496.0 63.0 L 496.0 69.0 L 493.0 72.0 L 493.0 80.0 L 496.0 82.0 L 497.0 94.0 Z",
      "position": {
        "x": 533.5,
        "y": 94.1
      },
      "badgeAnchor": {
        "x": 533.5,
        "y": 94.1
      },
      "adjacencies": [
        "crypt-001",
        "crypt-002",
        "crypt-007"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-005",
      "name": "Ashen Haven",
      "regionId": "left-parietal",
      "shape": "M 253.0 98.0 L 259.0 105.0 L 265.0 105.0 L 274.0 111.0 L 279.0 118.0 L 281.0 119.0 L 281.0 129.0 L 284.0 139.0 L 287.0 139.0 L 291.0 143.0 L 291.0 150.0 L 293.0 150.0 L 295.0 152.0 L 301.0 153.0 L 317.0 153.0 L 324.0 148.0 L 324.0 144.0 L 329.0 141.0 L 336.0 139.0 L 336.0 137.0 L 337.0 137.0 L 337.0 136.0 L 347.0 136.0 L 353.0 117.0 L 358.0 117.0 L 363.0 112.0 L 371.0 112.0 L 374.0 116.0 L 377.0 116.0 L 382.0 116.0 L 382.0 114.0 L 382.0 108.0 L 380.0 105.0 L 383.0 103.0 L 383.0 95.0 L 378.0 91.0 L 378.0 89.0 L 373.0 85.0 L 373.0 83.0 L 367.0 78.0 L 367.0 76.0 L 362.0 72.0 L 359.0 65.0 L 360.0 51.0 L 357.0 48.0 L 342.0 48.0 L 336.0 51.0 L 333.0 51.0 L 324.0 61.0 L 317.0 63.0 L 311.0 67.0 L 308.0 67.0 L 302.0 71.0 L 295.0 73.0 L 291.0 78.0 L 253.0 96.0 Z",
      "position": {
        "x": 315.9,
        "y": 104.6
      },
      "badgeAnchor": {
        "x": 315.9,
        "y": 104.6
      },
      "adjacencies": [
        "crypt-008",
        "crypt-011",
        "crypt-009"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-006",
      "name": "Ashen Watch",
      "regionId": "crown",
      "shape": "M 744.0 72.0 L 742.0 78.0 L 739.0 80.0 L 739.0 87.0 L 732.0 94.0 L 729.0 94.0 L 718.0 101.0 L 716.0 109.0 L 710.0 114.0 L 710.0 119.0 L 711.0 119.0 L 714.0 121.0 L 719.0 129.0 L 721.0 130.0 L 721.0 135.0 L 727.0 140.0 L 727.0 146.0 L 737.0 152.0 L 742.0 158.0 L 750.0 160.0 L 751.0 163.0 L 765.0 176.0 L 770.0 177.0 L 774.0 180.0 L 779.0 181.0 L 786.0 188.0 L 786.0 189.0 L 800.0 189.0 L 806.0 190.0 L 812.0 184.0 L 816.0 184.0 L 820.0 177.0 L 820.0 161.0 L 829.0 153.0 L 829.0 149.0 L 833.0 146.0 L 833.0 141.0 L 839.0 136.0 L 839.0 133.0 L 836.0 132.0 L 830.0 125.0 L 829.0 122.0 L 819.0 119.0 L 808.0 107.0 L 795.0 102.0 L 787.0 98.0 L 781.0 91.0 L 779.0 91.0 L 774.0 85.0 L 767.0 82.0 L 763.0 79.0 L 758.0 79.0 L 749.0 76.0 Z",
      "position": {
        "x": 776.1,
        "y": 129.9
      },
      "badgeAnchor": {
        "x": 776.1,
        "y": 129.9
      },
      "adjacencies": [
        "crypt-003",
        "crypt-010",
        "crypt-012",
        "crypt-015"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-007",
      "name": "Ashen Sanctum",
      "regionId": "crown",
      "shape": "M 585.0 100.0 L 585.0 103.0 L 580.0 110.0 L 573.0 115.0 L 573.0 118.0 L 562.0 128.0 L 562.0 136.0 L 561.0 136.0 L 561.0 137.0 L 560.0 137.0 L 560.0 138.0 L 559.0 138.0 L 559.0 139.0 L 558.0 139.0 L 557.0 141.0 L 555.0 141.0 L 554.0 145.0 L 557.0 148.0 L 558.0 153.0 L 552.0 155.0 L 544.0 155.0 L 540.0 157.0 L 541.0 160.0 L 542.0 160.0 L 542.0 162.0 L 542.0 163.0 L 543.0 163.0 L 543.0 165.0 L 543.0 166.0 L 544.0 166.0 L 544.0 167.0 L 544.0 169.0 L 545.0 170.0 L 551.0 171.0 L 554.0 168.0 L 558.0 167.0 L 563.0 169.0 L 570.0 177.0 L 576.0 178.0 L 579.0 180.0 L 590.0 179.0 L 595.0 177.0 L 611.0 177.0 L 611.0 178.0 L 625.0 178.0 L 633.0 181.0 L 639.0 182.0 L 643.0 187.0 L 643.0 193.0 L 646.0 193.0 L 647.0 190.0 L 651.0 187.0 L 653.0 183.0 L 653.0 178.0 L 660.0 174.0 L 668.0 165.0 L 667.0 153.0 L 669.0 151.0 L 669.0 144.0 L 668.0 144.0 L 667.0 141.0 L 663.0 138.0 L 657.0 136.0 L 650.0 130.0 L 638.0 123.0 L 634.0 124.0 L 627.0 120.0 L 623.0 113.0 L 617.0 110.0 L 617.0 108.0 L 613.0 106.0 L 599.0 105.0 L 593.0 100.0 Z",
      "position": {
        "x": 609.5,
        "y": 149
      },
      "badgeAnchor": {
        "x": 609.5,
        "y": 149
      },
      "adjacencies": [
        "crypt-001",
        "crypt-003",
        "crypt-004",
        "crypt-010",
        "crypt-014"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-008",
      "name": "Ashen Vault",
      "regionId": "left-parietal",
      "shape": "M 185.0 150.0 L 197.0 157.0 L 199.0 160.0 L 211.0 164.0 L 223.0 177.0 L 223.0 180.0 L 232.0 183.0 L 232.0 184.0 L 244.0 184.0 L 244.0 183.0 L 255.0 183.0 L 255.0 182.0 L 265.0 182.0 L 266.0 180.0 L 273.0 179.0 L 277.0 176.0 L 280.0 166.0 L 280.0 157.0 L 284.0 152.0 L 288.0 150.0 L 291.0 150.0 L 291.0 143.0 L 287.0 139.0 L 284.0 139.0 L 281.0 129.0 L 281.0 119.0 L 279.0 118.0 L 274.0 111.0 L 265.0 105.0 L 259.0 105.0 L 253.0 98.0 L 251.0 98.0 L 246.0 103.0 L 232.0 110.0 L 231.0 112.0 L 224.0 115.0 L 212.0 128.0 L 198.0 135.0 L 186.0 148.0 L 185.0 148.0 Z",
      "position": {
        "x": 241.5,
        "y": 149.3
      },
      "badgeAnchor": {
        "x": 241.5,
        "y": 149.3
      },
      "adjacencies": [
        "crypt-005",
        "crypt-011",
        "crypt-013",
        "crypt-018"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-009",
      "name": "Ashen Shrine",
      "regionId": "nasal-ridge",
      "shape": "M 382.0 116.0 L 377.0 116.0 L 378.0 125.0 L 370.0 131.0 L 371.0 146.0 L 373.0 149.0 L 380.0 153.0 L 381.0 155.0 L 393.0 160.0 L 394.0 162.0 L 400.0 164.0 L 406.0 170.0 L 406.0 179.0 L 405.0 179.0 L 405.0 181.0 L 416.0 182.0 L 422.0 188.0 L 427.0 190.0 L 428.0 199.0 L 432.0 199.0 L 439.0 200.0 L 450.0 195.0 L 464.0 195.0 L 464.0 196.0 L 476.0 196.0 L 481.0 188.0 L 479.0 186.0 L 480.0 182.0 L 488.0 175.0 L 489.0 173.0 L 489.0 169.0 L 488.0 167.0 L 487.0 165.0 L 488.0 165.0 L 489.0 164.0 L 490.0 163.0 L 491.0 162.0 L 492.0 160.0 L 492.0 156.0 L 485.0 155.0 L 476.0 145.0 L 476.0 140.0 L 470.0 133.0 L 472.0 122.0 L 465.0 122.0 L 463.0 125.0 L 445.0 123.0 L 437.0 130.0 L 428.0 130.0 L 423.0 128.0 L 412.0 127.0 L 407.0 124.0 L 404.0 119.0 L 395.0 120.0 L 388.0 114.0 L 382.0 114.0 Z",
      "position": {
        "x": 433.7,
        "y": 166.2
      },
      "badgeAnchor": {
        "x": 433.7,
        "y": 166.2
      },
      "adjacencies": [
        "crypt-014",
        "crypt-017",
        "crypt-005"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-010",
      "name": "Ashen Tomb",
      "regionId": "crown",
      "shape": "M 709.0 119.0 L 704.0 123.0 L 704.0 125.0 L 696.0 130.0 L 686.0 133.0 L 682.0 136.0 L 676.0 143.0 L 672.0 144.0 L 669.0 144.0 L 669.0 151.0 L 667.0 153.0 L 668.0 165.0 L 660.0 174.0 L 653.0 178.0 L 653.0 183.0 L 651.0 187.0 L 647.0 190.0 L 646.0 193.0 L 645.0 193.0 L 654.0 197.0 L 657.0 197.0 L 673.0 206.0 L 677.0 207.0 L 678.0 210.0 L 687.0 214.0 L 693.0 221.0 L 693.0 220.0 L 697.0 217.0 L 710.0 218.0 L 715.0 212.0 L 725.0 211.0 L 725.0 210.0 L 739.0 210.0 L 745.0 213.0 L 762.0 213.0 L 765.0 212.0 L 768.0 207.0 L 775.0 203.0 L 786.0 190.0 L 786.0 188.0 L 779.0 181.0 L 774.0 180.0 L 770.0 177.0 L 765.0 176.0 L 751.0 163.0 L 750.0 160.0 L 742.0 158.0 L 737.0 152.0 L 727.0 146.0 L 727.0 140.0 L 721.0 135.0 L 721.0 130.0 L 719.0 129.0 L 714.0 121.0 L 711.0 119.0 Z",
      "position": {
        "x": 708.4,
        "y": 178.8
      },
      "badgeAnchor": {
        "x": 708.4,
        "y": 178.8
      },
      "adjacencies": [
        "crypt-003",
        "crypt-006",
        "crypt-007",
        "crypt-015",
        "crypt-019"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-011",
      "name": "Silent Crypt",
      "regionId": "left-parietal",
      "shape": "M 337.0 137.0 L 336.0 139.0 L 329.0 141.0 L 324.0 144.0 L 324.0 148.0 L 317.0 153.0 L 301.0 153.0 L 295.0 152.0 L 293.0 150.0 L 288.0 150.0 L 284.0 152.0 L 280.0 157.0 L 280.0 166.0 L 277.0 176.0 L 273.0 179.0 L 266.0 180.0 L 265.0 182.0 L 264.0 182.0 L 265.0 190.0 L 269.0 194.0 L 270.0 207.0 L 273.0 211.0 L 274.0 216.0 L 277.0 221.0 L 286.0 220.0 L 295.0 223.0 L 298.0 226.0 L 307.0 226.0 L 314.0 227.0 L 315.0 223.0 L 322.0 217.0 L 329.0 215.0 L 329.0 207.0 L 321.0 196.0 L 323.0 190.0 L 329.0 189.0 L 340.0 189.0 L 347.0 188.0 L 349.0 185.0 L 356.0 184.0 L 359.0 182.0 L 367.0 181.0 L 372.0 179.0 L 372.0 173.0 L 368.0 171.0 L 363.0 166.0 L 355.0 166.0 L 351.0 162.0 L 350.0 155.0 L 350.0 146.0 L 348.0 140.0 L 345.0 138.0 Z",
      "position": {
        "x": 296.8,
        "y": 183.7
      },
      "badgeAnchor": {
        "x": 296.8,
        "y": 183.7
      },
      "adjacencies": [
        "crypt-005",
        "crypt-008",
        "crypt-018"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-012",
      "name": "Silent Barrow",
      "regionId": "crown",
      "shape": "M 839.0 136.0 L 833.0 141.0 L 833.0 146.0 L 829.0 149.0 L 829.0 153.0 L 820.0 161.0 L 820.0 177.0 L 816.0 184.0 L 815.0 184.0 L 818.0 191.0 L 818.0 196.0 L 822.0 199.0 L 821.0 202.0 L 821.0 213.0 L 822.0 221.0 L 820.0 222.0 L 820.0 231.0 L 822.0 233.0 L 822.0 238.0 L 815.0 244.0 L 808.0 244.0 L 805.0 247.0 L 806.0 256.0 L 813.0 262.0 L 813.0 273.0 L 810.0 275.0 L 806.0 283.0 L 815.0 283.0 L 820.0 285.0 L 824.0 285.0 L 828.0 284.0 L 838.0 278.0 L 848.0 278.0 L 855.0 280.0 L 860.0 278.0 L 866.0 273.0 L 872.0 271.0 L 873.0 264.0 L 886.0 256.0 L 890.0 255.0 L 890.0 240.0 L 891.0 240.0 L 891.0 222.0 L 888.0 205.0 L 885.0 203.0 L 883.0 198.0 L 880.0 196.0 L 878.0 191.0 L 872.0 185.0 L 870.0 180.0 L 867.0 177.0 L 867.0 167.0 L 866.0 167.0 L 866.0 158.0 L 841.0 134.0 Z",
      "position": {
        "x": 857.9,
        "y": 215.3
      },
      "badgeAnchor": {
        "x": 857.9,
        "y": 215.3
      },
      "adjacencies": [
        "crypt-006",
        "crypt-015",
        "crypt-024",
        "crypt-026"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-013",
      "name": "Silent Ossuary",
      "regionId": "left-parietal",
      "shape": "M 98.0 267.0 L 100.0 270.0 L 108.0 272.0 L 112.0 276.0 L 134.0 276.0 L 150.0 271.0 L 162.0 271.0 L 167.0 270.0 L 167.0 269.0 L 171.0 264.0 L 172.0 257.0 L 172.0 248.0 L 179.0 240.0 L 181.0 235.0 L 186.0 229.0 L 187.0 223.0 L 191.0 216.0 L 193.0 208.0 L 205.0 197.0 L 209.0 196.0 L 223.0 181.0 L 223.0 177.0 L 211.0 164.0 L 199.0 160.0 L 197.0 157.0 L 185.0 150.0 L 154.0 180.0 L 150.0 189.0 L 148.0 190.0 L 146.0 196.0 L 138.0 207.0 L 137.0 211.0 L 129.0 219.0 L 126.0 224.0 L 123.0 232.0 L 121.0 233.0 L 119.0 239.0 L 116.0 242.0 L 114.0 250.0 L 97.0 266.0 Z",
      "position": {
        "x": 159.8,
        "y": 215.5
      },
      "badgeAnchor": {
        "x": 159.8,
        "y": 215.5
      },
      "adjacencies": [
        "crypt-008",
        "crypt-018",
        "crypt-025"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-014",
      "name": "Silent Cairn",
      "regionId": "nasal-ridge",
      "shape": "M 492.0 160.0 L 492.0 162.0 L 491.0 162.0 L 491.0 163.0 L 490.0 163.0 L 490.0 164.0 L 489.0 164.0 L 489.0 165.0 L 488.0 165.0 L 488.0 167.0 L 489.0 167.0 L 489.0 169.0 L 489.0 171.0 L 489.0 173.0 L 488.0 175.0 L 480.0 182.0 L 479.0 186.0 L 481.0 188.0 L 476.0 196.0 L 464.0 196.0 L 464.0 195.0 L 450.0 195.0 L 439.0 200.0 L 432.0 199.0 L 427.0 199.0 L 427.0 208.0 L 437.0 217.0 L 442.0 217.0 L 447.0 220.0 L 448.0 227.0 L 448.0 236.0 L 451.0 242.0 L 452.0 247.0 L 464.0 258.0 L 470.0 261.0 L 475.0 268.0 L 475.0 273.0 L 476.0 273.0 L 478.0 279.0 L 485.0 284.0 L 491.0 290.0 L 495.0 289.0 L 502.0 281.0 L 508.0 279.0 L 515.0 279.0 L 520.0 276.0 L 520.0 273.0 L 524.0 271.0 L 524.0 268.0 L 526.0 265.0 L 525.0 261.0 L 525.0 240.0 L 516.0 230.0 L 516.0 220.0 L 518.0 217.0 L 518.0 197.0 L 521.0 195.0 L 520.0 193.0 L 521.0 193.0 L 523.0 192.0 L 524.0 191.0 L 524.0 190.0 L 535.0 190.0 L 540.0 189.0 L 538.0 184.0 L 532.0 178.0 L 536.0 173.0 L 543.0 172.0 L 545.0 170.0 L 544.0 170.0 L 544.0 169.0 L 544.0 167.0 L 543.0 167.0 L 543.0 166.0 L 543.0 165.0 L 542.0 165.0 L 542.0 163.0 L 542.0 162.0 L 541.0 160.0 L 540.0 160.0 L 540.0 157.0 L 538.0 158.0 L 520.0 158.0 L 517.0 160.0 L 506.0 159.0 L 495.0 157.0 Z",
      "position": {
        "x": 476.5,
        "y": 230.6
      },
      "badgeAnchor": {
        "x": 486.56,
        "y": 231.33
      },
      "adjacencies": [
        "crypt-009",
        "crypt-016",
        "crypt-017",
        "crypt-022",
        "crypt-007"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-015",
      "name": "Silent Haven",
      "regionId": "crown",
      "shape": "M 812.0 184.0 L 806.0 190.0 L 800.0 189.0 L 786.0 189.0 L 786.0 190.0 L 775.0 203.0 L 768.0 207.0 L 765.0 212.0 L 762.0 213.0 L 745.0 213.0 L 739.0 210.0 L 725.0 210.0 L 725.0 211.0 L 715.0 212.0 L 710.0 218.0 L 697.0 217.0 L 693.0 220.0 L 693.0 223.0 L 698.0 228.0 L 699.0 232.0 L 710.0 241.0 L 716.0 248.0 L 719.0 249.0 L 721.0 254.0 L 724.0 254.0 L 724.0 255.0 L 734.0 255.0 L 738.0 258.0 L 741.0 258.0 L 745.0 261.0 L 753.0 263.0 L 755.0 265.0 L 770.0 269.0 L 779.0 275.0 L 785.0 276.0 L 785.0 277.0 L 794.0 280.0 L 796.0 282.0 L 803.0 283.0 L 806.0 283.0 L 810.0 275.0 L 813.0 273.0 L 813.0 262.0 L 806.0 256.0 L 805.0 247.0 L 808.0 244.0 L 815.0 244.0 L 822.0 238.0 L 822.0 233.0 L 820.0 231.0 L 820.0 222.0 L 822.0 221.0 L 821.0 213.0 L 821.0 202.0 L 822.0 199.0 L 818.0 196.0 L 818.0 191.0 L 815.0 184.0 Z",
      "position": {
        "x": 768,
        "y": 232.2
      },
      "badgeAnchor": {
        "x": 768,
        "y": 232.2
      },
      "adjacencies": [
        "crypt-006",
        "crypt-010",
        "crypt-012",
        "crypt-019",
        "crypt-021",
        "crypt-026"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-016",
      "name": "Silent Watch",
      "regionId": "nasal-ridge",
      "shape": "M 524.0 191.0 L 524.0 192.0 L 523.0 192.0 L 523.0 193.0 L 521.0 193.0 L 521.0 195.0 L 518.0 197.0 L 518.0 217.0 L 516.0 220.0 L 516.0 230.0 L 525.0 240.0 L 525.0 261.0 L 526.0 265.0 L 524.0 268.0 L 524.0 270.0 L 532.0 277.0 L 535.0 284.0 L 541.0 289.0 L 551.0 294.0 L 556.0 298.0 L 556.0 299.0 L 563.0 300.0 L 570.0 300.0 L 569.0 297.0 L 571.0 295.0 L 573.0 287.0 L 573.0 275.0 L 571.0 272.0 L 571.0 265.0 L 574.0 262.0 L 577.0 254.0 L 579.0 253.0 L 582.0 245.0 L 586.0 240.0 L 586.0 232.0 L 582.0 226.0 L 586.0 213.0 L 581.0 211.0 L 578.0 208.0 L 565.0 206.0 L 554.0 200.0 L 550.0 197.0 L 541.0 196.0 L 533.0 191.0 Z",
      "position": {
        "x": 541.6,
        "y": 234.8
      },
      "badgeAnchor": {
        "x": 541.6,
        "y": 234.8
      },
      "adjacencies": [
        "crypt-014",
        "crypt-022",
        "crypt-034"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-017",
      "name": "Silent Sanctum",
      "regionId": "nasal-ridge",
      "shape": "M 452.0 284.0 L 454.0 284.0 L 462.0 275.0 L 472.0 274.0 L 472.0 273.0 L 475.0 273.0 L 475.0 268.0 L 470.0 261.0 L 464.0 258.0 L 452.0 247.0 L 451.0 242.0 L 448.0 236.0 L 448.0 227.0 L 447.0 220.0 L 442.0 217.0 L 437.0 217.0 L 427.0 208.0 L 427.0 199.0 L 428.0 199.0 L 427.0 190.0 L 422.0 188.0 L 416.0 182.0 L 405.0 181.0 L 402.0 183.0 L 395.0 191.0 L 387.0 193.0 L 385.0 195.0 L 362.0 200.0 L 352.0 203.0 L 351.0 211.0 L 356.0 217.0 L 356.0 221.0 L 348.0 226.0 L 348.0 233.0 L 356.0 235.0 L 361.0 241.0 L 362.0 246.0 L 371.0 253.0 L 383.0 256.0 L 391.0 267.0 L 396.0 271.0 L 401.0 271.0 L 410.0 274.0 L 424.0 274.0 L 424.0 275.0 L 437.0 275.0 L 443.0 277.0 L 448.0 285.0 Z",
      "position": {
        "x": 402,
        "y": 236.4
      },
      "badgeAnchor": {
        "x": 402,
        "y": 236.4
      },
      "adjacencies": [
        "crypt-009",
        "crypt-014",
        "crypt-022"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-018",
      "name": "Silent Vault",
      "regionId": "left-parietal",
      "shape": "M 223.0 180.0 L 223.0 181.0 L 209.0 196.0 L 205.0 197.0 L 193.0 208.0 L 191.0 216.0 L 187.0 223.0 L 186.0 229.0 L 181.0 235.0 L 179.0 240.0 L 172.0 248.0 L 172.0 257.0 L 171.0 264.0 L 167.0 269.0 L 167.0 271.0 L 170.0 276.0 L 170.0 280.0 L 173.0 282.0 L 173.0 291.0 L 176.0 299.0 L 182.0 299.0 L 184.0 300.0 L 192.0 309.0 L 202.0 315.0 L 204.0 318.0 L 228.0 329.0 L 231.0 329.0 L 238.0 323.0 L 238.0 314.0 L 235.0 310.0 L 235.0 302.0 L 237.0 300.0 L 237.0 291.0 L 233.0 288.0 L 230.0 283.0 L 231.0 274.0 L 238.0 268.0 L 240.0 262.0 L 244.0 259.0 L 245.0 253.0 L 247.0 251.0 L 250.0 238.0 L 260.0 232.0 L 270.0 231.0 L 271.0 225.0 L 277.0 221.0 L 274.0 216.0 L 273.0 211.0 L 270.0 207.0 L 269.0 194.0 L 265.0 190.0 L 264.0 182.0 L 255.0 182.0 L 255.0 183.0 L 244.0 183.0 L 244.0 184.0 L 232.0 184.0 L 232.0 183.0 Z",
      "position": {
        "x": 213.8,
        "y": 239.1
      },
      "badgeAnchor": {
        "x": 213.8,
        "y": 239.1
      },
      "adjacencies": [
        "crypt-008",
        "crypt-011",
        "crypt-013",
        "crypt-025",
        "crypt-029"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-019",
      "name": "Silent Shrine",
      "regionId": "right-lacrimal",
      "shape": "M 643.0 193.0 L 642.0 196.0 L 637.0 200.0 L 625.0 200.0 L 619.0 214.0 L 610.0 222.0 L 610.0 229.0 L 614.0 232.0 L 614.0 240.0 L 606.0 250.0 L 605.0 254.0 L 597.0 264.0 L 597.0 276.0 L 596.0 276.0 L 596.0 288.0 L 593.0 296.0 L 600.0 297.0 L 601.0 298.0 L 602.0 299.0 L 603.0 300.0 L 604.0 301.0 L 607.0 302.0 L 610.0 304.0 L 618.0 304.0 L 624.0 306.0 L 624.0 305.0 L 632.0 300.0 L 633.0 294.0 L 640.0 288.0 L 641.0 278.0 L 644.0 274.0 L 652.0 267.0 L 657.0 265.0 L 659.0 262.0 L 664.0 260.0 L 689.0 260.0 L 701.0 264.0 L 703.0 264.0 L 705.0 261.0 L 711.0 260.0 L 718.0 257.0 L 720.0 254.0 L 721.0 254.0 L 719.0 249.0 L 716.0 248.0 L 710.0 241.0 L 699.0 232.0 L 698.0 228.0 L 693.0 223.0 L 693.0 221.0 L 687.0 214.0 L 678.0 210.0 L 677.0 207.0 L 673.0 206.0 L 657.0 197.0 L 654.0 197.0 L 645.0 193.0 Z",
      "position": {
        "x": 650.9,
        "y": 245.2
      },
      "badgeAnchor": {
        "x": 646.38,
        "y": 234.81
      },
      "adjacencies": [
        "crypt-010",
        "crypt-015",
        "crypt-020",
        "crypt-021",
        "crypt-027"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-020",
      "name": "Silent Tomb",
      "regionId": "right-lacrimal",
      "shape": "M 624.0 305.0 L 624.0 308.0 L 628.0 314.0 L 635.0 315.0 L 638.0 318.0 L 649.0 324.0 L 655.0 324.0 L 664.0 330.0 L 666.0 330.0 L 670.0 335.0 L 672.0 335.0 L 678.0 333.0 L 684.0 333.0 L 693.0 327.0 L 693.0 326.0 L 704.0 316.0 L 705.0 308.0 L 697.0 303.0 L 693.0 298.0 L 695.0 297.0 L 695.0 286.0 L 691.0 283.0 L 691.0 275.0 L 702.0 265.0 L 702.0 264.0 L 701.0 264.0 L 689.0 260.0 L 664.0 260.0 L 659.0 262.0 L 657.0 265.0 L 652.0 267.0 L 644.0 274.0 L 641.0 278.0 L 640.0 288.0 L 633.0 294.0 L 632.0 300.0 Z",
      "position": {
        "x": 667.8,
        "y": 298.6
      },
      "badgeAnchor": {
        "x": 667.8,
        "y": 298.6
      },
      "adjacencies": [
        "crypt-019",
        "crypt-021",
        "crypt-027",
        "crypt-030"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-021",
      "name": "Forgotten Crypt",
      "regionId": "right-parietal",
      "shape": "M 720.0 254.0 L 718.0 257.0 L 711.0 260.0 L 705.0 261.0 L 703.0 264.0 L 702.0 264.0 L 702.0 265.0 L 691.0 275.0 L 691.0 283.0 L 695.0 286.0 L 695.0 297.0 L 693.0 298.0 L 697.0 303.0 L 705.0 308.0 L 704.0 316.0 L 693.0 326.0 L 693.0 328.0 L 701.0 334.0 L 701.0 339.0 L 709.0 345.0 L 723.0 348.0 L 726.0 350.0 L 734.0 350.0 L 743.0 352.0 L 743.0 353.0 L 745.0 349.0 L 750.0 346.0 L 757.0 337.0 L 766.0 330.0 L 766.0 328.0 L 772.0 323.0 L 773.0 318.0 L 780.0 312.0 L 782.0 307.0 L 782.0 294.0 L 781.0 294.0 L 781.0 284.0 L 785.0 278.0 L 785.0 276.0 L 779.0 275.0 L 770.0 269.0 L 755.0 265.0 L 753.0 263.0 L 745.0 261.0 L 741.0 258.0 L 738.0 258.0 L 734.0 255.0 L 724.0 255.0 L 724.0 254.0 Z",
      "position": {
        "x": 736.4,
        "y": 298.7
      },
      "badgeAnchor": {
        "x": 736.4,
        "y": 298.7
      },
      "adjacencies": [
        "crypt-015",
        "crypt-019",
        "crypt-020",
        "crypt-026",
        "crypt-030"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-022",
      "name": "Forgotten Barrow",
      "regionId": "nasal-ridge",
      "shape": "M 524.0 270.0 L 524.0 271.0 L 520.0 273.0 L 520.0 276.0 L 515.0 279.0 L 508.0 279.0 L 502.0 281.0 L 495.0 289.0 L 491.0 290.0 L 485.0 284.0 L 478.0 279.0 L 476.0 273.0 L 472.0 273.0 L 472.0 274.0 L 462.0 275.0 L 454.0 284.0 L 452.0 284.0 L 446.0 303.0 L 438.0 310.0 L 437.0 315.0 L 434.0 321.0 L 427.0 327.0 L 427.0 334.0 L 437.0 342.0 L 445.0 343.0 L 449.0 348.0 L 451.0 348.0 L 456.0 354.0 L 459.0 354.0 L 464.0 350.0 L 478.0 346.0 L 487.0 336.0 L 492.0 334.0 L 499.0 328.0 L 507.0 327.0 L 513.0 331.0 L 516.0 335.0 L 521.0 335.0 L 531.0 335.0 L 533.0 332.0 L 536.0 321.0 L 541.0 317.0 L 542.0 308.0 L 545.0 305.0 L 550.0 304.0 L 556.0 300.0 L 556.0 298.0 L 551.0 294.0 L 541.0 289.0 L 535.0 284.0 L 532.0 277.0 Z",
      "position": {
        "x": 474,
        "y": 309.5
      },
      "badgeAnchor": {
        "x": 497.85,
        "y": 306.98
      },
      "adjacencies": [
        "crypt-014",
        "crypt-016",
        "crypt-017",
        "crypt-032",
        "crypt-034"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-023",
      "name": "Forgotten Ossuary",
      "regionId": "left-orbital",
      "shape": "M 252.0 346.0 L 255.0 350.0 L 259.0 351.0 L 261.0 355.0 L 261.0 361.0 L 265.0 368.0 L 265.0 372.0 L 273.0 370.0 L 281.0 370.0 L 289.0 373.0 L 293.0 377.0 L 301.0 378.0 L 304.0 382.0 L 311.0 385.0 L 314.0 389.0 L 316.0 389.0 L 321.0 383.0 L 323.0 376.0 L 326.0 374.0 L 326.0 367.0 L 334.0 360.0 L 336.0 342.0 L 337.0 338.0 L 343.0 333.0 L 343.0 328.0 L 350.0 325.0 L 354.0 321.0 L 358.0 320.0 L 362.0 316.0 L 366.0 315.0 L 373.0 309.0 L 377.0 308.0 L 381.0 304.0 L 385.0 303.0 L 389.0 299.0 L 393.0 298.0 L 402.0 291.0 L 393.0 290.0 L 379.0 287.0 L 373.0 281.0 L 372.0 275.0 L 366.0 270.0 L 362.0 269.0 L 353.0 258.0 L 342.0 248.0 L 330.0 249.0 L 327.0 246.0 L 316.0 246.0 L 311.0 245.0 L 303.0 251.0 L 294.0 251.0 L 292.0 249.0 L 285.0 249.0 L 281.0 253.0 L 274.0 254.0 L 264.0 263.0 L 264.0 270.0 L 262.0 276.0 L 254.0 283.0 L 254.0 289.0 L 258.0 293.0 L 258.0 303.0 L 257.0 306.0 L 263.0 309.0 L 267.0 314.0 L 267.0 324.0 L 266.0 326.0 L 257.0 334.0 L 256.0 342.0 Z",
      "position": {
        "x": 299,
        "y": 311.6
      },
      "badgeAnchor": {
        "x": 315.01,
        "y": 312.15
      },
      "adjacencies": [
        "crypt-028",
        "crypt-029",
        "crypt-038"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-024",
      "name": "Forgotten Cairn",
      "regionId": "right-parietal",
      "shape": "M 824.0 285.0 L 823.0 285.0 L 823.0 299.0 L 830.0 311.0 L 832.0 312.0 L 836.0 329.0 L 838.0 332.0 L 838.0 346.0 L 837.0 349.0 L 833.0 352.0 L 833.0 358.0 L 835.0 361.0 L 835.0 363.0 L 842.0 363.0 L 848.0 369.0 L 856.0 372.0 L 864.0 373.0 L 884.0 373.0 L 889.0 369.0 L 896.0 360.0 L 908.0 353.0 L 916.0 352.0 L 916.0 351.0 L 921.0 347.0 L 937.0 340.0 L 948.0 328.0 L 958.0 325.0 L 961.0 321.0 L 961.0 317.0 L 957.0 316.0 L 952.0 310.0 L 952.0 298.0 L 945.0 293.0 L 943.0 293.0 L 929.0 278.0 L 919.0 277.0 L 911.0 278.0 L 900.0 284.0 L 892.0 285.0 L 880.0 282.0 L 872.0 273.0 L 872.0 271.0 L 866.0 273.0 L 860.0 278.0 L 855.0 280.0 L 848.0 278.0 L 838.0 278.0 L 828.0 284.0 Z",
      "position": {
        "x": 881,
        "y": 317.8
      },
      "badgeAnchor": {
        "x": 881,
        "y": 317.8
      },
      "adjacencies": [
        "crypt-012",
        "crypt-026",
        "crypt-031",
        "crypt-033"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-025",
      "name": "Forgotten Haven",
      "regionId": "left-parietal",
      "shape": "M 63.0 394.0 L 73.0 396.0 L 79.0 399.0 L 90.0 399.0 L 93.0 396.0 L 99.0 394.0 L 105.0 389.0 L 117.0 387.0 L 122.0 383.0 L 129.0 383.0 L 131.0 380.0 L 131.0 362.0 L 132.0 357.0 L 135.0 352.0 L 141.0 347.0 L 141.0 345.0 L 148.0 339.0 L 147.0 329.0 L 149.0 325.0 L 175.0 300.0 L 175.0 299.0 L 176.0 299.0 L 173.0 291.0 L 173.0 282.0 L 170.0 280.0 L 170.0 276.0 L 167.0 271.0 L 167.0 270.0 L 162.0 271.0 L 150.0 271.0 L 134.0 276.0 L 112.0 276.0 L 108.0 272.0 L 100.0 270.0 L 98.0 267.0 L 90.0 272.0 L 89.0 283.0 L 86.0 292.0 L 74.0 303.0 L 74.0 312.0 L 76.0 314.0 L 76.0 321.0 L 74.0 325.0 L 69.0 330.0 L 69.0 346.0 L 68.0 346.0 L 68.0 362.0 L 65.0 365.0 L 65.0 377.0 L 66.0 377.0 L 66.0 389.0 Z",
      "position": {
        "x": 104.9,
        "y": 326.5
      },
      "badgeAnchor": {
        "x": 104.9,
        "y": 326.5
      },
      "adjacencies": [
        "crypt-013",
        "crypt-018",
        "crypt-029",
        "crypt-037"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-026",
      "name": "Forgotten Watch",
      "regionId": "right-parietal",
      "shape": "M 785.0 277.0 L 785.0 278.0 L 781.0 284.0 L 781.0 294.0 L 782.0 294.0 L 782.0 307.0 L 780.0 312.0 L 773.0 318.0 L 772.0 323.0 L 766.0 328.0 L 766.0 330.0 L 757.0 337.0 L 750.0 346.0 L 745.0 349.0 L 743.0 353.0 L 743.0 355.0 L 742.0 358.0 L 745.0 362.0 L 758.0 374.0 L 761.0 374.0 L 761.0 373.0 L 770.0 373.0 L 770.0 374.0 L 782.0 374.0 L 782.0 373.0 L 793.0 373.0 L 804.0 378.0 L 812.0 380.0 L 816.0 384.0 L 823.0 385.0 L 823.0 384.0 L 825.0 380.0 L 829.0 377.0 L 831.0 370.0 L 835.0 364.0 L 835.0 361.0 L 833.0 358.0 L 833.0 352.0 L 837.0 349.0 L 838.0 346.0 L 838.0 332.0 L 836.0 329.0 L 832.0 312.0 L 830.0 311.0 L 823.0 299.0 L 823.0 285.0 L 820.0 285.0 L 815.0 283.0 L 803.0 283.0 L 796.0 282.0 L 794.0 280.0 Z",
      "position": {
        "x": 797.8,
        "y": 339
      },
      "badgeAnchor": {
        "x": 797.8,
        "y": 339
      },
      "adjacencies": [
        "crypt-012",
        "crypt-015",
        "crypt-021",
        "crypt-024",
        "crypt-030",
        "crypt-033",
        "crypt-035"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-027",
      "name": "Forgotten Sanctum",
      "regionId": "right-lacrimal",
      "shape": "M 644.0 400.0 L 647.0 396.0 L 655.0 392.0 L 659.0 387.0 L 659.0 386.0 L 658.0 383.0 L 650.0 376.0 L 649.0 371.0 L 645.0 366.0 L 645.0 358.0 L 649.0 356.0 L 651.0 352.0 L 651.0 346.0 L 659.0 341.0 L 660.0 339.0 L 668.0 335.0 L 670.0 335.0 L 666.0 330.0 L 664.0 330.0 L 655.0 324.0 L 649.0 324.0 L 638.0 318.0 L 635.0 315.0 L 628.0 314.0 L 624.0 308.0 L 624.0 306.0 L 618.0 304.0 L 610.0 304.0 L 607.0 302.0 L 604.0 302.0 L 604.0 301.0 L 603.0 301.0 L 603.0 300.0 L 602.0 300.0 L 602.0 299.0 L 601.0 299.0 L 601.0 298.0 L 600.0 298.0 L 600.0 297.0 L 593.0 297.0 L 591.0 299.0 L 593.0 315.0 L 590.0 320.0 L 590.0 331.0 L 595.0 339.0 L 595.0 342.0 L 599.0 348.0 L 596.0 355.0 L 594.0 356.0 L 594.0 364.0 L 604.0 373.0 L 607.0 379.0 L 611.0 382.0 L 614.0 388.0 L 618.0 391.0 L 621.0 397.0 L 625.0 400.0 L 628.0 405.0 L 635.0 405.0 L 641.0 398.0 L 642.0 400.0 Z",
      "position": {
        "x": 623.3,
        "y": 343.8
      },
      "badgeAnchor": {
        "x": 623.3,
        "y": 343.8
      },
      "adjacencies": [
        "crypt-019",
        "crypt-020",
        "crypt-030",
        "crypt-036"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-028",
      "name": "Forgotten Vault",
      "regionId": "left-orbital",
      "shape": "M 402.0 291.0 L 393.0 298.0 L 389.0 299.0 L 385.0 303.0 L 381.0 304.0 L 377.0 308.0 L 373.0 309.0 L 366.0 315.0 L 362.0 316.0 L 358.0 320.0 L 354.0 321.0 L 350.0 325.0 L 343.0 328.0 L 343.0 333.0 L 337.0 338.0 L 336.0 342.0 L 334.0 360.0 L 326.0 367.0 L 326.0 374.0 L 323.0 376.0 L 321.0 383.0 L 316.0 389.0 L 317.0 389.0 L 317.0 391.0 L 322.0 395.0 L 324.0 404.0 L 326.0 408.0 L 331.0 413.0 L 332.0 417.0 L 337.0 421.0 L 339.0 425.0 L 339.0 426.0 L 349.0 425.0 L 351.0 422.0 L 375.0 415.0 L 383.0 414.0 L 386.0 410.0 L 391.0 410.0 L 398.0 412.0 L 404.0 415.0 L 407.0 414.0 L 410.0 413.0 L 410.0 414.0 L 415.0 414.0 L 418.0 394.0 L 413.0 388.0 L 413.0 373.0 L 424.0 363.0 L 424.0 356.0 L 414.0 350.0 L 400.0 335.0 L 399.0 325.0 L 400.0 318.0 L 407.0 312.0 L 413.0 310.0 L 419.0 301.0 L 419.0 294.0 L 410.0 294.0 L 406.0 291.0 Z",
      "position": {
        "x": 367.4,
        "y": 367.3
      },
      "badgeAnchor": {
        "x": 367.4,
        "y": 367.3
      },
      "adjacencies": [
        "crypt-023",
        "crypt-038",
        "crypt-040"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-029",
      "name": "Forgotten Shrine",
      "regionId": "left-parietal",
      "shape": "M 175.0 299.0 L 175.0 300.0 L 149.0 325.0 L 147.0 329.0 L 148.0 339.0 L 141.0 345.0 L 141.0 347.0 L 135.0 352.0 L 132.0 357.0 L 131.0 362.0 L 131.0 380.0 L 129.0 383.0 L 130.0 383.0 L 131.0 387.0 L 149.0 404.0 L 159.0 410.0 L 158.0 420.0 L 163.0 427.0 L 164.0 431.0 L 169.0 436.0 L 170.0 441.0 L 171.0 441.0 L 173.0 439.0 L 202.0 439.0 L 202.0 438.0 L 213.0 438.0 L 227.0 430.0 L 233.0 425.0 L 247.0 425.0 L 252.0 424.0 L 258.0 415.0 L 260.0 414.0 L 262.0 408.0 L 264.0 407.0 L 268.0 395.0 L 268.0 379.0 L 265.0 373.0 L 265.0 368.0 L 261.0 361.0 L 261.0 355.0 L 259.0 351.0 L 255.0 350.0 L 252.0 346.0 L 242.0 346.0 L 233.0 343.0 L 229.0 338.0 L 228.0 329.0 L 204.0 318.0 L 202.0 315.0 L 192.0 309.0 L 184.0 300.0 L 182.0 299.0 Z",
      "position": {
        "x": 177.2,
        "y": 383.5
      },
      "badgeAnchor": {
        "x": 177.2,
        "y": 383.5
      },
      "adjacencies": [
        "crypt-018",
        "crypt-023",
        "crypt-025",
        "crypt-037",
        "crypt-038",
        "crypt-041"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-030",
      "name": "Forgotten Tomb",
      "regionId": "right-parietal",
      "shape": "M 672.0 335.0 L 668.0 335.0 L 660.0 339.0 L 659.0 341.0 L 651.0 346.0 L 651.0 352.0 L 649.0 356.0 L 645.0 358.0 L 645.0 366.0 L 649.0 371.0 L 650.0 376.0 L 658.0 383.0 L 659.0 386.0 L 659.0 388.0 L 666.0 389.0 L 672.0 388.0 L 678.0 394.0 L 692.0 397.0 L 703.0 405.0 L 708.0 407.0 L 718.0 418.0 L 719.0 423.0 L 716.0 425.0 L 716.0 432.0 L 718.0 433.0 L 720.0 439.0 L 725.0 445.0 L 727.0 451.0 L 730.0 454.0 L 730.0 460.0 L 732.0 463.0 L 732.0 464.0 L 739.0 464.0 L 769.0 471.0 L 775.0 471.0 L 779.0 468.0 L 782.0 468.0 L 788.0 461.0 L 792.0 459.0 L 792.0 456.0 L 786.0 452.0 L 780.0 444.0 L 775.0 439.0 L 771.0 439.0 L 765.0 431.0 L 763.0 420.0 L 761.0 414.0 L 754.0 407.0 L 754.0 392.0 L 758.0 383.0 L 759.0 374.0 L 758.0 374.0 L 745.0 362.0 L 742.0 358.0 L 743.0 355.0 L 743.0 352.0 L 734.0 350.0 L 726.0 350.0 L 723.0 348.0 L 709.0 345.0 L 701.0 339.0 L 701.0 334.0 L 693.0 328.0 L 693.0 327.0 L 684.0 333.0 L 678.0 333.0 Z",
      "position": {
        "x": 722.7,
        "y": 388.6
      },
      "badgeAnchor": {
        "x": 722.7,
        "y": 388.6
      },
      "adjacencies": [
        "crypt-020",
        "crypt-021",
        "crypt-026",
        "crypt-027",
        "crypt-035",
        "crypt-036",
        "crypt-043",
        "crypt-044"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-031",
      "name": "Hollow Crypt",
      "regionId": "right-parietal",
      "shape": "M 961.0 317.0 L 961.0 321.0 L 958.0 325.0 L 948.0 328.0 L 937.0 340.0 L 921.0 347.0 L 916.0 351.0 L 916.0 354.0 L 919.0 357.0 L 919.0 362.0 L 924.0 368.0 L 920.0 386.0 L 916.0 390.0 L 916.0 395.0 L 918.0 397.0 L 918.0 399.0 L 926.0 399.0 L 929.0 402.0 L 938.0 406.0 L 939.0 410.0 L 944.0 413.0 L 947.0 417.0 L 948.0 427.0 L 951.0 435.0 L 958.0 441.0 L 958.0 442.0 L 965.0 442.0 L 971.0 445.0 L 978.0 446.0 L 984.0 452.0 L 993.0 455.0 L 1002.0 456.0 L 1001.0 453.0 L 1001.0 440.0 L 1000.0 440.0 L 1000.0 428.0 L 999.0 428.0 L 999.0 415.0 L 998.0 415.0 L 998.0 403.0 L 997.0 403.0 L 997.0 390.0 L 996.0 382.0 L 989.0 359.0 L 986.0 343.0 L 984.0 336.0 L 973.0 316.0 L 971.0 314.0 L 968.0 317.0 Z",
      "position": {
        "x": 956.2,
        "y": 390.2
      },
      "badgeAnchor": {
        "x": 956.2,
        "y": 390.2
      },
      "adjacencies": [
        "crypt-024",
        "crypt-033",
        "crypt-039",
        "crypt-045"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-032",
      "name": "Hollow Barrow",
      "regionId": "nasal-ridge",
      "shape": "M 459.0 354.0 L 459.0 364.0 L 458.0 366.0 L 446.0 377.0 L 436.0 382.0 L 436.0 390.0 L 438.0 396.0 L 444.0 402.0 L 444.0 423.0 L 448.0 429.0 L 450.0 436.0 L 457.0 441.0 L 465.0 444.0 L 468.0 447.0 L 486.0 450.0 L 494.0 452.0 L 502.0 461.0 L 503.0 461.0 L 504.0 460.0 L 505.0 459.0 L 506.0 458.0 L 507.0 457.0 L 508.0 456.0 L 509.0 455.0 L 510.0 454.0 L 517.0 451.0 L 524.0 444.0 L 525.0 442.0 L 526.0 441.0 L 527.0 440.0 L 528.0 439.0 L 529.0 437.0 L 530.0 437.0 L 530.0 434.0 L 533.0 430.0 L 533.0 427.0 L 536.0 421.0 L 538.0 420.0 L 538.0 414.0 L 541.0 412.0 L 541.0 407.0 L 534.0 397.0 L 533.0 392.0 L 533.0 380.0 L 534.0 380.0 L 534.0 369.0 L 535.0 369.0 L 535.0 360.0 L 534.0 353.0 L 532.0 350.0 L 532.0 338.0 L 530.0 335.0 L 521.0 335.0 L 516.0 335.0 L 513.0 331.0 L 507.0 327.0 L 499.0 328.0 L 492.0 334.0 L 487.0 336.0 L 478.0 346.0 L 464.0 350.0 Z",
      "position": {
        "x": 489,
        "y": 401.1
      },
      "badgeAnchor": {
        "x": 491.96,
        "y": 392.83
      },
      "adjacencies": [
        "crypt-022",
        "crypt-034"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-033",
      "name": "Hollow Ossuary",
      "regionId": "right-parietal",
      "shape": "M 835.0 363.0 L 835.0 364.0 L 831.0 370.0 L 829.0 377.0 L 825.0 380.0 L 823.0 384.0 L 823.0 386.0 L 825.0 388.0 L 825.0 399.0 L 822.0 406.0 L 822.0 417.0 L 823.0 419.0 L 840.0 435.0 L 846.0 436.0 L 850.0 439.0 L 852.0 439.0 L 856.0 436.0 L 863.0 434.0 L 870.0 434.0 L 878.0 429.0 L 892.0 426.0 L 903.0 418.0 L 907.0 417.0 L 916.0 407.0 L 918.0 402.0 L 918.0 397.0 L 916.0 395.0 L 916.0 390.0 L 920.0 386.0 L 924.0 368.0 L 919.0 362.0 L 919.0 357.0 L 916.0 354.0 L 916.0 352.0 L 908.0 353.0 L 896.0 360.0 L 889.0 369.0 L 884.0 373.0 L 864.0 373.0 L 856.0 372.0 L 848.0 369.0 L 842.0 363.0 Z",
      "position": {
        "x": 857.6,
        "y": 405.4
      },
      "badgeAnchor": {
        "x": 872.33,
        "y": 403.35
      },
      "adjacencies": [
        "crypt-024",
        "crypt-026",
        "crypt-031",
        "crypt-035",
        "crypt-039"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-034",
      "name": "Hollow Cairn",
      "regionId": "nasal-ridge",
      "shape": "M 556.0 299.0 L 556.0 300.0 L 550.0 304.0 L 545.0 305.0 L 542.0 308.0 L 541.0 317.0 L 536.0 321.0 L 533.0 332.0 L 531.0 335.0 L 530.0 335.0 L 532.0 338.0 L 532.0 350.0 L 534.0 353.0 L 535.0 360.0 L 535.0 369.0 L 534.0 369.0 L 534.0 380.0 L 533.0 380.0 L 533.0 392.0 L 534.0 397.0 L 541.0 407.0 L 541.0 412.0 L 538.0 414.0 L 538.0 420.0 L 536.0 421.0 L 533.0 427.0 L 533.0 432.0 L 530.0 437.0 L 529.0 437.0 L 529.0 439.0 L 528.0 439.0 L 528.0 440.0 L 527.0 440.0 L 527.0 441.0 L 526.0 441.0 L 526.0 442.0 L 525.0 442.0 L 525.0 444.0 L 524.0 444.0 L 523.0 449.0 L 528.0 452.0 L 533.0 452.0 L 534.0 451.0 L 535.0 451.0 L 536.0 451.0 L 540.0 452.0 L 544.0 457.0 L 548.0 459.0 L 566.0 459.0 L 573.0 466.0 L 578.0 467.0 L 584.0 474.0 L 592.0 476.0 L 592.0 474.0 L 598.0 466.0 L 599.0 461.0 L 599.0 457.0 L 607.0 445.0 L 607.0 443.0 L 613.0 437.0 L 607.0 431.0 L 612.0 427.0 L 612.0 416.0 L 592.0 397.0 L 590.0 391.0 L 586.0 386.0 L 585.0 375.0 L 582.0 369.0 L 573.0 361.0 L 573.0 338.0 L 572.0 338.0 L 572.0 310.0 L 571.0 302.0 L 569.0 300.0 L 563.0 300.0 Z",
      "position": {
        "x": 565.1,
        "y": 423
      },
      "badgeAnchor": {
        "x": 564.65,
        "y": 411.53
      },
      "adjacencies": [
        "crypt-016",
        "crypt-022",
        "crypt-032",
        "crypt-036",
        "crypt-042",
        "crypt-047"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-035",
      "name": "Hollow Haven",
      "regionId": "right-parietal",
      "shape": "M 761.0 374.0 L 759.0 374.0 L 758.0 383.0 L 754.0 392.0 L 754.0 407.0 L 761.0 414.0 L 763.0 420.0 L 765.0 431.0 L 771.0 439.0 L 775.0 439.0 L 780.0 444.0 L 786.0 452.0 L 792.0 456.0 L 792.0 458.0 L 794.0 458.0 L 802.0 470.0 L 809.0 471.0 L 819.0 471.0 L 827.0 477.0 L 838.0 477.0 L 838.0 476.0 L 840.0 476.0 L 841.0 474.0 L 841.0 464.0 L 844.0 462.0 L 844.0 450.0 L 850.0 446.0 L 851.0 439.0 L 850.0 439.0 L 846.0 436.0 L 840.0 435.0 L 823.0 419.0 L 822.0 417.0 L 822.0 406.0 L 825.0 399.0 L 825.0 388.0 L 823.0 386.0 L 823.0 385.0 L 816.0 384.0 L 812.0 380.0 L 804.0 378.0 L 793.0 373.0 L 782.0 373.0 L 782.0 374.0 L 770.0 374.0 L 770.0 373.0 L 761.0 373.0 Z",
      "position": {
        "x": 793.9,
        "y": 424.2
      },
      "badgeAnchor": {
        "x": 793.9,
        "y": 424.2
      },
      "adjacencies": [
        "crypt-026",
        "crypt-030",
        "crypt-033",
        "crypt-039",
        "crypt-044"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-036",
      "name": "Hollow Watch",
      "regionId": "right-parietal",
      "shape": "M 644.0 400.0 L 643.0 403.0 L 638.0 406.0 L 632.0 413.0 L 633.0 421.0 L 633.0 430.0 L 625.0 438.0 L 620.0 439.0 L 613.0 437.0 L 607.0 443.0 L 607.0 445.0 L 599.0 457.0 L 599.0 459.0 L 607.0 465.0 L 612.0 471.0 L 614.0 471.0 L 619.0 477.0 L 623.0 475.0 L 633.0 474.0 L 639.0 469.0 L 658.0 467.0 L 660.0 469.0 L 667.0 469.0 L 670.0 467.0 L 683.0 467.0 L 683.0 468.0 L 697.0 468.0 L 705.0 472.0 L 706.0 477.0 L 709.0 479.0 L 709.0 478.0 L 713.0 478.0 L 717.0 473.0 L 727.0 472.0 L 732.0 465.0 L 732.0 463.0 L 730.0 460.0 L 730.0 454.0 L 727.0 451.0 L 725.0 445.0 L 720.0 439.0 L 718.0 433.0 L 716.0 432.0 L 716.0 425.0 L 719.0 423.0 L 718.0 418.0 L 708.0 407.0 L 703.0 405.0 L 692.0 397.0 L 678.0 394.0 L 672.0 388.0 L 666.0 389.0 L 659.0 388.0 L 659.0 387.0 L 655.0 392.0 L 647.0 396.0 Z",
      "position": {
        "x": 667.9,
        "y": 433.4
      },
      "badgeAnchor": {
        "x": 667.9,
        "y": 433.4
      },
      "adjacencies": [
        "crypt-027",
        "crypt-030",
        "crypt-034",
        "crypt-042",
        "crypt-043"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-037",
      "name": "Hollow Sanctum",
      "regionId": "left-parietal",
      "shape": "M 122.0 383.0 L 117.0 387.0 L 105.0 389.0 L 99.0 394.0 L 93.0 396.0 L 90.0 399.0 L 79.0 399.0 L 73.0 396.0 L 63.0 394.0 L 60.0 400.0 L 59.0 405.0 L 59.0 449.0 L 60.0 449.0 L 60.0 492.0 L 62.0 496.0 L 66.0 493.0 L 73.0 492.0 L 83.0 492.0 L 83.0 493.0 L 97.0 493.0 L 101.0 490.0 L 109.0 489.0 L 113.0 486.0 L 119.0 478.0 L 125.0 473.0 L 125.0 471.0 L 133.0 467.0 L 143.0 455.0 L 148.0 452.0 L 152.0 452.0 L 156.0 448.0 L 160.0 447.0 L 167.0 441.0 L 170.0 441.0 L 169.0 436.0 L 164.0 431.0 L 163.0 427.0 L 158.0 420.0 L 159.0 410.0 L 149.0 404.0 L 131.0 387.0 L 130.0 383.0 Z",
      "position": {
        "x": 98.6,
        "y": 439.6
      },
      "badgeAnchor": {
        "x": 98.6,
        "y": 439.6
      },
      "adjacencies": [
        "crypt-025",
        "crypt-029",
        "crypt-041",
        "crypt-051"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-038",
      "name": "Hollow Vault",
      "regionId": "left-orbital",
      "shape": "M 265.0 372.0 L 265.0 373.0 L 268.0 379.0 L 268.0 395.0 L 264.0 407.0 L 262.0 408.0 L 260.0 414.0 L 258.0 415.0 L 252.0 424.0 L 247.0 425.0 L 233.0 425.0 L 227.0 430.0 L 213.0 438.0 L 204.0 438.0 L 210.0 446.0 L 212.0 446.0 L 218.0 453.0 L 224.0 454.0 L 227.0 461.0 L 230.0 464.0 L 231.0 469.0 L 234.0 473.0 L 244.0 481.0 L 245.0 483.0 L 245.0 485.0 L 256.0 485.0 L 256.0 486.0 L 268.0 486.0 L 273.0 488.0 L 284.0 488.0 L 284.0 489.0 L 294.0 489.0 L 300.0 491.0 L 300.0 489.0 L 303.0 487.0 L 303.0 484.0 L 306.0 482.0 L 306.0 470.0 L 307.0 468.0 L 315.0 464.0 L 328.0 450.0 L 328.0 442.0 L 331.0 439.0 L 334.0 439.0 L 338.0 436.0 L 338.0 427.0 L 339.0 427.0 L 339.0 425.0 L 337.0 421.0 L 332.0 417.0 L 331.0 413.0 L 326.0 408.0 L 324.0 404.0 L 322.0 395.0 L 317.0 391.0 L 317.0 389.0 L 314.0 389.0 L 311.0 385.0 L 304.0 382.0 L 301.0 378.0 L 293.0 377.0 L 289.0 373.0 L 281.0 370.0 L 273.0 370.0 Z",
      "position": {
        "x": 281.7,
        "y": 445.6
      },
      "badgeAnchor": {
        "x": 281.7,
        "y": 445.6
      },
      "adjacencies": [
        "crypt-023",
        "crypt-028",
        "crypt-029",
        "crypt-040",
        "crypt-041",
        "crypt-048"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-039",
      "name": "Hollow Shrine",
      "regionId": "right-parietal",
      "shape": "M 918.0 399.0 L 918.0 402.0 L 916.0 407.0 L 907.0 417.0 L 903.0 418.0 L 892.0 426.0 L 878.0 429.0 L 870.0 434.0 L 863.0 434.0 L 856.0 436.0 L 852.0 439.0 L 851.0 439.0 L 850.0 446.0 L 844.0 450.0 L 844.0 462.0 L 841.0 464.0 L 841.0 474.0 L 840.0 476.0 L 841.0 476.0 L 843.0 479.0 L 849.0 483.0 L 850.0 493.0 L 853.0 497.0 L 853.0 501.0 L 856.0 507.0 L 864.0 507.0 L 871.0 513.0 L 877.0 513.0 L 893.0 522.0 L 896.0 523.0 L 906.0 523.0 L 906.0 522.0 L 915.0 522.0 L 919.0 523.0 L 926.0 528.0 L 926.0 526.0 L 929.0 522.0 L 929.0 509.0 L 930.0 504.0 L 928.0 503.0 L 928.0 496.0 L 930.0 495.0 L 932.0 489.0 L 935.0 486.0 L 935.0 472.0 L 934.0 465.0 L 935.0 462.0 L 941.0 461.0 L 942.0 458.0 L 950.0 451.0 L 953.0 451.0 L 958.0 445.0 L 958.0 441.0 L 951.0 435.0 L 948.0 427.0 L 947.0 417.0 L 944.0 413.0 L 939.0 410.0 L 938.0 406.0 L 929.0 402.0 L 926.0 399.0 Z",
      "position": {
        "x": 895.8,
        "y": 467.7
      },
      "badgeAnchor": {
        "x": 895.8,
        "y": 467.7
      },
      "adjacencies": [
        "crypt-031",
        "crypt-033",
        "crypt-035",
        "crypt-044",
        "crypt-045",
        "crypt-049"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-040",
      "name": "Hollow Tomb",
      "regionId": "left-orbital",
      "shape": "M 339.0 426.0 L 339.0 427.0 L 338.0 427.0 L 338.0 436.0 L 334.0 439.0 L 331.0 439.0 L 328.0 442.0 L 328.0 450.0 L 315.0 464.0 L 307.0 468.0 L 306.0 470.0 L 306.0 482.0 L 303.0 484.0 L 303.0 487.0 L 300.0 489.0 L 300.0 493.0 L 301.0 499.0 L 306.0 503.0 L 306.0 510.0 L 304.0 514.0 L 304.0 529.0 L 305.0 529.0 L 305.0 538.0 L 308.0 537.0 L 318.0 537.0 L 318.0 538.0 L 327.0 538.0 L 333.0 539.0 L 338.0 537.0 L 340.0 534.0 L 348.0 531.0 L 355.0 530.0 L 358.0 526.0 L 365.0 524.0 L 371.0 517.0 L 373.0 517.0 L 382.0 507.0 L 383.0 499.0 L 385.0 492.0 L 389.0 486.0 L 389.0 483.0 L 405.0 459.0 L 406.0 444.0 L 411.0 437.0 L 414.0 431.0 L 415.0 417.0 L 414.0 416.0 L 415.0 414.0 L 409.0 415.0 L 407.0 414.0 L 404.0 415.0 L 398.0 412.0 L 391.0 410.0 L 386.0 410.0 L 383.0 414.0 L 375.0 415.0 L 351.0 422.0 L 349.0 425.0 Z",
      "position": {
        "x": 356.8,
        "y": 476
      },
      "badgeAnchor": {
        "x": 351.01,
        "y": 474.39
      },
      "adjacencies": [
        "crypt-028",
        "crypt-038",
        "crypt-048"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-041",
      "name": "Veiled Crypt",
      "regionId": "left-orbital",
      "shape": "M 202.0 438.0 L 202.0 439.0 L 173.0 439.0 L 171.0 441.0 L 167.0 441.0 L 160.0 447.0 L 156.0 448.0 L 152.0 452.0 L 148.0 452.0 L 143.0 455.0 L 133.0 467.0 L 125.0 471.0 L 125.0 473.0 L 119.0 478.0 L 113.0 486.0 L 109.0 489.0 L 101.0 490.0 L 97.0 493.0 L 84.0 493.0 L 88.0 501.0 L 92.0 502.0 L 98.0 506.0 L 100.0 510.0 L 100.0 516.0 L 102.0 522.0 L 105.0 524.0 L 106.0 532.0 L 106.0 543.0 L 112.0 549.0 L 113.0 557.0 L 119.0 562.0 L 119.0 568.0 L 122.0 573.0 L 125.0 573.0 L 130.0 576.0 L 130.0 575.0 L 135.0 574.0 L 142.0 568.0 L 142.0 565.0 L 145.0 560.0 L 145.0 555.0 L 148.0 553.0 L 148.0 548.0 L 154.0 544.0 L 159.0 538.0 L 170.0 534.0 L 177.0 530.0 L 189.0 530.0 L 197.0 531.0 L 204.0 535.0 L 204.0 537.0 L 216.0 534.0 L 224.0 525.0 L 234.0 523.0 L 238.0 519.0 L 238.0 509.0 L 243.0 503.0 L 243.0 489.0 L 245.0 486.0 L 245.0 483.0 L 244.0 481.0 L 234.0 473.0 L 231.0 469.0 L 230.0 464.0 L 227.0 461.0 L 224.0 454.0 L 218.0 453.0 L 212.0 446.0 L 210.0 446.0 L 204.0 438.0 Z",
      "position": {
        "x": 171.1,
        "y": 490.9
      },
      "badgeAnchor": {
        "x": 171.1,
        "y": 490.9
      },
      "adjacencies": [
        "crypt-029",
        "crypt-037",
        "crypt-038",
        "crypt-048",
        "crypt-051",
        "crypt-053"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-042",
      "name": "Veiled Barrow",
      "regionId": "right-parietal",
      "shape": "M 599.0 459.0 L 599.0 461.0 L 598.0 466.0 L 592.0 474.0 L 592.0 479.0 L 593.0 489.0 L 595.0 491.0 L 595.0 493.0 L 599.0 497.0 L 602.0 505.0 L 611.0 513.0 L 618.0 515.0 L 622.0 521.0 L 625.0 521.0 L 625.0 520.0 L 634.0 520.0 L 645.0 527.0 L 650.0 523.0 L 660.0 521.0 L 664.0 516.0 L 669.0 512.0 L 674.0 510.0 L 686.0 509.0 L 691.0 504.0 L 697.0 504.0 L 701.0 501.0 L 704.0 496.0 L 707.0 488.0 L 709.0 487.0 L 709.0 481.0 L 709.0 479.0 L 706.0 477.0 L 705.0 472.0 L 697.0 468.0 L 683.0 468.0 L 683.0 467.0 L 670.0 467.0 L 667.0 469.0 L 660.0 469.0 L 658.0 467.0 L 639.0 469.0 L 633.0 474.0 L 623.0 475.0 L 619.0 477.0 L 614.0 471.0 L 612.0 471.0 L 607.0 465.0 Z",
      "position": {
        "x": 649.4,
        "y": 492.6
      },
      "badgeAnchor": {
        "x": 649.4,
        "y": 492.6
      },
      "adjacencies": [
        "crypt-034",
        "crypt-036",
        "crypt-043",
        "crypt-047",
        "crypt-050"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-043",
      "name": "Veiled Ossuary",
      "regionId": "right-parietal",
      "shape": "M 732.0 464.0 L 732.0 465.0 L 727.0 472.0 L 717.0 473.0 L 713.0 478.0 L 709.0 478.0 L 709.0 481.0 L 709.0 487.0 L 707.0 488.0 L 704.0 496.0 L 701.0 501.0 L 697.0 504.0 L 691.0 504.0 L 686.0 509.0 L 674.0 510.0 L 669.0 512.0 L 664.0 516.0 L 660.0 521.0 L 650.0 523.0 L 645.0 527.0 L 649.0 534.0 L 649.0 543.0 L 652.0 545.0 L 663.0 546.0 L 669.0 550.0 L 681.0 550.0 L 687.0 548.0 L 691.0 544.0 L 699.0 543.0 L 706.0 541.0 L 710.0 538.0 L 713.0 538.0 L 721.0 534.0 L 734.0 534.0 L 734.0 535.0 L 749.0 535.0 L 749.0 533.0 L 753.0 524.0 L 755.0 523.0 L 756.0 512.0 L 763.0 504.0 L 767.0 498.0 L 770.0 483.0 L 775.0 478.0 L 774.0 471.0 L 769.0 471.0 L 739.0 464.0 Z",
      "position": {
        "x": 721.5,
        "y": 496.9
      },
      "badgeAnchor": {
        "x": 730.91,
        "y": 500.92
      },
      "adjacencies": [
        "crypt-030",
        "crypt-036",
        "crypt-042",
        "crypt-044"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-044",
      "name": "Veiled Cairn",
      "regionId": "right-parietal",
      "shape": "M 792.0 458.0 L 792.0 459.0 L 788.0 461.0 L 782.0 468.0 L 779.0 468.0 L 775.0 471.0 L 774.0 471.0 L 775.0 478.0 L 770.0 483.0 L 767.0 498.0 L 763.0 504.0 L 756.0 512.0 L 755.0 523.0 L 753.0 524.0 L 749.0 533.0 L 749.0 536.0 L 773.0 541.0 L 773.0 542.0 L 783.0 542.0 L 787.0 543.0 L 796.0 548.0 L 802.0 548.0 L 810.0 551.0 L 814.0 556.0 L 817.0 557.0 L 820.0 550.0 L 823.0 548.0 L 824.0 536.0 L 827.0 532.0 L 827.0 526.0 L 833.0 521.0 L 840.0 517.0 L 849.0 515.0 L 855.0 507.0 L 856.0 507.0 L 853.0 501.0 L 853.0 497.0 L 850.0 493.0 L 849.0 483.0 L 843.0 479.0 L 841.0 476.0 L 838.0 476.0 L 838.0 477.0 L 827.0 477.0 L 819.0 471.0 L 809.0 471.0 L 802.0 470.0 L 794.0 458.0 Z",
      "position": {
        "x": 793.5,
        "y": 501.3
      },
      "badgeAnchor": {
        "x": 793.5,
        "y": 501.3
      },
      "adjacencies": [
        "crypt-030",
        "crypt-035",
        "crypt-039",
        "crypt-043",
        "crypt-049"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-045",
      "name": "Veiled Haven",
      "regionId": "right-parietal",
      "shape": "M 958.0 442.0 L 958.0 445.0 L 953.0 451.0 L 950.0 451.0 L 942.0 458.0 L 941.0 461.0 L 935.0 462.0 L 934.0 465.0 L 935.0 472.0 L 935.0 486.0 L 932.0 489.0 L 930.0 495.0 L 928.0 496.0 L 928.0 503.0 L 930.0 504.0 L 929.0 509.0 L 929.0 522.0 L 926.0 526.0 L 926.0 530.0 L 932.0 536.0 L 932.0 540.0 L 936.0 546.0 L 939.0 557.0 L 944.0 557.0 L 948.0 558.0 L 950.0 563.0 L 961.0 571.0 L 976.0 571.0 L 982.0 575.0 L 985.0 579.0 L 991.0 579.0 L 994.0 554.0 L 996.0 547.0 L 996.0 509.0 L 999.0 501.0 L 999.0 496.0 L 1001.0 492.0 L 1001.0 475.0 L 1002.0 475.0 L 1002.0 456.0 L 993.0 455.0 L 984.0 452.0 L 978.0 446.0 L 971.0 445.0 L 965.0 442.0 Z",
      "position": {
        "x": 960.3,
        "y": 510.4
      },
      "badgeAnchor": {
        "x": 960.3,
        "y": 510.4
      },
      "adjacencies": [
        "crypt-031",
        "crypt-039",
        "crypt-049",
        "crypt-054"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-046",
      "name": "Veiled Watch",
      "regionId": "nasal-ridge",
      "shape": "M 416.0 573.0 L 424.0 570.0 L 432.0 570.0 L 437.0 572.0 L 445.0 573.0 L 459.0 562.0 L 464.0 560.0 L 470.0 555.0 L 473.0 554.0 L 482.0 554.0 L 488.0 560.0 L 502.0 559.0 L 504.0 560.0 L 504.0 559.0 L 507.0 556.0 L 508.0 552.0 L 508.0 549.0 L 509.0 549.0 L 510.0 548.0 L 511.0 541.0 L 512.0 541.0 L 513.0 541.0 L 513.0 539.0 L 514.0 539.0 L 514.0 538.0 L 516.0 538.0 L 517.0 537.0 L 517.0 533.0 L 512.0 529.0 L 511.0 524.0 L 508.0 520.0 L 506.0 503.0 L 501.0 497.0 L 497.0 483.0 L 485.0 475.0 L 483.0 472.0 L 478.0 470.0 L 476.0 467.0 L 463.0 464.0 L 450.0 460.0 L 446.0 457.0 L 442.0 449.0 L 438.0 444.0 L 432.0 444.0 L 429.0 452.0 L 426.0 456.0 L 426.0 466.0 L 427.0 466.0 L 427.0 477.0 L 422.0 481.0 L 422.0 483.0 L 417.0 487.0 L 414.0 510.0 L 411.0 517.0 L 408.0 519.0 L 408.0 542.0 L 409.0 542.0 L 409.0 566.0 Z",
      "position": {
        "x": 448.9,
        "y": 512.5
      },
      "badgeAnchor": {
        "x": 456.42,
        "y": 517.15
      },
      "adjacencies": [
        "crypt-047",
        "crypt-052"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-047",
      "name": "Veiled Sanctum",
      "regionId": "nasal-ridge",
      "shape": "M 517.0 451.0 L 515.0 454.0 L 510.0 454.0 L 510.0 455.0 L 509.0 455.0 L 509.0 456.0 L 508.0 456.0 L 508.0 457.0 L 507.0 457.0 L 507.0 458.0 L 506.0 458.0 L 506.0 459.0 L 505.0 459.0 L 505.0 460.0 L 504.0 460.0 L 504.0 461.0 L 503.0 461.0 L 503.0 463.0 L 509.0 468.0 L 509.0 470.0 L 515.0 475.0 L 513.0 483.0 L 513.0 492.0 L 514.0 492.0 L 514.0 501.0 L 518.0 509.0 L 519.0 515.0 L 523.0 523.0 L 523.0 530.0 L 518.0 534.0 L 517.0 537.0 L 517.0 538.0 L 515.0 538.0 L 514.0 539.0 L 513.0 541.0 L 511.0 541.0 L 511.0 548.0 L 510.0 548.0 L 510.0 549.0 L 509.0 549.0 L 508.0 552.0 L 507.0 556.0 L 504.0 559.0 L 504.0 567.0 L 498.0 577.0 L 498.0 587.0 L 501.0 589.0 L 503.0 594.0 L 503.0 595.0 L 504.0 596.0 L 522.0 596.0 L 529.0 591.0 L 547.0 586.0 L 561.0 571.0 L 566.0 569.0 L 567.0 569.0 L 567.0 555.0 L 571.0 548.0 L 571.0 545.0 L 576.0 541.0 L 577.0 537.0 L 577.0 527.0 L 576.0 527.0 L 576.0 514.0 L 575.0 508.0 L 583.0 502.0 L 588.0 496.0 L 595.0 494.0 L 595.0 491.0 L 593.0 489.0 L 592.0 479.0 L 592.0 476.0 L 584.0 474.0 L 578.0 467.0 L 573.0 466.0 L 566.0 459.0 L 548.0 459.0 L 544.0 457.0 L 540.0 452.0 L 536.0 451.0 L 534.0 451.0 L 534.0 452.0 L 533.0 452.0 L 531.0 453.0 L 528.0 452.0 L 523.0 449.0 Z",
      "position": {
        "x": 540.3,
        "y": 514.4
      },
      "badgeAnchor": {
        "x": 550.34,
        "y": 523.65
      },
      "adjacencies": [
        "crypt-034",
        "crypt-042",
        "crypt-046",
        "crypt-050",
        "crypt-052",
        "crypt-055"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-048",
      "name": "Veiled Vault",
      "regionId": "left-orbital",
      "shape": "M 245.0 485.0 L 245.0 486.0 L 243.0 489.0 L 243.0 503.0 L 238.0 509.0 L 238.0 519.0 L 234.0 523.0 L 224.0 525.0 L 216.0 534.0 L 204.0 537.0 L 204.0 538.0 L 202.0 541.0 L 202.0 546.0 L 206.0 550.0 L 209.0 557.0 L 222.0 565.0 L 223.0 567.0 L 226.0 567.0 L 229.0 563.0 L 239.0 558.0 L 243.0 554.0 L 251.0 551.0 L 263.0 550.0 L 280.0 544.0 L 284.0 541.0 L 293.0 538.0 L 305.0 538.0 L 305.0 529.0 L 304.0 529.0 L 304.0 514.0 L 306.0 510.0 L 306.0 503.0 L 301.0 499.0 L 300.0 493.0 L 300.0 491.0 L 294.0 489.0 L 284.0 489.0 L 284.0 488.0 L 273.0 488.0 L 268.0 486.0 L 256.0 486.0 L 256.0 485.0 Z",
      "position": {
        "x": 264.8,
        "y": 523.2
      },
      "badgeAnchor": {
        "x": 266.17,
        "y": 511.94
      },
      "adjacencies": [
        "crypt-038",
        "crypt-040",
        "crypt-041",
        "crypt-053"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-049",
      "name": "Veiled Shrine",
      "regionId": "right-parietal",
      "shape": "M 855.0 507.0 L 849.0 515.0 L 840.0 517.0 L 833.0 521.0 L 827.0 526.0 L 827.0 532.0 L 824.0 536.0 L 823.0 548.0 L 820.0 550.0 L 817.0 557.0 L 819.0 559.0 L 830.0 559.0 L 836.0 562.0 L 843.0 564.0 L 848.0 572.0 L 860.0 583.0 L 862.0 584.0 L 873.0 596.0 L 878.0 612.0 L 878.0 623.0 L 879.0 630.0 L 884.0 640.0 L 884.0 649.0 L 883.0 656.0 L 894.0 656.0 L 899.0 655.0 L 907.0 659.0 L 907.0 658.0 L 909.0 658.0 L 915.0 651.0 L 924.0 627.0 L 925.0 617.0 L 926.0 617.0 L 926.0 606.0 L 927.0 600.0 L 929.0 598.0 L 929.0 583.0 L 928.0 583.0 L 928.0 570.0 L 935.0 564.0 L 935.0 561.0 L 938.0 557.0 L 939.0 557.0 L 936.0 546.0 L 932.0 540.0 L 932.0 536.0 L 926.0 530.0 L 926.0 528.0 L 919.0 523.0 L 915.0 522.0 L 906.0 522.0 L 906.0 523.0 L 896.0 523.0 L 893.0 522.0 L 877.0 513.0 L 871.0 513.0 L 864.0 507.0 Z",
      "position": {
        "x": 882.7,
        "y": 552.6
      },
      "badgeAnchor": {
        "x": 882.7,
        "y": 552.6
      },
      "adjacencies": [
        "crypt-039",
        "crypt-044",
        "crypt-045",
        "crypt-054",
        "crypt-058"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-050",
      "name": "Veiled Tomb",
      "regionId": "nasal-ridge",
      "shape": "M 595.0 493.0 L 595.0 494.0 L 588.0 496.0 L 583.0 502.0 L 575.0 508.0 L 576.0 514.0 L 576.0 527.0 L 577.0 527.0 L 577.0 537.0 L 576.0 541.0 L 571.0 545.0 L 571.0 548.0 L 567.0 555.0 L 567.0 569.0 L 568.0 569.0 L 571.0 573.0 L 573.0 582.0 L 576.0 584.0 L 579.0 589.0 L 583.0 599.0 L 584.0 606.0 L 583.0 608.0 L 585.0 608.0 L 589.0 614.0 L 598.0 622.0 L 598.0 624.0 L 607.0 630.0 L 612.0 631.0 L 613.0 633.0 L 617.0 633.0 L 619.0 628.0 L 622.0 625.0 L 628.0 604.0 L 634.0 594.0 L 637.0 592.0 L 637.0 582.0 L 636.0 582.0 L 636.0 564.0 L 635.0 564.0 L 635.0 549.0 L 632.0 548.0 L 629.0 543.0 L 620.0 535.0 L 619.0 526.0 L 622.0 521.0 L 618.0 515.0 L 611.0 513.0 L 602.0 505.0 L 599.0 497.0 Z",
      "position": {
        "x": 595.8,
        "y": 576
      },
      "badgeAnchor": {
        "x": 599.89,
        "y": 563.91
      },
      "adjacencies": [
        "crypt-042",
        "crypt-047",
        "crypt-055",
        "crypt-056"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-051",
      "name": "Moonlit Crypt",
      "regionId": "left-orbital",
      "shape": "M 62.0 496.0 L 62.0 503.0 L 59.0 508.0 L 58.0 515.0 L 58.0 542.0 L 62.0 553.0 L 62.0 563.0 L 63.0 563.0 L 63.0 580.0 L 64.0 580.0 L 64.0 597.0 L 65.0 597.0 L 65.0 606.0 L 68.0 609.0 L 68.0 637.0 L 74.0 647.0 L 76.0 668.0 L 77.0 668.0 L 77.0 677.0 L 78.0 682.0 L 84.0 680.0 L 85.0 677.0 L 92.0 675.0 L 98.0 668.0 L 101.0 667.0 L 111.0 667.0 L 111.0 666.0 L 121.0 666.0 L 125.0 662.0 L 126.0 662.0 L 126.0 658.0 L 129.0 655.0 L 127.0 651.0 L 127.0 639.0 L 128.0 639.0 L 128.0 627.0 L 126.0 625.0 L 126.0 617.0 L 128.0 616.0 L 128.0 593.0 L 129.0 593.0 L 129.0 579.0 L 130.0 579.0 L 130.0 576.0 L 125.0 573.0 L 122.0 573.0 L 119.0 568.0 L 119.0 562.0 L 113.0 557.0 L 112.0 549.0 L 106.0 543.0 L 106.0 532.0 L 105.0 524.0 L 102.0 522.0 L 100.0 516.0 L 100.0 510.0 L 98.0 506.0 L 92.0 502.0 L 88.0 501.0 L 84.0 493.0 L 83.0 493.0 L 83.0 492.0 L 73.0 492.0 L 66.0 493.0 Z",
      "position": {
        "x": 94.2,
        "y": 595.6
      },
      "badgeAnchor": {
        "x": 96.1,
        "y": 588.37
      },
      "adjacencies": [
        "crypt-037",
        "crypt-041",
        "crypt-053",
        "crypt-059"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-052",
      "name": "Moonlit Barrow",
      "regionId": "nasal-ridge",
      "shape": "M 416.0 573.0 L 420.0 583.0 L 421.0 583.0 L 421.0 596.0 L 423.0 599.0 L 423.0 612.0 L 424.0 612.0 L 424.0 630.0 L 423.0 630.0 L 423.0 644.0 L 422.0 644.0 L 422.0 654.0 L 429.0 654.0 L 434.0 657.0 L 443.0 656.0 L 452.0 651.0 L 455.0 651.0 L 459.0 648.0 L 464.0 647.0 L 465.0 645.0 L 469.0 645.0 L 469.0 640.0 L 474.0 635.0 L 477.0 635.0 L 493.0 626.0 L 493.0 623.0 L 499.0 616.0 L 499.0 600.0 L 503.0 596.0 L 503.0 594.0 L 501.0 589.0 L 498.0 587.0 L 498.0 577.0 L 504.0 567.0 L 504.0 560.0 L 502.0 559.0 L 488.0 560.0 L 482.0 554.0 L 473.0 554.0 L 470.0 555.0 L 464.0 560.0 L 459.0 562.0 L 445.0 573.0 L 437.0 572.0 L 432.0 570.0 L 424.0 570.0 Z",
      "position": {
        "x": 463.2,
        "y": 604
      },
      "badgeAnchor": {
        "x": 463.2,
        "y": 604
      },
      "adjacencies": [
        "crypt-046",
        "crypt-047",
        "crypt-055",
        "crypt-057"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-053",
      "name": "Moonlit Ossuary",
      "regionId": "left-orbital",
      "shape": "M 130.0 575.0 L 130.0 579.0 L 129.0 579.0 L 129.0 593.0 L 128.0 593.0 L 128.0 616.0 L 126.0 617.0 L 126.0 625.0 L 128.0 627.0 L 128.0 639.0 L 127.0 639.0 L 127.0 651.0 L 129.0 655.0 L 126.0 658.0 L 126.0 662.0 L 128.0 662.0 L 131.0 664.0 L 138.0 672.0 L 143.0 674.0 L 152.0 674.0 L 152.0 675.0 L 165.0 675.0 L 176.0 670.0 L 183.0 670.0 L 183.0 658.0 L 187.0 653.0 L 187.0 644.0 L 190.0 640.0 L 190.0 627.0 L 189.0 627.0 L 189.0 615.0 L 188.0 615.0 L 188.0 602.0 L 189.0 595.0 L 191.0 591.0 L 207.0 576.0 L 215.0 575.0 L 217.0 572.0 L 222.0 570.0 L 223.0 567.0 L 222.0 565.0 L 209.0 557.0 L 206.0 550.0 L 202.0 546.0 L 202.0 541.0 L 204.0 538.0 L 204.0 535.0 L 197.0 531.0 L 189.0 530.0 L 177.0 530.0 L 170.0 534.0 L 159.0 538.0 L 154.0 544.0 L 148.0 548.0 L 148.0 553.0 L 145.0 555.0 L 145.0 560.0 L 142.0 565.0 L 142.0 568.0 L 135.0 574.0 Z",
      "position": {
        "x": 161.9,
        "y": 618.7
      },
      "badgeAnchor": {
        "x": 153.13,
        "y": 603
      },
      "adjacencies": [
        "crypt-041",
        "crypt-048",
        "crypt-051",
        "crypt-059"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-054",
      "name": "Moonlit Cairn",
      "regionId": "right-parietal",
      "shape": "M 938.0 557.0 L 935.0 561.0 L 935.0 564.0 L 928.0 570.0 L 928.0 583.0 L 929.0 583.0 L 929.0 598.0 L 927.0 600.0 L 926.0 606.0 L 926.0 617.0 L 925.0 617.0 L 924.0 627.0 L 915.0 651.0 L 909.0 658.0 L 907.0 658.0 L 907.0 661.0 L 908.0 666.0 L 916.0 670.0 L 917.0 678.0 L 919.0 683.0 L 929.0 692.0 L 941.0 692.0 L 950.0 697.0 L 953.0 697.0 L 957.0 700.0 L 963.0 702.0 L 975.0 702.0 L 977.0 703.0 L 977.0 665.0 L 980.0 655.0 L 980.0 644.0 L 979.0 637.0 L 984.0 632.0 L 987.0 617.0 L 988.0 617.0 L 988.0 607.0 L 989.0 607.0 L 989.0 596.0 L 990.0 596.0 L 990.0 586.0 L 991.0 579.0 L 985.0 579.0 L 982.0 575.0 L 976.0 571.0 L 961.0 571.0 L 950.0 563.0 L 948.0 558.0 L 944.0 557.0 Z",
      "position": {
        "x": 951.4,
        "y": 627.3
      },
      "badgeAnchor": {
        "x": 951.4,
        "y": 627.3
      },
      "adjacencies": [
        "crypt-045",
        "crypt-049",
        "crypt-058"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-055",
      "name": "Moonlit Haven",
      "regionId": "nasal-ridge",
      "shape": "M 566.0 569.0 L 561.0 571.0 L 547.0 586.0 L 529.0 591.0 L 522.0 596.0 L 504.0 596.0 L 503.0 595.0 L 503.0 596.0 L 499.0 600.0 L 499.0 616.0 L 493.0 623.0 L 493.0 626.0 L 477.0 635.0 L 474.0 635.0 L 469.0 640.0 L 469.0 645.0 L 471.0 645.0 L 474.0 648.0 L 477.0 648.0 L 479.0 653.0 L 504.0 677.0 L 509.0 680.0 L 512.0 680.0 L 521.0 685.0 L 521.0 684.0 L 531.0 677.0 L 532.0 671.0 L 534.0 669.0 L 535.0 663.0 L 542.0 658.0 L 546.0 653.0 L 552.0 650.0 L 560.0 642.0 L 562.0 642.0 L 568.0 634.0 L 569.0 628.0 L 573.0 623.0 L 576.0 615.0 L 579.0 610.0 L 582.0 608.0 L 583.0 608.0 L 584.0 606.0 L 583.0 599.0 L 579.0 589.0 L 576.0 584.0 L 573.0 582.0 L 571.0 573.0 L 568.0 569.0 Z",
      "position": {
        "x": 525.1,
        "y": 629.7
      },
      "badgeAnchor": {
        "x": 525.1,
        "y": 629.7
      },
      "adjacencies": [
        "crypt-047",
        "crypt-050",
        "crypt-052",
        "crypt-056",
        "crypt-057"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-056",
      "name": "Moonlit Watch",
      "regionId": "nasal-ridge",
      "shape": "M 582.0 608.0 L 579.0 610.0 L 576.0 615.0 L 573.0 623.0 L 569.0 628.0 L 568.0 634.0 L 562.0 642.0 L 560.0 642.0 L 552.0 650.0 L 546.0 653.0 L 542.0 658.0 L 535.0 663.0 L 534.0 669.0 L 532.0 671.0 L 531.0 677.0 L 521.0 684.0 L 521.0 686.0 L 522.0 691.0 L 525.0 694.0 L 531.0 694.0 L 536.0 702.0 L 536.0 710.0 L 540.0 713.0 L 539.0 722.0 L 536.0 725.0 L 536.0 730.0 L 538.0 732.0 L 538.0 740.0 L 543.0 740.0 L 551.0 743.0 L 556.0 748.0 L 560.0 748.0 L 563.0 751.0 L 565.0 751.0 L 565.0 749.0 L 570.0 744.0 L 583.0 744.0 L 586.0 743.0 L 592.0 735.0 L 592.0 730.0 L 595.0 724.0 L 613.0 722.0 L 614.0 720.0 L 620.0 718.0 L 619.0 717.0 L 619.0 708.0 L 618.0 700.0 L 613.0 693.0 L 613.0 641.0 L 616.0 633.0 L 613.0 633.0 L 612.0 631.0 L 607.0 630.0 L 598.0 624.0 L 598.0 622.0 L 589.0 614.0 L 585.0 608.0 Z",
      "position": {
        "x": 574.7,
        "y": 686.6
      },
      "badgeAnchor": {
        "x": 574.7,
        "y": 686.6
      },
      "adjacencies": [
        "crypt-050",
        "crypt-055",
        "crypt-057",
        "crypt-063"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-057",
      "name": "Moonlit Sanctum",
      "regionId": "nasal-ridge",
      "shape": "M 465.0 645.0 L 464.0 647.0 L 459.0 648.0 L 455.0 651.0 L 452.0 651.0 L 443.0 656.0 L 434.0 657.0 L 429.0 654.0 L 422.0 654.0 L 421.0 661.0 L 418.0 672.0 L 418.0 697.0 L 421.0 700.0 L 423.0 706.0 L 425.0 707.0 L 427.0 713.0 L 429.0 714.0 L 431.0 720.0 L 433.0 721.0 L 435.0 727.0 L 437.0 728.0 L 439.0 734.0 L 442.0 737.0 L 442.0 745.0 L 448.0 760.0 L 450.0 767.0 L 452.0 768.0 L 454.0 774.0 L 467.0 784.0 L 471.0 789.0 L 478.0 789.0 L 481.0 783.0 L 481.0 780.0 L 484.0 776.0 L 484.0 773.0 L 487.0 767.0 L 493.0 763.0 L 499.0 756.0 L 499.0 754.0 L 509.0 745.0 L 538.0 741.0 L 538.0 732.0 L 536.0 730.0 L 536.0 725.0 L 539.0 722.0 L 540.0 713.0 L 536.0 710.0 L 536.0 702.0 L 531.0 694.0 L 525.0 694.0 L 522.0 691.0 L 521.0 686.0 L 521.0 685.0 L 512.0 680.0 L 509.0 680.0 L 504.0 677.0 L 479.0 653.0 L 477.0 648.0 L 474.0 648.0 L 471.0 645.0 Z",
      "position": {
        "x": 472,
        "y": 705.6
      },
      "badgeAnchor": {
        "x": 472,
        "y": 705.6
      },
      "adjacencies": [
        "crypt-052",
        "crypt-055",
        "crypt-056"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-058",
      "name": "Moonlit Vault",
      "regionId": "right-parietal",
      "shape": "M 883.0 656.0 L 882.0 664.0 L 882.0 679.0 L 881.0 679.0 L 881.0 693.0 L 880.0 701.0 L 876.0 709.0 L 874.0 718.0 L 870.0 726.0 L 870.0 733.0 L 868.0 739.0 L 868.0 742.0 L 887.0 745.0 L 894.0 748.0 L 900.0 754.0 L 914.0 757.0 L 914.0 756.0 L 932.0 756.0 L 936.0 760.0 L 936.0 778.0 L 940.0 786.0 L 940.0 792.0 L 948.0 804.0 L 954.0 800.0 L 958.0 799.0 L 958.0 785.0 L 963.0 778.0 L 963.0 766.0 L 970.0 757.0 L 970.0 731.0 L 977.0 707.0 L 977.0 703.0 L 975.0 702.0 L 963.0 702.0 L 957.0 700.0 L 953.0 697.0 L 950.0 697.0 L 941.0 692.0 L 929.0 692.0 L 919.0 683.0 L 917.0 678.0 L 916.0 670.0 L 908.0 666.0 L 907.0 661.0 L 907.0 659.0 L 899.0 655.0 L 894.0 656.0 Z",
      "position": {
        "x": 916.9,
        "y": 714.6
      },
      "badgeAnchor": {
        "x": 916.9,
        "y": 714.6
      },
      "adjacencies": [
        "crypt-049",
        "crypt-054",
        "crypt-062"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-059",
      "name": "Moonlit Shrine",
      "regionId": "left-orbital",
      "shape": "M 125.0 662.0 L 121.0 666.0 L 111.0 666.0 L 111.0 667.0 L 101.0 667.0 L 98.0 668.0 L 92.0 675.0 L 85.0 677.0 L 84.0 680.0 L 78.0 682.0 L 78.0 691.0 L 77.0 691.0 L 77.0 716.0 L 79.0 723.0 L 84.0 728.0 L 93.0 777.0 L 95.0 784.0 L 98.0 788.0 L 100.0 796.0 L 102.0 798.0 L 101.0 806.0 L 101.0 809.0 L 106.0 812.0 L 133.0 812.0 L 141.0 809.0 L 148.0 808.0 L 152.0 803.0 L 154.0 803.0 L 158.0 798.0 L 164.0 797.0 L 164.0 792.0 L 160.0 789.0 L 157.0 784.0 L 151.0 780.0 L 146.0 775.0 L 146.0 767.0 L 143.0 762.0 L 143.0 755.0 L 150.0 752.0 L 153.0 746.0 L 153.0 735.0 L 154.0 729.0 L 151.0 727.0 L 151.0 715.0 L 157.0 710.0 L 157.0 708.0 L 166.0 706.0 L 172.0 707.0 L 177.0 701.0 L 185.0 700.0 L 191.0 693.0 L 193.0 693.0 L 193.0 691.0 L 185.0 684.0 L 183.0 677.0 L 183.0 670.0 L 176.0 670.0 L 165.0 675.0 L 152.0 675.0 L 152.0 674.0 L 143.0 674.0 L 138.0 672.0 L 131.0 664.0 L 128.0 662.0 Z",
      "position": {
        "x": 115.6,
        "y": 727.6
      },
      "badgeAnchor": {
        "x": 115.6,
        "y": 727.6
      },
      "adjacencies": [
        "crypt-051",
        "crypt-053",
        "crypt-060",
        "crypt-067"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-060",
      "name": "Moonlit Tomb",
      "regionId": "left-orbital",
      "shape": "M 193.0 693.0 L 191.0 693.0 L 185.0 700.0 L 177.0 701.0 L 172.0 707.0 L 166.0 706.0 L 157.0 708.0 L 157.0 710.0 L 151.0 715.0 L 151.0 727.0 L 154.0 729.0 L 153.0 735.0 L 153.0 746.0 L 150.0 752.0 L 143.0 755.0 L 143.0 762.0 L 146.0 767.0 L 146.0 775.0 L 151.0 780.0 L 157.0 784.0 L 160.0 789.0 L 164.0 792.0 L 164.0 798.0 L 166.0 799.0 L 177.0 799.0 L 177.0 800.0 L 189.0 800.0 L 189.0 801.0 L 198.0 801.0 L 203.0 802.0 L 204.0 804.0 L 211.0 807.0 L 215.0 812.0 L 219.0 814.0 L 226.0 826.0 L 226.0 829.0 L 231.0 826.0 L 234.0 819.0 L 234.0 814.0 L 236.0 811.0 L 245.0 807.0 L 245.0 800.0 L 252.0 796.0 L 259.0 788.0 L 267.0 787.0 L 267.0 785.0 L 270.0 782.0 L 268.0 775.0 L 268.0 765.0 L 266.0 761.0 L 266.0 752.0 L 267.0 744.0 L 266.0 739.0 L 270.0 736.0 L 272.0 732.0 L 272.0 730.0 L 264.0 727.0 L 261.0 723.0 L 255.0 720.0 L 252.0 716.0 L 246.0 713.0 L 243.0 709.0 L 235.0 706.0 L 234.0 704.0 L 228.0 701.0 L 204.0 701.0 L 198.0 699.0 L 194.0 692.0 Z",
      "position": {
        "x": 193.1,
        "y": 748.9
      },
      "badgeAnchor": {
        "x": 205.46,
        "y": 756.96
      },
      "adjacencies": [
        "crypt-059",
        "crypt-061",
        "crypt-064",
        "crypt-067"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-061",
      "name": "Sunken Crypt",
      "regionId": "left-orbital",
      "shape": "M 272.0 732.0 L 270.0 736.0 L 266.0 739.0 L 267.0 744.0 L 266.0 752.0 L 266.0 761.0 L 268.0 765.0 L 268.0 775.0 L 270.0 782.0 L 267.0 785.0 L 267.0 788.0 L 272.0 795.0 L 279.0 794.0 L 292.0 794.0 L 295.0 796.0 L 302.0 795.0 L 312.0 795.0 L 319.0 799.0 L 334.0 799.0 L 341.0 796.0 L 345.0 796.0 L 348.0 793.0 L 352.0 792.0 L 362.0 792.0 L 367.0 789.0 L 390.0 789.0 L 390.0 790.0 L 412.0 790.0 L 418.0 784.0 L 423.0 783.0 L 421.0 780.0 L 421.0 773.0 L 416.0 765.0 L 415.0 761.0 L 409.0 754.0 L 406.0 747.0 L 394.0 736.0 L 390.0 728.0 L 383.0 728.0 L 372.0 736.0 L 364.0 739.0 L 359.0 739.0 L 348.0 745.0 L 345.0 745.0 L 338.0 750.0 L 332.0 752.0 L 331.0 754.0 L 323.0 758.0 L 313.0 758.0 L 311.0 757.0 L 305.0 749.0 L 296.0 742.0 L 285.0 739.0 L 284.0 737.0 L 278.0 735.0 L 275.0 732.0 Z",
      "position": {
        "x": 374.1,
        "y": 768
      },
      "badgeAnchor": {
        "x": 360.07,
        "y": 769.99
      },
      "adjacencies": [
        "crypt-060",
        "crypt-064",
        "crypt-065"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-062",
      "name": "Sunken Barrow",
      "regionId": "right-zygomatic",
      "shape": "M 831.0 789.0 L 838.0 794.0 L 841.0 794.0 L 844.0 798.0 L 844.0 802.0 L 851.0 806.0 L 854.0 810.0 L 859.0 811.0 L 866.0 819.0 L 869.0 819.0 L 874.0 824.0 L 876.0 831.0 L 880.0 832.0 L 881.0 835.0 L 887.0 839.0 L 893.0 847.0 L 898.0 851.0 L 899.0 855.0 L 906.0 855.0 L 911.0 852.0 L 915.0 853.0 L 932.0 853.0 L 942.0 857.0 L 945.0 857.0 L 948.0 860.0 L 953.0 860.0 L 956.0 862.0 L 965.0 863.0 L 967.0 862.0 L 975.0 842.0 L 975.0 834.0 L 973.0 829.0 L 970.0 826.0 L 964.0 825.0 L 957.0 820.0 L 953.0 819.0 L 948.0 813.0 L 948.0 804.0 L 940.0 792.0 L 940.0 786.0 L 936.0 778.0 L 936.0 760.0 L 932.0 756.0 L 914.0 756.0 L 914.0 757.0 L 900.0 754.0 L 894.0 748.0 L 887.0 745.0 L 868.0 742.0 L 866.0 742.0 L 862.0 748.0 L 859.0 750.0 L 857.0 755.0 L 852.0 760.0 L 847.0 773.0 L 835.0 783.0 Z",
      "position": {
        "x": 897.9,
        "y": 793.9
      },
      "badgeAnchor": {
        "x": 897.9,
        "y": 793.9
      },
      "adjacencies": [
        "crypt-058",
        "crypt-066",
        "crypt-070"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-063",
      "name": "Sunken Ossuary",
      "regionId": "right-zygomatic",
      "shape": "M 565.0 751.0 L 567.0 757.0 L 579.0 770.0 L 582.0 776.0 L 590.0 784.0 L 593.0 794.0 L 596.0 798.0 L 602.0 816.0 L 607.0 825.0 L 610.0 840.0 L 614.0 852.0 L 614.0 857.0 L 616.0 863.0 L 623.0 860.0 L 628.0 856.0 L 643.0 856.0 L 651.0 851.0 L 658.0 851.0 L 660.0 848.0 L 666.0 848.0 L 675.0 844.0 L 681.0 844.0 L 691.0 833.0 L 695.0 830.0 L 700.0 834.0 L 706.0 836.0 L 706.0 835.0 L 709.0 830.0 L 709.0 826.0 L 726.0 810.0 L 721.0 809.0 L 715.0 806.0 L 704.0 804.0 L 698.0 802.0 L 691.0 797.0 L 687.0 796.0 L 674.0 786.0 L 670.0 785.0 L 664.0 781.0 L 658.0 774.0 L 656.0 774.0 L 642.0 759.0 L 638.0 754.0 L 630.0 735.0 L 620.0 718.0 L 614.0 720.0 L 613.0 722.0 L 595.0 724.0 L 592.0 730.0 L 592.0 735.0 L 586.0 743.0 L 583.0 744.0 L 570.0 744.0 L 565.0 749.0 Z",
      "position": {
        "x": 637.6,
        "y": 806.5
      },
      "badgeAnchor": {
        "x": 637.6,
        "y": 806.5
      },
      "adjacencies": [
        "crypt-056",
        "crypt-068",
        "crypt-069"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-064",
      "name": "Sunken Cairn",
      "regionId": "left-orbital",
      "shape": "M 226.0 829.0 L 226.0 830.0 L 236.0 838.0 L 243.0 838.0 L 249.0 840.0 L 254.0 845.0 L 260.0 844.0 L 269.0 844.0 L 278.0 846.0 L 281.0 850.0 L 287.0 853.0 L 290.0 856.0 L 300.0 858.0 L 307.0 866.0 L 313.0 867.0 L 320.0 864.0 L 326.0 865.0 L 338.0 865.0 L 338.0 864.0 L 341.0 864.0 L 345.0 861.0 L 380.0 861.0 L 385.0 865.0 L 385.0 856.0 L 384.0 853.0 L 378.0 848.0 L 378.0 846.0 L 370.0 839.0 L 369.0 831.0 L 366.0 829.0 L 362.0 822.0 L 353.0 815.0 L 346.0 807.0 L 346.0 801.0 L 344.0 796.0 L 341.0 796.0 L 334.0 799.0 L 319.0 799.0 L 312.0 795.0 L 302.0 795.0 L 295.0 796.0 L 292.0 794.0 L 279.0 794.0 L 272.0 795.0 L 267.0 788.0 L 267.0 787.0 L 259.0 788.0 L 252.0 796.0 L 245.0 800.0 L 245.0 807.0 L 236.0 811.0 L 234.0 814.0 L 234.0 819.0 L 231.0 826.0 Z",
      "position": {
        "x": 295.3,
        "y": 821.3
      },
      "badgeAnchor": {
        "x": 295.3,
        "y": 821.3
      },
      "adjacencies": [
        "crypt-060",
        "crypt-061",
        "crypt-065",
        "crypt-067",
        "crypt-074"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-065",
      "name": "Sunken Haven",
      "regionId": "left-orbital",
      "shape": "M 345.0 796.0 L 344.0 796.0 L 346.0 801.0 L 346.0 807.0 L 353.0 815.0 L 362.0 822.0 L 366.0 829.0 L 369.0 831.0 L 370.0 839.0 L 378.0 846.0 L 378.0 848.0 L 384.0 853.0 L 385.0 856.0 L 385.0 866.0 L 387.0 869.0 L 397.0 877.0 L 405.0 877.0 L 405.0 878.0 L 424.0 878.0 L 424.0 879.0 L 445.0 879.0 L 447.0 875.0 L 447.0 860.0 L 448.0 860.0 L 448.0 844.0 L 451.0 841.0 L 454.0 833.0 L 458.0 828.0 L 458.0 819.0 L 445.0 810.0 L 434.0 798.0 L 433.0 796.0 L 424.0 788.0 L 423.0 783.0 L 418.0 784.0 L 412.0 790.0 L 390.0 790.0 L 390.0 789.0 L 367.0 789.0 L 362.0 792.0 L 352.0 792.0 L 348.0 793.0 Z",
      "position": {
        "x": 403.7,
        "y": 829.9
      },
      "badgeAnchor": {
        "x": 403.7,
        "y": 829.9
      },
      "adjacencies": [
        "crypt-061",
        "crypt-064",
        "crypt-072",
        "crypt-074"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-066",
      "name": "Sunken Watch",
      "regionId": "right-zygomatic",
      "shape": "M 765.0 818.0 L 764.0 820.0 L 764.0 830.0 L 762.0 833.0 L 762.0 838.0 L 767.0 842.0 L 767.0 850.0 L 770.0 853.0 L 770.0 862.0 L 771.0 864.0 L 782.0 874.0 L 782.0 884.0 L 788.0 891.0 L 788.0 892.0 L 797.0 893.0 L 800.0 895.0 L 805.0 895.0 L 808.0 893.0 L 814.0 892.0 L 817.0 888.0 L 820.0 887.0 L 837.0 887.0 L 837.0 888.0 L 849.0 888.0 L 854.0 893.0 L 856.0 893.0 L 862.0 887.0 L 862.0 884.0 L 870.0 877.0 L 873.0 871.0 L 879.0 871.0 L 884.0 865.0 L 888.0 864.0 L 895.0 858.0 L 898.0 858.0 L 900.0 855.0 L 899.0 855.0 L 898.0 851.0 L 893.0 847.0 L 887.0 839.0 L 881.0 835.0 L 880.0 832.0 L 876.0 831.0 L 874.0 824.0 L 869.0 819.0 L 866.0 819.0 L 859.0 811.0 L 854.0 810.0 L 851.0 806.0 L 844.0 802.0 L 844.0 798.0 L 841.0 794.0 L 838.0 794.0 L 831.0 789.0 L 824.0 793.0 L 817.0 801.0 L 815.0 801.0 L 809.0 808.0 L 804.0 811.0 L 795.0 814.0 L 791.0 817.0 L 773.0 820.0 Z",
      "position": {
        "x": 826.7,
        "y": 844.7
      },
      "badgeAnchor": {
        "x": 826.7,
        "y": 844.7
      },
      "adjacencies": [
        "crypt-062",
        "crypt-069",
        "crypt-070",
        "crypt-073"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-067",
      "name": "Sunken Sanctum",
      "regionId": "left-zygomatic",
      "shape": "M 101.0 809.0 L 94.0 813.0 L 90.0 813.0 L 84.0 823.0 L 82.0 831.0 L 79.0 833.0 L 79.0 846.0 L 84.0 854.0 L 84.0 864.0 L 95.0 874.0 L 99.0 887.0 L 103.0 887.0 L 109.0 886.0 L 112.0 888.0 L 136.0 888.0 L 140.0 891.0 L 147.0 891.0 L 150.0 894.0 L 157.0 894.0 L 172.0 888.0 L 183.0 888.0 L 187.0 881.0 L 197.0 878.0 L 204.0 878.0 L 211.0 875.0 L 232.0 875.0 L 234.0 876.0 L 266.0 909.0 L 278.0 916.0 L 284.0 921.0 L 284.0 924.0 L 294.0 932.0 L 294.0 933.0 L 303.0 934.0 L 305.0 932.0 L 311.0 931.0 L 314.0 927.0 L 314.0 917.0 L 316.0 913.0 L 317.0 900.0 L 318.0 896.0 L 323.0 888.0 L 324.0 883.0 L 327.0 879.0 L 335.0 878.0 L 339.0 874.0 L 341.0 865.0 L 340.0 864.0 L 338.0 864.0 L 338.0 865.0 L 326.0 865.0 L 320.0 864.0 L 313.0 867.0 L 307.0 866.0 L 300.0 858.0 L 290.0 856.0 L 287.0 853.0 L 281.0 850.0 L 278.0 846.0 L 269.0 844.0 L 260.0 844.0 L 254.0 845.0 L 249.0 840.0 L 243.0 838.0 L 236.0 838.0 L 226.0 830.0 L 226.0 826.0 L 219.0 814.0 L 215.0 812.0 L 211.0 807.0 L 204.0 804.0 L 203.0 802.0 L 198.0 801.0 L 189.0 801.0 L 189.0 800.0 L 177.0 800.0 L 177.0 799.0 L 166.0 799.0 L 164.0 798.0 L 164.0 797.0 L 158.0 798.0 L 154.0 803.0 L 152.0 803.0 L 148.0 808.0 L 141.0 809.0 L 133.0 812.0 L 106.0 812.0 Z",
      "position": {
        "x": 169,
        "y": 846.8
      },
      "badgeAnchor": {
        "x": 169,
        "y": 846.8
      },
      "adjacencies": [
        "crypt-059",
        "crypt-060",
        "crypt-064",
        "crypt-071",
        "crypt-074"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-068",
      "name": "Sunken Vault",
      "regionId": "right-zygomatic",
      "shape": "M 616.0 863.0 L 615.0 868.0 L 615.0 877.0 L 614.0 877.0 L 614.0 886.0 L 613.0 893.0 L 615.0 893.0 L 619.0 894.0 L 622.0 900.0 L 633.0 907.0 L 642.0 906.0 L 652.0 902.0 L 673.0 902.0 L 677.0 903.0 L 683.0 914.0 L 696.0 926.0 L 703.0 928.0 L 703.0 929.0 L 706.0 929.0 L 710.0 926.0 L 711.0 923.0 L 719.0 916.0 L 718.0 909.0 L 720.0 908.0 L 719.0 896.0 L 722.0 892.0 L 721.0 887.0 L 721.0 868.0 L 719.0 867.0 L 719.0 855.0 L 717.0 852.0 L 717.0 847.0 L 706.0 839.0 L 706.0 836.0 L 700.0 834.0 L 695.0 830.0 L 691.0 833.0 L 681.0 844.0 L 675.0 844.0 L 666.0 848.0 L 660.0 848.0 L 658.0 851.0 L 651.0 851.0 L 643.0 856.0 L 628.0 856.0 L 623.0 860.0 Z",
      "position": {
        "x": 687.1,
        "y": 876.5
      },
      "badgeAnchor": {
        "x": 685.12,
        "y": 870.34
      },
      "adjacencies": [
        "crypt-063",
        "crypt-069",
        "crypt-075"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-069",
      "name": "Sunken Shrine",
      "regionId": "right-zygomatic",
      "shape": "M 726.0 810.0 L 709.0 826.0 L 709.0 830.0 L 706.0 835.0 L 706.0 839.0 L 717.0 847.0 L 717.0 852.0 L 719.0 855.0 L 719.0 867.0 L 721.0 868.0 L 721.0 887.0 L 722.0 892.0 L 719.0 896.0 L 720.0 908.0 L 718.0 909.0 L 719.0 916.0 L 711.0 923.0 L 710.0 926.0 L 706.0 929.0 L 707.0 929.0 L 717.0 931.0 L 722.0 934.0 L 730.0 943.0 L 734.0 946.0 L 748.0 950.0 L 753.0 956.0 L 753.0 955.0 L 755.0 948.0 L 758.0 944.0 L 758.0 940.0 L 762.0 937.0 L 761.0 928.0 L 766.0 923.0 L 766.0 919.0 L 772.0 914.0 L 772.0 907.0 L 782.0 903.0 L 788.0 895.0 L 788.0 891.0 L 782.0 884.0 L 782.0 874.0 L 771.0 864.0 L 770.0 862.0 L 770.0 853.0 L 767.0 850.0 L 767.0 842.0 L 762.0 838.0 L 762.0 833.0 L 764.0 830.0 L 764.0 820.0 L 765.0 818.0 L 758.0 818.0 L 754.0 816.0 L 749.0 816.0 L 741.0 813.0 L 736.0 813.0 Z",
      "position": {
        "x": 744.7,
        "y": 887
      },
      "badgeAnchor": {
        "x": 744.7,
        "y": 887
      },
      "adjacencies": [
        "crypt-063",
        "crypt-066",
        "crypt-068",
        "crypt-073",
        "crypt-076"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-070",
      "name": "Sunken Tomb",
      "regionId": "right-zygomatic",
      "shape": "M 906.0 855.0 L 900.0 855.0 L 898.0 858.0 L 895.0 858.0 L 888.0 864.0 L 884.0 865.0 L 879.0 871.0 L 873.0 871.0 L 870.0 877.0 L 862.0 884.0 L 862.0 887.0 L 856.0 893.0 L 855.0 893.0 L 855.0 903.0 L 854.0 910.0 L 850.0 916.0 L 850.0 922.0 L 852.0 924.0 L 852.0 940.0 L 848.0 948.0 L 848.0 962.0 L 846.0 965.0 L 847.0 972.0 L 847.0 983.0 L 848.0 989.0 L 842.0 993.0 L 837.0 994.0 L 837.0 995.0 L 840.0 997.0 L 839.0 1013.0 L 847.0 1018.0 L 854.0 1019.0 L 854.0 1015.0 L 857.0 1009.0 L 860.0 995.0 L 862.0 991.0 L 875.0 979.0 L 875.0 977.0 L 892.0 961.0 L 896.0 960.0 L 906.0 949.0 L 917.0 944.0 L 918.0 942.0 L 929.0 937.0 L 934.0 930.0 L 939.0 918.0 L 941.0 917.0 L 944.0 908.0 L 947.0 904.0 L 951.0 891.0 L 954.0 887.0 L 957.0 877.0 L 962.0 871.0 L 965.0 863.0 L 956.0 862.0 L 953.0 860.0 L 948.0 860.0 L 945.0 857.0 L 942.0 857.0 L 932.0 853.0 L 915.0 853.0 L 911.0 852.0 Z",
      "position": {
        "x": 903.9,
        "y": 905.1
      },
      "badgeAnchor": {
        "x": 903.9,
        "y": 905.1
      },
      "adjacencies": [
        "crypt-062",
        "crypt-066",
        "crypt-073",
        "crypt-081"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-071",
      "name": "Broken Crypt",
      "regionId": "left-zygomatic",
      "shape": "M 103.0 887.0 L 100.0 887.0 L 102.0 899.0 L 111.0 907.0 L 114.0 914.0 L 128.0 927.0 L 136.0 941.0 L 142.0 945.0 L 147.0 950.0 L 160.0 950.0 L 165.0 953.0 L 168.0 953.0 L 172.0 956.0 L 172.0 969.0 L 180.0 976.0 L 185.0 974.0 L 185.0 973.0 L 186.0 973.0 L 187.0 973.0 L 187.0 972.0 L 188.0 972.0 L 189.0 972.0 L 189.0 968.0 L 184.0 962.0 L 192.0 954.0 L 198.0 956.0 L 229.0 956.0 L 229.0 957.0 L 262.0 957.0 L 269.0 958.0 L 281.0 963.0 L 284.0 963.0 L 286.0 956.0 L 289.0 954.0 L 288.0 942.0 L 289.0 938.0 L 294.0 934.0 L 294.0 932.0 L 284.0 924.0 L 284.0 921.0 L 278.0 916.0 L 266.0 909.0 L 234.0 876.0 L 232.0 875.0 L 211.0 875.0 L 204.0 878.0 L 197.0 878.0 L 187.0 881.0 L 183.0 888.0 L 172.0 888.0 L 157.0 894.0 L 150.0 894.0 L 147.0 891.0 L 140.0 891.0 L 136.0 888.0 L 112.0 888.0 L 109.0 886.0 Z",
      "position": {
        "x": 196.9,
        "y": 919.4
      },
      "badgeAnchor": {
        "x": 196.9,
        "y": 919.4
      },
      "adjacencies": [
        "crypt-067",
        "crypt-074",
        "crypt-083"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-072",
      "name": "Broken Barrow",
      "regionId": "left-zygomatic",
      "shape": "M 405.0 878.0 L 405.0 879.0 L 397.0 887.0 L 397.0 892.0 L 387.0 901.0 L 387.0 911.0 L 386.0 911.0 L 386.0 920.0 L 380.0 924.0 L 380.0 929.0 L 375.0 933.0 L 374.0 945.0 L 378.0 948.0 L 378.0 957.0 L 383.0 960.0 L 385.0 963.0 L 385.0 967.0 L 394.0 972.0 L 395.0 974.0 L 403.0 977.0 L 407.0 977.0 L 412.0 981.0 L 418.0 983.0 L 418.0 982.0 L 423.0 978.0 L 426.0 978.0 L 430.0 975.0 L 431.0 969.0 L 434.0 966.0 L 441.0 965.0 L 456.0 959.0 L 456.0 949.0 L 453.0 947.0 L 451.0 941.0 L 447.0 936.0 L 446.0 928.0 L 446.0 915.0 L 445.0 915.0 L 445.0 902.0 L 444.0 902.0 L 444.0 889.0 L 445.0 889.0 L 445.0 879.0 L 424.0 879.0 L 424.0 878.0 Z",
      "position": {
        "x": 405.5,
        "y": 925.7
      },
      "badgeAnchor": {
        "x": 409.44,
        "y": 935.87
      },
      "adjacencies": [
        "crypt-065",
        "crypt-074",
        "crypt-078",
        "crypt-079"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-073",
      "name": "Broken Ossuary",
      "regionId": "right-zygomatic",
      "shape": "M 788.0 892.0 L 788.0 895.0 L 782.0 903.0 L 772.0 907.0 L 772.0 914.0 L 766.0 919.0 L 766.0 923.0 L 761.0 928.0 L 762.0 937.0 L 758.0 940.0 L 758.0 944.0 L 755.0 948.0 L 753.0 955.0 L 753.0 958.0 L 759.0 963.0 L 763.0 969.0 L 765.0 969.0 L 765.0 971.0 L 766.0 972.0 L 767.0 973.0 L 768.0 974.0 L 769.0 975.0 L 770.0 976.0 L 771.0 977.0 L 775.0 978.0 L 784.0 978.0 L 789.0 979.0 L 790.0 976.0 L 795.0 975.0 L 802.0 971.0 L 807.0 971.0 L 807.0 973.0 L 813.0 972.0 L 829.0 972.0 L 834.0 977.0 L 834.0 986.0 L 835.0 992.0 L 837.0 993.0 L 837.0 994.0 L 842.0 993.0 L 848.0 989.0 L 847.0 983.0 L 847.0 972.0 L 846.0 965.0 L 848.0 962.0 L 848.0 948.0 L 852.0 940.0 L 852.0 924.0 L 850.0 922.0 L 850.0 916.0 L 854.0 910.0 L 855.0 903.0 L 855.0 893.0 L 854.0 893.0 L 849.0 888.0 L 837.0 888.0 L 837.0 887.0 L 820.0 887.0 L 817.0 888.0 L 814.0 892.0 L 808.0 893.0 L 805.0 895.0 L 800.0 895.0 L 797.0 893.0 Z",
      "position": {
        "x": 801.7,
        "y": 929.7
      },
      "badgeAnchor": {
        "x": 801.7,
        "y": 929.7
      },
      "adjacencies": [
        "crypt-066",
        "crypt-069",
        "crypt-070",
        "crypt-076",
        "crypt-081"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-074",
      "name": "Broken Cairn",
      "regionId": "left-zygomatic",
      "shape": "M 341.0 864.0 L 340.0 864.0 L 341.0 865.0 L 339.0 874.0 L 335.0 878.0 L 327.0 879.0 L 324.0 883.0 L 323.0 888.0 L 318.0 896.0 L 317.0 900.0 L 316.0 913.0 L 314.0 917.0 L 314.0 927.0 L 311.0 931.0 L 305.0 932.0 L 303.0 934.0 L 294.0 933.0 L 294.0 934.0 L 289.0 938.0 L 288.0 942.0 L 289.0 954.0 L 286.0 956.0 L 284.0 963.0 L 286.0 966.0 L 292.0 968.0 L 300.0 977.0 L 302.0 986.0 L 308.0 991.0 L 310.0 999.0 L 319.0 1007.0 L 323.0 1016.0 L 326.0 1018.0 L 329.0 1016.0 L 330.0 1012.0 L 336.0 1007.0 L 337.0 1001.0 L 335.0 999.0 L 335.0 994.0 L 346.0 985.0 L 349.0 986.0 L 359.0 986.0 L 367.0 982.0 L 370.0 982.0 L 374.0 976.0 L 383.0 968.0 L 385.0 968.0 L 385.0 963.0 L 383.0 960.0 L 378.0 957.0 L 378.0 948.0 L 374.0 945.0 L 375.0 933.0 L 380.0 929.0 L 380.0 924.0 L 386.0 920.0 L 386.0 911.0 L 387.0 911.0 L 387.0 901.0 L 397.0 892.0 L 397.0 887.0 L 405.0 879.0 L 405.0 877.0 L 397.0 877.0 L 387.0 869.0 L 385.0 866.0 L 385.0 865.0 L 380.0 861.0 L 345.0 861.0 Z",
      "position": {
        "x": 333.4,
        "y": 938.3
      },
      "badgeAnchor": {
        "x": 336.57,
        "y": 939.57
      },
      "adjacencies": [
        "crypt-064",
        "crypt-065",
        "crypt-067",
        "crypt-071",
        "crypt-072",
        "crypt-078"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-075",
      "name": "Broken Haven",
      "regionId": "maxilla",
      "shape": "M 588.0 972.0 L 591.0 976.0 L 591.0 981.0 L 599.0 988.0 L 599.0 990.0 L 605.0 996.0 L 607.0 1003.0 L 614.0 1008.0 L 614.0 1009.0 L 618.0 1007.0 L 629.0 1004.0 L 640.0 992.0 L 651.0 989.0 L 659.0 988.0 L 669.0 985.0 L 675.0 979.0 L 677.0 979.0 L 681.0 969.0 L 693.0 958.0 L 698.0 945.0 L 698.0 938.0 L 703.0 931.0 L 703.0 928.0 L 696.0 926.0 L 683.0 914.0 L 677.0 903.0 L 673.0 902.0 L 652.0 902.0 L 642.0 906.0 L 633.0 907.0 L 622.0 900.0 L 619.0 894.0 L 615.0 893.0 L 612.0 893.0 L 609.0 903.0 L 609.0 913.0 L 608.0 913.0 L 608.0 922.0 L 607.0 922.0 L 607.0 932.0 L 606.0 939.0 L 601.0 951.0 L 601.0 954.0 L 593.0 966.0 L 593.0 968.0 Z",
      "position": {
        "x": 646.9,
        "y": 949.4
      },
      "badgeAnchor": {
        "x": 646.9,
        "y": 949.4
      },
      "adjacencies": [
        "crypt-068",
        "crypt-076",
        "crypt-077",
        "crypt-080"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-076",
      "name": "Broken Watch",
      "regionId": "maxilla",
      "shape": "M 703.0 929.0 L 703.0 931.0 L 698.0 938.0 L 698.0 945.0 L 693.0 958.0 L 681.0 969.0 L 677.0 979.0 L 678.0 979.0 L 680.0 980.0 L 686.0 992.0 L 696.0 1000.0 L 712.0 1000.0 L 718.0 1005.0 L 723.0 1007.0 L 726.0 1010.0 L 731.0 1010.0 L 738.0 1015.0 L 749.0 1014.0 L 749.0 1009.0 L 753.0 999.0 L 756.0 999.0 L 756.0 1020.0 L 762.0 1020.0 L 767.0 1013.0 L 768.0 1009.0 L 771.0 1006.0 L 772.0 999.0 L 772.0 986.0 L 773.0 979.0 L 771.0 977.0 L 770.0 977.0 L 770.0 976.0 L 769.0 976.0 L 769.0 975.0 L 768.0 975.0 L 768.0 974.0 L 767.0 974.0 L 767.0 973.0 L 766.0 973.0 L 766.0 972.0 L 765.0 972.0 L 765.0 971.0 L 763.0 969.0 L 759.0 963.0 L 753.0 958.0 L 753.0 956.0 L 748.0 950.0 L 734.0 946.0 L 730.0 943.0 L 722.0 934.0 L 717.0 931.0 L 707.0 929.0 Z",
      "position": {
        "x": 720.5,
        "y": 978.9
      },
      "badgeAnchor": {
        "x": 720.5,
        "y": 978.9
      },
      "adjacencies": [
        "crypt-069",
        "crypt-073",
        "crypt-075",
        "crypt-080"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-077",
      "name": "Broken Sanctum",
      "regionId": "maxilla",
      "shape": "M 497.0 979.0 L 499.0 985.0 L 502.0 987.0 L 506.0 997.0 L 518.0 1008.0 L 520.0 1009.0 L 531.0 1021.0 L 533.0 1024.0 L 533.0 1038.0 L 534.0 1038.0 L 534.0 1052.0 L 539.0 1059.0 L 539.0 1065.0 L 535.0 1072.0 L 535.0 1074.0 L 536.0 1074.0 L 536.0 1076.0 L 545.0 1079.0 L 548.0 1082.0 L 559.0 1082.0 L 563.0 1085.0 L 568.0 1086.0 L 577.0 1086.0 L 581.0 1087.0 L 581.0 1086.0 L 593.0 1070.0 L 595.0 1060.0 L 598.0 1052.0 L 603.0 1048.0 L 605.0 1041.0 L 610.0 1033.0 L 611.0 1028.0 L 616.0 1022.0 L 616.0 1018.0 L 614.0 1013.0 L 614.0 1008.0 L 607.0 1003.0 L 605.0 996.0 L 599.0 990.0 L 599.0 988.0 L 591.0 981.0 L 591.0 976.0 L 588.0 972.0 L 579.0 974.0 L 576.0 976.0 L 564.0 978.0 L 556.0 975.0 L 551.0 971.0 L 545.0 964.0 L 541.0 953.0 L 534.0 941.0 L 534.0 924.0 L 532.0 919.0 L 526.0 919.0 L 521.0 930.0 L 521.0 947.0 L 522.0 954.0 L 519.0 959.0 L 518.0 964.0 L 506.0 975.0 L 496.0 978.0 Z",
      "position": {
        "x": 560.8,
        "y": 1022.4
      },
      "badgeAnchor": {
        "x": 560.8,
        "y": 1022.4
      },
      "adjacencies": [
        "crypt-075",
        "crypt-080",
        "crypt-082",
        "crypt-084",
        "crypt-091"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-078",
      "name": "Broken Vault",
      "regionId": "left-zygomatic",
      "shape": "M 385.0 967.0 L 385.0 968.0 L 383.0 968.0 L 374.0 976.0 L 370.0 982.0 L 367.0 982.0 L 359.0 986.0 L 349.0 986.0 L 346.0 985.0 L 335.0 994.0 L 335.0 999.0 L 337.0 1001.0 L 336.0 1007.0 L 330.0 1012.0 L 329.0 1016.0 L 326.0 1018.0 L 330.0 1026.0 L 330.0 1034.0 L 327.0 1039.0 L 327.0 1048.0 L 328.0 1048.0 L 328.0 1057.0 L 332.0 1061.0 L 335.0 1067.0 L 335.0 1078.0 L 336.0 1078.0 L 336.0 1091.0 L 340.0 1096.0 L 341.0 1108.0 L 347.0 1116.0 L 353.0 1116.0 L 354.0 1118.0 L 362.0 1111.0 L 363.0 1109.0 L 363.0 1105.0 L 365.0 1105.0 L 366.0 1100.0 L 368.0 1099.0 L 370.0 1093.0 L 377.0 1088.0 L 382.0 1088.0 L 382.0 1086.0 L 387.0 1082.0 L 387.0 1075.0 L 389.0 1072.0 L 399.0 1071.0 L 401.0 1068.0 L 407.0 1065.0 L 414.0 1064.0 L 417.0 1064.0 L 416.0 1059.0 L 416.0 1050.0 L 415.0 1050.0 L 415.0 1041.0 L 419.0 1034.0 L 419.0 1003.0 L 420.0 1003.0 L 420.0 991.0 L 418.0 985.0 L 418.0 983.0 L 412.0 981.0 L 407.0 977.0 L 403.0 977.0 L 395.0 974.0 L 394.0 972.0 Z",
      "position": {
        "x": 371.9,
        "y": 1025.9
      },
      "badgeAnchor": {
        "x": 371.9,
        "y": 1025.9
      },
      "adjacencies": [
        "crypt-072",
        "crypt-074",
        "crypt-079",
        "crypt-087"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-079",
      "name": "Broken Shrine",
      "regionId": "left-zygomatic",
      "shape": "M 418.0 982.0 L 418.0 985.0 L 420.0 991.0 L 420.0 1003.0 L 419.0 1003.0 L 419.0 1034.0 L 415.0 1041.0 L 415.0 1050.0 L 416.0 1050.0 L 416.0 1059.0 L 417.0 1064.0 L 419.0 1064.0 L 426.0 1068.0 L 439.0 1069.0 L 457.0 1079.0 L 468.0 1080.0 L 470.0 1081.0 L 470.0 1080.0 L 472.0 1078.0 L 472.0 1072.0 L 470.0 1067.0 L 470.0 1056.0 L 473.0 1048.0 L 475.0 1038.0 L 478.0 1034.0 L 477.0 1024.0 L 470.0 1018.0 L 469.0 1015.0 L 469.0 988.0 L 462.0 986.0 L 456.0 979.0 L 456.0 959.0 L 441.0 965.0 L 434.0 966.0 L 431.0 969.0 L 430.0 975.0 L 426.0 978.0 L 423.0 978.0 Z",
      "position": {
        "x": 435.1,
        "y": 1026.1
      },
      "badgeAnchor": {
        "x": 438.46,
        "y": 1028.62
      },
      "adjacencies": [
        "crypt-072",
        "crypt-078",
        "crypt-082",
        "crypt-086",
        "crypt-087"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-080",
      "name": "Broken Tomb",
      "regionId": "maxilla",
      "shape": "M 675.0 979.0 L 669.0 985.0 L 659.0 988.0 L 651.0 989.0 L 640.0 992.0 L 629.0 1004.0 L 618.0 1007.0 L 614.0 1009.0 L 614.0 1013.0 L 616.0 1018.0 L 616.0 1021.0 L 621.0 1022.0 L 627.0 1026.0 L 631.0 1034.0 L 643.0 1042.0 L 647.0 1047.0 L 652.0 1047.0 L 656.0 1052.0 L 668.0 1062.0 L 668.0 1070.0 L 671.0 1074.0 L 677.0 1074.0 L 680.0 1073.0 L 684.0 1067.0 L 700.0 1058.0 L 711.0 1057.0 L 717.0 1062.0 L 720.0 1062.0 L 727.0 1062.0 L 728.0 1059.0 L 728.0 1049.0 L 727.0 1042.0 L 734.0 1032.0 L 734.0 1023.0 L 738.0 1018.0 L 738.0 1015.0 L 731.0 1010.0 L 726.0 1010.0 L 723.0 1007.0 L 718.0 1005.0 L 712.0 1000.0 L 696.0 1000.0 L 686.0 992.0 L 680.0 980.0 L 678.0 979.0 Z",
      "position": {
        "x": 669.9,
        "y": 1028.1
      },
      "badgeAnchor": {
        "x": 669.9,
        "y": 1028.1
      },
      "adjacencies": [
        "crypt-075",
        "crypt-076",
        "crypt-077",
        "crypt-084",
        "crypt-085"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-081",
      "name": "Pale Crypt",
      "regionId": "right-mandible",
      "shape": "M 807.0 973.0 L 807.0 974.0 L 798.0 974.0 L 798.0 981.0 L 801.0 983.0 L 801.0 989.0 L 797.0 992.0 L 794.0 998.0 L 790.0 1001.0 L 788.0 1013.0 L 783.0 1017.0 L 783.0 1026.0 L 776.0 1040.0 L 777.0 1043.0 L 775.0 1044.0 L 773.0 1053.0 L 775.0 1053.0 L 787.0 1055.0 L 793.0 1060.0 L 807.0 1064.0 L 810.0 1068.0 L 819.0 1068.0 L 826.0 1072.0 L 836.0 1075.0 L 846.0 1083.0 L 849.0 1083.0 L 856.0 1074.0 L 854.0 1054.0 L 855.0 1048.0 L 858.0 1044.0 L 858.0 1027.0 L 856.0 1026.0 L 854.0 1019.0 L 847.0 1018.0 L 839.0 1013.0 L 840.0 997.0 L 837.0 995.0 L 837.0 993.0 L 835.0 992.0 L 834.0 986.0 L 834.0 977.0 L 829.0 972.0 L 813.0 972.0 Z",
      "position": {
        "x": 813,
        "y": 1029.9
      },
      "badgeAnchor": {
        "x": 818.89,
        "y": 1037.25
      },
      "adjacencies": [
        "crypt-070",
        "crypt-073",
        "crypt-088",
        "crypt-089"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-082",
      "name": "Pale Barrow",
      "regionId": "maxilla",
      "shape": "M 469.0 988.0 L 469.0 1015.0 L 470.0 1018.0 L 477.0 1024.0 L 478.0 1034.0 L 475.0 1038.0 L 473.0 1048.0 L 470.0 1056.0 L 470.0 1067.0 L 472.0 1072.0 L 472.0 1075.0 L 488.0 1073.0 L 488.0 1074.0 L 497.0 1074.0 L 505.0 1076.0 L 521.0 1076.0 L 525.0 1073.0 L 535.0 1073.0 L 535.0 1072.0 L 539.0 1065.0 L 539.0 1059.0 L 534.0 1052.0 L 534.0 1038.0 L 533.0 1038.0 L 533.0 1024.0 L 531.0 1021.0 L 520.0 1009.0 L 518.0 1008.0 L 506.0 997.0 L 502.0 987.0 L 499.0 985.0 L 497.0 979.0 L 492.0 980.0 L 486.0 985.0 L 470.0 989.0 Z",
      "position": {
        "x": 504,
        "y": 1043.5
      },
      "badgeAnchor": {
        "x": 504,
        "y": 1043.5
      },
      "adjacencies": [
        "crypt-077",
        "crypt-079",
        "crypt-086"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-083",
      "name": "Pale Ossuary",
      "regionId": "left-mandible",
      "shape": "M 185.0 974.0 L 181.0 978.0 L 189.0 985.0 L 193.0 994.0 L 196.0 997.0 L 197.0 1005.0 L 197.0 1014.0 L 198.0 1014.0 L 198.0 1031.0 L 197.0 1031.0 L 197.0 1040.0 L 196.0 1046.0 L 205.0 1062.0 L 207.0 1070.0 L 207.0 1079.0 L 206.0 1079.0 L 206.0 1088.0 L 211.0 1098.0 L 211.0 1105.0 L 242.0 1105.0 L 242.0 1106.0 L 251.0 1106.0 L 256.0 1107.0 L 257.0 1105.0 L 266.0 1105.0 L 269.0 1107.0 L 274.0 1114.0 L 277.0 1115.0 L 277.0 1114.0 L 282.0 1112.0 L 285.0 1108.0 L 294.0 1106.0 L 299.0 1101.0 L 299.0 1092.0 L 300.0 1085.0 L 285.0 1082.0 L 281.0 1080.0 L 268.0 1066.0 L 266.0 1059.0 L 263.0 1053.0 L 247.0 1035.0 L 245.0 1027.0 L 242.0 1022.0 L 241.0 1010.0 L 240.0 1007.0 L 232.0 1005.0 L 225.0 997.0 L 222.0 983.0 L 212.0 983.0 L 212.0 982.0 L 201.0 982.0 L 190.0 972.0 L 189.0 972.0 L 188.0 972.0 L 188.0 973.0 L 187.0 973.0 L 186.0 973.0 Z",
      "position": {
        "x": 230.9,
        "y": 1058.5
      },
      "badgeAnchor": {
        "x": 236.23,
        "y": 1066.19
      },
      "adjacencies": [
        "crypt-090",
        "crypt-093",
        "crypt-071"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-084",
      "name": "Pale Cairn",
      "regionId": "maxilla",
      "shape": "M 616.0 1021.0 L 616.0 1022.0 L 611.0 1028.0 L 610.0 1033.0 L 605.0 1041.0 L 603.0 1048.0 L 598.0 1052.0 L 595.0 1060.0 L 593.0 1070.0 L 581.0 1086.0 L 581.0 1089.0 L 583.0 1097.0 L 586.0 1101.0 L 592.0 1103.0 L 592.0 1108.0 L 592.0 1121.0 L 591.0 1121.0 L 591.0 1128.0 L 592.0 1129.0 L 593.0 1130.0 L 594.0 1131.0 L 598.0 1139.0 L 601.0 1139.0 L 603.0 1137.0 L 604.0 1136.0 L 605.0 1135.0 L 605.0 1134.0 L 608.0 1134.0 L 610.0 1133.0 L 611.0 1132.0 L 612.0 1131.0 L 613.0 1130.0 L 614.0 1129.0 L 615.0 1128.0 L 616.0 1127.0 L 617.0 1126.0 L 618.0 1125.0 L 619.0 1124.0 L 620.0 1123.0 L 621.0 1122.0 L 622.0 1121.0 L 622.0 1120.0 L 624.0 1120.0 L 633.0 1110.0 L 642.0 1105.0 L 650.0 1105.0 L 653.0 1107.0 L 655.0 1107.0 L 657.0 1106.0 L 667.0 1094.0 L 669.0 1079.0 L 672.0 1074.0 L 671.0 1074.0 L 668.0 1070.0 L 668.0 1062.0 L 656.0 1052.0 L 652.0 1047.0 L 647.0 1047.0 L 643.0 1042.0 L 631.0 1034.0 L 627.0 1026.0 L 621.0 1022.0 Z",
      "position": {
        "x": 622.6,
        "y": 1079.2
      },
      "badgeAnchor": {
        "x": 622.6,
        "y": 1079.2
      },
      "adjacencies": [
        "crypt-077",
        "crypt-080",
        "crypt-085",
        "crypt-091",
        "crypt-092"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-085",
      "name": "Pale Haven",
      "regionId": "maxilla",
      "shape": "M 677.0 1074.0 L 672.0 1074.0 L 669.0 1079.0 L 667.0 1094.0 L 657.0 1106.0 L 655.0 1107.0 L 654.0 1107.0 L 655.0 1115.0 L 675.0 1134.0 L 676.0 1140.0 L 684.0 1148.0 L 686.0 1148.0 L 693.0 1141.0 L 699.0 1141.0 L 705.0 1139.0 L 707.0 1136.0 L 708.0 1136.0 L 714.0 1124.0 L 723.0 1116.0 L 731.0 1114.0 L 737.0 1107.0 L 738.0 1100.0 L 726.0 1089.0 L 723.0 1077.0 L 726.0 1067.0 L 726.0 1062.0 L 720.0 1062.0 L 717.0 1062.0 L 711.0 1057.0 L 700.0 1058.0 L 684.0 1067.0 L 680.0 1073.0 Z",
      "position": {
        "x": 695.4,
        "y": 1100.4
      },
      "badgeAnchor": {
        "x": 695.4,
        "y": 1100.4
      },
      "adjacencies": [
        "crypt-080",
        "crypt-084",
        "crypt-088",
        "crypt-092",
        "crypt-094"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-086",
      "name": "Pale Watch",
      "regionId": "maxilla",
      "shape": "M 472.0 1075.0 L 472.0 1078.0 L 470.0 1080.0 L 470.0 1082.0 L 467.0 1086.0 L 467.0 1096.0 L 468.0 1100.0 L 473.0 1107.0 L 473.0 1118.0 L 474.0 1119.0 L 474.0 1129.0 L 473.0 1129.0 L 473.0 1146.0 L 474.0 1146.0 L 474.0 1165.0 L 475.0 1165.0 L 475.0 1175.0 L 477.0 1178.0 L 488.0 1184.0 L 489.0 1186.0 L 495.0 1189.0 L 503.0 1189.0 L 504.0 1186.0 L 511.0 1187.0 L 512.0 1184.0 L 518.0 1184.0 L 520.0 1182.0 L 520.0 1161.0 L 519.0 1161.0 L 519.0 1140.0 L 521.0 1134.0 L 529.0 1128.0 L 529.0 1118.0 L 530.0 1114.0 L 536.0 1104.0 L 536.0 1087.0 L 535.0 1087.0 L 535.0 1078.0 L 536.0 1078.0 L 536.0 1074.0 L 535.0 1074.0 L 535.0 1073.0 L 525.0 1073.0 L 521.0 1076.0 L 505.0 1076.0 L 497.0 1074.0 L 488.0 1074.0 L 488.0 1073.0 Z",
      "position": {
        "x": 504,
        "y": 1111.6
      },
      "badgeAnchor": {
        "x": 504,
        "y": 1111.6
      },
      "adjacencies": [
        "crypt-079",
        "crypt-082",
        "crypt-087",
        "crypt-091"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-087",
      "name": "Pale Sanctum",
      "regionId": "left-zygomatic",
      "shape": "M 414.0 1064.0 L 407.0 1065.0 L 401.0 1068.0 L 399.0 1071.0 L 389.0 1072.0 L 387.0 1075.0 L 387.0 1082.0 L 382.0 1086.0 L 382.0 1088.0 L 377.0 1088.0 L 370.0 1093.0 L 368.0 1099.0 L 366.0 1100.0 L 365.0 1105.0 L 363.0 1109.0 L 363.0 1112.0 L 356.0 1118.0 L 350.0 1119.0 L 349.0 1122.0 L 352.0 1125.0 L 353.0 1129.0 L 378.0 1153.0 L 380.0 1153.0 L 385.0 1159.0 L 395.0 1163.0 L 403.0 1172.0 L 416.0 1170.0 L 418.0 1173.0 L 423.0 1175.0 L 425.0 1178.0 L 434.0 1180.0 L 434.0 1181.0 L 456.0 1181.0 L 455.0 1167.0 L 453.0 1166.0 L 453.0 1158.0 L 455.0 1157.0 L 454.0 1151.0 L 454.0 1141.0 L 453.0 1135.0 L 456.0 1132.0 L 457.0 1128.0 L 463.0 1124.0 L 469.0 1118.0 L 473.0 1118.0 L 473.0 1107.0 L 468.0 1100.0 L 467.0 1096.0 L 467.0 1086.0 L 470.0 1082.0 L 470.0 1081.0 L 468.0 1080.0 L 457.0 1079.0 L 439.0 1069.0 L 426.0 1068.0 L 419.0 1064.0 Z",
      "position": {
        "x": 407.9,
        "y": 1116.9
      },
      "badgeAnchor": {
        "x": 418.92,
        "y": 1113.86
      },
      "adjacencies": [
        "crypt-078",
        "crypt-079",
        "crypt-086"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-088",
      "name": "Pale Vault",
      "regionId": "right-mandible",
      "shape": "M 738.0 1100.0 L 737.0 1107.0 L 731.0 1114.0 L 723.0 1116.0 L 714.0 1124.0 L 708.0 1136.0 L 719.0 1136.0 L 720.0 1149.0 L 728.0 1156.0 L 731.0 1168.0 L 734.0 1174.0 L 736.0 1174.0 L 739.0 1176.0 L 748.0 1173.0 L 749.0 1171.0 L 759.0 1171.0 L 762.0 1170.0 L 766.0 1165.0 L 768.0 1165.0 L 778.0 1154.0 L 781.0 1153.0 L 792.0 1153.0 L 792.0 1151.0 L 792.0 1145.0 L 790.0 1144.0 L 790.0 1133.0 L 792.0 1127.0 L 792.0 1120.0 L 794.0 1118.0 L 794.0 1113.0 L 797.0 1107.0 L 800.0 1105.0 L 802.0 1100.0 L 803.0 1084.0 L 804.0 1079.0 L 810.0 1074.0 L 811.0 1068.0 L 810.0 1068.0 L 807.0 1064.0 L 793.0 1060.0 L 787.0 1055.0 L 775.0 1053.0 L 772.0 1053.0 L 766.0 1065.0 L 762.0 1069.0 L 759.0 1076.0 L 751.0 1084.0 L 748.0 1090.0 L 744.0 1095.0 Z",
      "position": {
        "x": 753.8,
        "y": 1125.1
      },
      "badgeAnchor": {
        "x": 753.8,
        "y": 1125.1
      },
      "adjacencies": [
        "crypt-081",
        "crypt-085",
        "crypt-089",
        "crypt-094",
        "crypt-095"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-089",
      "name": "Pale Shrine",
      "regionId": "right-mandible",
      "shape": "M 811.0 1068.0 L 810.0 1074.0 L 804.0 1079.0 L 803.0 1084.0 L 802.0 1100.0 L 800.0 1105.0 L 797.0 1107.0 L 794.0 1113.0 L 794.0 1118.0 L 792.0 1120.0 L 792.0 1127.0 L 790.0 1133.0 L 790.0 1144.0 L 792.0 1145.0 L 792.0 1151.0 L 792.0 1155.0 L 791.0 1160.0 L 791.0 1169.0 L 792.0 1177.0 L 798.0 1185.0 L 800.0 1185.0 L 804.0 1180.0 L 814.0 1178.0 L 818.0 1175.0 L 826.0 1173.0 L 830.0 1170.0 L 836.0 1169.0 L 845.0 1171.0 L 845.0 1153.0 L 846.0 1153.0 L 846.0 1110.0 L 847.0 1110.0 L 847.0 1088.0 L 849.0 1083.0 L 846.0 1083.0 L 836.0 1075.0 L 826.0 1072.0 L 819.0 1068.0 Z",
      "position": {
        "x": 814.6,
        "y": 1126.6
      },
      "badgeAnchor": {
        "x": 814.6,
        "y": 1126.6
      },
      "adjacencies": [
        "crypt-081",
        "crypt-088",
        "crypt-095",
        "crypt-096"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-090",
      "name": "Pale Tomb",
      "regionId": "left-mandible",
      "shape": "M 211.0 1105.0 L 210.0 1113.0 L 207.0 1120.0 L 207.0 1131.0 L 210.0 1133.0 L 213.0 1143.0 L 214.0 1143.0 L 214.0 1153.0 L 212.0 1156.0 L 213.0 1164.0 L 213.0 1178.0 L 214.0 1185.0 L 221.0 1184.0 L 229.0 1181.0 L 234.0 1178.0 L 239.0 1172.0 L 246.0 1172.0 L 250.0 1177.0 L 252.0 1177.0 L 256.0 1182.0 L 258.0 1182.0 L 263.0 1188.0 L 265.0 1188.0 L 270.0 1194.0 L 278.0 1195.0 L 286.0 1198.0 L 290.0 1198.0 L 296.0 1201.0 L 296.0 1205.0 L 306.0 1211.0 L 306.0 1210.0 L 309.0 1209.0 L 312.0 1205.0 L 319.0 1203.0 L 322.0 1198.0 L 323.0 1198.0 L 318.0 1192.0 L 311.0 1190.0 L 307.0 1187.0 L 304.0 1187.0 L 298.0 1184.0 L 296.0 1181.0 L 292.0 1180.0 L 286.0 1173.0 L 284.0 1169.0 L 283.0 1155.0 L 282.0 1155.0 L 282.0 1141.0 L 283.0 1141.0 L 283.0 1129.0 L 280.0 1125.0 L 280.0 1121.0 L 277.0 1117.0 L 277.0 1115.0 L 274.0 1114.0 L 269.0 1107.0 L 266.0 1105.0 L 257.0 1105.0 L 256.0 1107.0 L 251.0 1106.0 L 242.0 1106.0 L 242.0 1105.0 Z",
      "position": {
        "x": 243.4,
        "y": 1133.4
      },
      "badgeAnchor": {
        "x": 252.67,
        "y": 1139.86
      },
      "adjacencies": [
        "crypt-083",
        "crypt-093",
        "crypt-097",
        "crypt-099"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-091",
      "name": "Lost Crypt",
      "regionId": "maxilla",
      "shape": "M 536.0 1076.0 L 536.0 1078.0 L 535.0 1078.0 L 535.0 1087.0 L 536.0 1087.0 L 536.0 1104.0 L 530.0 1114.0 L 529.0 1126.0 L 534.0 1136.0 L 534.0 1171.0 L 538.0 1177.0 L 538.0 1185.0 L 543.0 1189.0 L 576.0 1189.0 L 586.0 1186.0 L 586.0 1172.0 L 583.0 1164.0 L 589.0 1157.0 L 592.0 1151.0 L 594.0 1143.0 L 594.0 1131.0 L 593.0 1131.0 L 593.0 1130.0 L 592.0 1130.0 L 592.0 1129.0 L 591.0 1129.0 L 591.0 1128.0 L 590.0 1121.0 L 591.0 1121.0 L 592.0 1118.0 L 592.0 1108.0 L 592.0 1103.0 L 586.0 1101.0 L 583.0 1097.0 L 581.0 1089.0 L 581.0 1087.0 L 577.0 1086.0 L 568.0 1086.0 L 563.0 1085.0 L 559.0 1082.0 L 548.0 1082.0 L 545.0 1079.0 Z",
      "position": {
        "x": 556.8,
        "y": 1136.7
      },
      "badgeAnchor": {
        "x": 556.8,
        "y": 1136.7
      },
      "adjacencies": [
        "crypt-077",
        "crypt-084",
        "crypt-086"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-092",
      "name": "Lost Barrow",
      "regionId": "maxilla",
      "shape": "M 624.0 1120.0 L 622.0 1121.0 L 622.0 1122.0 L 621.0 1122.0 L 621.0 1123.0 L 620.0 1123.0 L 620.0 1124.0 L 619.0 1124.0 L 619.0 1125.0 L 618.0 1125.0 L 618.0 1126.0 L 617.0 1126.0 L 617.0 1127.0 L 616.0 1127.0 L 616.0 1128.0 L 615.0 1128.0 L 615.0 1129.0 L 614.0 1129.0 L 614.0 1130.0 L 613.0 1130.0 L 613.0 1131.0 L 612.0 1131.0 L 612.0 1132.0 L 611.0 1132.0 L 611.0 1133.0 L 610.0 1133.0 L 610.0 1134.0 L 607.0 1134.0 L 605.0 1135.0 L 605.0 1136.0 L 604.0 1136.0 L 603.0 1139.0 L 603.0 1137.0 L 601.0 1139.0 L 604.0 1147.0 L 603.0 1157.0 L 602.0 1157.0 L 602.0 1179.0 L 604.0 1182.0 L 609.0 1185.0 L 611.0 1188.0 L 620.0 1188.0 L 625.0 1184.0 L 629.0 1183.0 L 644.0 1175.0 L 652.0 1174.0 L 655.0 1168.0 L 672.0 1163.0 L 685.0 1148.0 L 684.0 1148.0 L 676.0 1140.0 L 675.0 1134.0 L 655.0 1115.0 L 654.0 1107.0 L 653.0 1107.0 L 650.0 1105.0 L 642.0 1105.0 L 633.0 1110.0 Z",
      "position": {
        "x": 642.1,
        "y": 1142.3
      },
      "badgeAnchor": {
        "x": 642.1,
        "y": 1142.3
      },
      "adjacencies": [
        "crypt-084",
        "crypt-085",
        "crypt-094"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-093",
      "name": "Lost Ossuary",
      "regionId": "left-mandible",
      "shape": "M 299.0 1101.0 L 294.0 1106.0 L 285.0 1108.0 L 282.0 1112.0 L 277.0 1114.0 L 277.0 1117.0 L 280.0 1121.0 L 280.0 1125.0 L 283.0 1129.0 L 283.0 1141.0 L 282.0 1141.0 L 282.0 1155.0 L 283.0 1155.0 L 284.0 1169.0 L 286.0 1173.0 L 292.0 1180.0 L 296.0 1181.0 L 298.0 1184.0 L 304.0 1187.0 L 307.0 1187.0 L 311.0 1190.0 L 318.0 1192.0 L 323.0 1198.0 L 327.0 1198.0 L 330.0 1201.0 L 341.0 1204.0 L 348.0 1203.0 L 358.0 1198.0 L 361.0 1198.0 L 369.0 1190.0 L 369.0 1188.0 L 370.0 1188.0 L 370.0 1175.0 L 371.0 1175.0 L 373.0 1169.0 L 362.0 1159.0 L 362.0 1157.0 L 350.0 1146.0 L 350.0 1144.0 L 339.0 1134.0 L 336.0 1125.0 L 332.0 1120.0 L 327.0 1116.0 L 324.0 1105.0 L 317.0 1105.0 L 314.0 1109.0 L 308.0 1109.0 L 301.0 1101.0 Z",
      "position": {
        "x": 316.1,
        "y": 1161
      },
      "badgeAnchor": {
        "x": 316.56,
        "y": 1157.66
      },
      "adjacencies": [
        "crypt-083",
        "crypt-090",
        "crypt-097"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-094",
      "name": "Lost Cairn",
      "regionId": "right-mandible",
      "shape": "M 707.0 1136.0 L 705.0 1139.0 L 699.0 1141.0 L 693.0 1141.0 L 686.0 1148.0 L 685.0 1148.0 L 672.0 1163.0 L 655.0 1168.0 L 652.0 1174.0 L 656.0 1175.0 L 660.0 1180.0 L 659.0 1189.0 L 646.0 1197.0 L 653.0 1201.0 L 657.0 1201.0 L 663.0 1205.0 L 663.0 1213.0 L 659.0 1220.0 L 659.0 1223.0 L 655.0 1230.0 L 655.0 1251.0 L 656.0 1251.0 L 656.0 1264.0 L 658.0 1267.0 L 658.0 1269.0 L 666.0 1270.0 L 668.0 1273.0 L 673.0 1273.0 L 678.0 1269.0 L 684.0 1270.0 L 695.0 1270.0 L 695.0 1268.0 L 700.0 1260.0 L 702.0 1255.0 L 702.0 1245.0 L 704.0 1241.0 L 709.0 1237.0 L 711.0 1237.0 L 711.0 1229.0 L 713.0 1227.0 L 713.0 1222.0 L 706.0 1217.0 L 708.0 1210.0 L 713.0 1204.0 L 715.0 1198.0 L 723.0 1187.0 L 724.0 1183.0 L 733.0 1175.0 L 733.0 1174.0 L 734.0 1174.0 L 731.0 1168.0 L 728.0 1156.0 L 720.0 1149.0 L 719.0 1136.0 Z",
      "position": {
        "x": 693.5,
        "y": 1184.3
      },
      "badgeAnchor": {
        "x": 684.27,
        "y": 1207.58
      },
      "adjacencies": [
        "crypt-085",
        "crypt-088",
        "crypt-092",
        "crypt-095",
        "crypt-098",
        "crypt-102",
        "crypt-103"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-095",
      "name": "Lost Haven",
      "regionId": "right-mandible",
      "shape": "M 736.0 1174.0 L 733.0 1174.0 L 733.0 1175.0 L 724.0 1183.0 L 723.0 1187.0 L 715.0 1198.0 L 713.0 1204.0 L 708.0 1210.0 L 706.0 1217.0 L 713.0 1222.0 L 713.0 1227.0 L 711.0 1229.0 L 711.0 1237.0 L 714.0 1237.0 L 720.0 1237.0 L 723.0 1240.0 L 732.0 1240.0 L 740.0 1246.0 L 756.0 1248.0 L 761.0 1250.0 L 768.0 1251.0 L 774.0 1259.0 L 778.0 1260.0 L 778.0 1258.0 L 783.0 1252.0 L 785.0 1230.0 L 786.0 1230.0 L 786.0 1221.0 L 787.0 1221.0 L 787.0 1211.0 L 788.0 1205.0 L 791.0 1198.0 L 796.0 1194.0 L 797.0 1188.0 L 799.0 1185.0 L 798.0 1185.0 L 792.0 1177.0 L 791.0 1169.0 L 791.0 1160.0 L 792.0 1155.0 L 792.0 1153.0 L 781.0 1153.0 L 778.0 1154.0 L 768.0 1165.0 L 766.0 1165.0 L 762.0 1170.0 L 759.0 1171.0 L 749.0 1171.0 L 748.0 1173.0 L 739.0 1176.0 Z",
      "position": {
        "x": 753.4,
        "y": 1207.8
      },
      "badgeAnchor": {
        "x": 753.4,
        "y": 1207.8
      },
      "adjacencies": [
        "crypt-088",
        "crypt-089",
        "crypt-094",
        "crypt-096",
        "crypt-102"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-096",
      "name": "Lost Watch",
      "regionId": "right-mandible",
      "shape": "M 800.0 1185.0 L 799.0 1185.0 L 797.0 1188.0 L 796.0 1194.0 L 791.0 1198.0 L 788.0 1205.0 L 787.0 1211.0 L 787.0 1221.0 L 786.0 1221.0 L 786.0 1230.0 L 785.0 1230.0 L 783.0 1252.0 L 778.0 1258.0 L 778.0 1261.0 L 781.0 1263.0 L 784.0 1272.0 L 794.0 1281.0 L 796.0 1285.0 L 796.0 1292.0 L 804.0 1282.0 L 807.0 1277.0 L 809.0 1269.0 L 818.0 1261.0 L 821.0 1253.0 L 830.0 1245.0 L 832.0 1237.0 L 838.0 1227.0 L 841.0 1225.0 L 842.0 1218.0 L 842.0 1206.0 L 843.0 1206.0 L 843.0 1193.0 L 844.0 1193.0 L 844.0 1181.0 L 845.0 1181.0 L 845.0 1171.0 L 836.0 1169.0 L 830.0 1170.0 L 826.0 1173.0 L 818.0 1175.0 L 814.0 1178.0 L 804.0 1180.0 Z",
      "position": {
        "x": 809.2,
        "y": 1213.5
      },
      "badgeAnchor": {
        "x": 809.2,
        "y": 1213.5
      },
      "adjacencies": [
        "crypt-089",
        "crypt-095",
        "crypt-102"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-097",
      "name": "Lost Sanctum",
      "regionId": "left-mandible",
      "shape": "M 371.0 1175.0 L 371.0 1188.0 L 370.0 1188.0 L 369.0 1190.0 L 361.0 1198.0 L 358.0 1198.0 L 348.0 1203.0 L 341.0 1204.0 L 330.0 1201.0 L 327.0 1198.0 L 322.0 1198.0 L 319.0 1203.0 L 312.0 1205.0 L 309.0 1209.0 L 306.0 1210.0 L 306.0 1213.0 L 311.0 1226.0 L 312.0 1231.0 L 333.0 1246.0 L 341.0 1256.0 L 342.0 1260.0 L 345.0 1263.0 L 345.0 1274.0 L 348.0 1279.0 L 348.0 1283.0 L 351.0 1283.0 L 354.0 1285.0 L 363.0 1295.0 L 371.0 1299.0 L 377.0 1300.0 L 390.0 1300.0 L 396.0 1301.0 L 400.0 1304.0 L 406.0 1305.0 L 408.0 1298.0 L 408.0 1285.0 L 407.0 1285.0 L 407.0 1270.0 L 403.0 1269.0 L 403.0 1259.0 L 406.0 1254.0 L 406.0 1251.0 L 409.0 1246.0 L 409.0 1239.0 L 405.0 1238.0 L 401.0 1231.0 L 399.0 1230.0 L 400.0 1216.0 L 403.0 1210.0 L 403.0 1194.0 L 402.0 1191.0 L 384.0 1174.0 L 373.0 1172.0 Z",
      "position": {
        "x": 371.6,
        "y": 1244.4
      },
      "badgeAnchor": {
        "x": 359.54,
        "y": 1236.29
      },
      "adjacencies": [
        "crypt-090",
        "crypt-093",
        "crypt-099",
        "crypt-101",
        "crypt-104"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-098",
      "name": "Lost Vault",
      "regionId": "right-mandible",
      "shape": "M 609.0 1214.0 L 599.0 1214.0 L 595.0 1219.0 L 589.0 1218.0 L 584.0 1220.0 L 581.0 1228.0 L 581.0 1241.0 L 584.0 1246.0 L 584.0 1270.0 L 582.0 1270.0 L 582.0 1286.0 L 586.0 1293.0 L 587.0 1293.0 L 586.0 1297.0 L 586.0 1304.0 L 596.0 1303.0 L 599.0 1301.0 L 615.0 1301.0 L 620.0 1299.0 L 625.0 1299.0 L 639.0 1288.0 L 644.0 1286.0 L 650.0 1278.0 L 658.0 1271.0 L 658.0 1267.0 L 656.0 1264.0 L 656.0 1251.0 L 655.0 1251.0 L 655.0 1230.0 L 659.0 1223.0 L 659.0 1220.0 L 663.0 1213.0 L 663.0 1205.0 L 657.0 1201.0 L 653.0 1201.0 L 646.0 1197.0 L 636.0 1197.0 L 630.0 1191.0 L 630.0 1202.0 L 626.0 1205.0 L 608.0 1205.0 L 602.0 1213.0 Z",
      "position": {
        "x": 624.1,
        "y": 1246
      },
      "badgeAnchor": {
        "x": 624.1,
        "y": 1246
      },
      "adjacencies": [
        "crypt-094",
        "crypt-100",
        "crypt-103",
        "crypt-105"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-099",
      "name": "Lost Shrine",
      "regionId": "left-mandible",
      "shape": "M 214.0 1185.0 L 217.0 1193.0 L 217.0 1205.0 L 218.0 1205.0 L 218.0 1217.0 L 224.0 1222.0 L 224.0 1224.0 L 230.0 1229.0 L 232.0 1236.0 L 236.0 1242.0 L 238.0 1249.0 L 242.0 1252.0 L 245.0 1258.0 L 252.0 1265.0 L 254.0 1272.0 L 257.0 1276.0 L 257.0 1279.0 L 260.0 1283.0 L 260.0 1286.0 L 263.0 1290.0 L 263.0 1293.0 L 267.0 1300.0 L 270.0 1302.0 L 276.0 1313.0 L 279.0 1315.0 L 282.0 1321.0 L 288.0 1319.0 L 291.0 1316.0 L 297.0 1314.0 L 310.0 1300.0 L 315.0 1299.0 L 321.0 1295.0 L 328.0 1293.0 L 336.0 1285.0 L 344.0 1286.0 L 346.0 1283.0 L 348.0 1283.0 L 348.0 1279.0 L 345.0 1274.0 L 345.0 1263.0 L 342.0 1260.0 L 341.0 1256.0 L 333.0 1246.0 L 312.0 1231.0 L 311.0 1226.0 L 306.0 1213.0 L 306.0 1211.0 L 296.0 1205.0 L 296.0 1201.0 L 290.0 1198.0 L 286.0 1198.0 L 278.0 1195.0 L 270.0 1194.0 L 265.0 1188.0 L 263.0 1188.0 L 258.0 1182.0 L 256.0 1182.0 L 252.0 1177.0 L 250.0 1177.0 L 246.0 1172.0 L 239.0 1172.0 L 234.0 1178.0 L 229.0 1181.0 L 221.0 1184.0 Z",
      "position": {
        "x": 282,
        "y": 1261.4
      },
      "badgeAnchor": {
        "x": 283,
        "y": 1248.17
      },
      "adjacencies": [
        "crypt-090",
        "crypt-097",
        "crypt-104"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-100",
      "name": "Lost Tomb",
      "regionId": "chin",
      "shape": "M 488.0 1258.0 L 491.0 1262.0 L 492.0 1263.0 L 493.0 1263.0 L 494.0 1265.0 L 496.0 1265.0 L 496.0 1266.0 L 497.0 1267.0 L 496.0 1267.0 L 496.0 1269.0 L 498.0 1270.0 L 501.0 1275.0 L 500.0 1288.0 L 503.0 1297.0 L 508.0 1297.0 L 516.0 1299.0 L 521.0 1305.0 L 531.0 1305.0 L 531.0 1304.0 L 542.0 1304.0 L 547.0 1305.0 L 549.0 1302.0 L 569.0 1302.0 L 573.0 1301.0 L 579.0 1295.0 L 584.0 1293.0 L 586.0 1293.0 L 582.0 1286.0 L 582.0 1270.0 L 580.0 1270.0 L 580.0 1257.0 L 572.0 1257.0 L 567.0 1253.0 L 567.0 1250.0 L 564.0 1245.0 L 563.0 1238.0 L 563.0 1226.0 L 562.0 1219.0 L 566.0 1215.0 L 566.0 1207.0 L 549.0 1205.0 L 541.0 1208.0 L 541.0 1220.0 L 540.0 1220.0 L 540.0 1232.0 L 533.0 1238.0 L 528.0 1239.0 L 525.0 1234.0 L 521.0 1231.0 L 521.0 1218.0 L 520.0 1218.0 L 520.0 1206.0 L 510.0 1206.0 L 510.0 1207.0 L 500.0 1207.0 L 501.0 1216.0 L 495.0 1231.0 L 495.0 1242.0 L 496.0 1242.0 L 496.0 1254.0 L 493.0 1257.0 Z",
      "position": {
        "x": 539.6,
        "y": 1275.6
      },
      "badgeAnchor": {
        "x": 539.6,
        "y": 1275.6
      },
      "adjacencies": [
        "crypt-098",
        "crypt-101",
        "crypt-105"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-101",
      "name": "Shadow Crypt",
      "regionId": "chin",
      "shape": "M 407.0 1270.0 L 407.0 1285.0 L 408.0 1285.0 L 408.0 1298.0 L 406.0 1305.0 L 414.0 1306.0 L 420.0 1301.0 L 436.0 1301.0 L 441.0 1305.0 L 447.0 1306.0 L 450.0 1309.0 L 464.0 1309.0 L 464.0 1308.0 L 479.0 1308.0 L 487.0 1312.0 L 487.0 1313.0 L 494.0 1311.0 L 499.0 1306.0 L 499.0 1301.0 L 502.0 1297.0 L 503.0 1297.0 L 500.0 1288.0 L 501.0 1275.0 L 498.0 1270.0 L 496.0 1270.0 L 496.0 1269.0 L 495.0 1267.0 L 496.0 1267.0 L 496.0 1266.0 L 495.0 1265.0 L 493.0 1265.0 L 493.0 1263.0 L 492.0 1263.0 L 489.0 1262.0 L 491.0 1262.0 L 488.0 1258.0 L 486.0 1253.0 L 482.0 1248.0 L 479.0 1249.0 L 480.0 1245.0 L 477.0 1243.0 L 477.0 1233.0 L 481.0 1227.0 L 481.0 1203.0 L 475.0 1202.0 L 465.0 1202.0 L 457.0 1204.0 L 458.0 1209.0 L 458.0 1218.0 L 459.0 1224.0 L 455.0 1229.0 L 455.0 1251.0 L 452.0 1254.0 L 445.0 1255.0 L 439.0 1248.0 L 433.0 1233.0 L 434.0 1227.0 L 434.0 1217.0 L 435.0 1217.0 L 435.0 1206.0 L 436.0 1201.0 L 421.0 1201.0 L 421.0 1213.0 L 418.0 1220.0 L 418.0 1229.0 L 419.0 1229.0 L 419.0 1238.0 L 409.0 1249.0 L 409.0 1261.0 L 410.0 1261.0 L 410.0 1270.0 Z",
      "position": {
        "x": 455.7,
        "y": 1282.6
      },
      "badgeAnchor": {
        "x": 455.7,
        "y": 1282.6
      },
      "adjacencies": [
        "crypt-097",
        "crypt-100",
        "crypt-105",
        "crypt-106"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-102",
      "name": "Shadow Barrow",
      "regionId": "right-mandible",
      "shape": "M 714.0 1237.0 L 709.0 1237.0 L 704.0 1241.0 L 702.0 1245.0 L 702.0 1255.0 L 700.0 1260.0 L 695.0 1268.0 L 695.0 1284.0 L 699.0 1289.0 L 702.0 1295.0 L 702.0 1305.0 L 704.0 1309.0 L 709.0 1313.0 L 709.0 1314.0 L 717.0 1317.0 L 723.0 1324.0 L 723.0 1326.0 L 728.0 1330.0 L 739.0 1330.0 L 743.0 1328.0 L 759.0 1328.0 L 759.0 1329.0 L 772.0 1329.0 L 775.0 1327.0 L 785.0 1311.0 L 791.0 1300.0 L 793.0 1299.0 L 796.0 1293.0 L 796.0 1285.0 L 794.0 1281.0 L 784.0 1272.0 L 781.0 1263.0 L 778.0 1261.0 L 778.0 1260.0 L 774.0 1259.0 L 768.0 1251.0 L 761.0 1250.0 L 756.0 1248.0 L 740.0 1246.0 L 732.0 1240.0 L 723.0 1240.0 L 720.0 1237.0 Z",
      "position": {
        "x": 732.3,
        "y": 1282.6
      },
      "badgeAnchor": {
        "x": 738.9,
        "y": 1285.93
      },
      "adjacencies": [
        "crypt-094",
        "crypt-095",
        "crypt-096",
        "crypt-103",
        "crypt-107"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-103",
      "name": "Shadow Ossuary",
      "regionId": "right-mandible",
      "shape": "M 658.0 1269.0 L 658.0 1271.0 L 650.0 1278.0 L 644.0 1286.0 L 639.0 1288.0 L 625.0 1299.0 L 620.0 1299.0 L 615.0 1301.0 L 599.0 1301.0 L 596.0 1303.0 L 586.0 1304.0 L 586.0 1311.0 L 588.0 1313.0 L 591.0 1321.0 L 596.0 1325.0 L 596.0 1327.0 L 601.0 1331.0 L 602.0 1339.0 L 600.0 1344.0 L 600.0 1351.0 L 601.0 1353.0 L 613.0 1364.0 L 615.0 1364.0 L 621.0 1373.0 L 624.0 1376.0 L 630.0 1378.0 L 644.0 1378.0 L 645.0 1387.0 L 647.0 1390.0 L 649.0 1390.0 L 653.0 1385.0 L 656.0 1376.0 L 659.0 1374.0 L 661.0 1369.0 L 664.0 1367.0 L 669.0 1358.0 L 676.0 1353.0 L 682.0 1345.0 L 682.0 1342.0 L 688.0 1337.0 L 688.0 1335.0 L 698.0 1326.0 L 706.0 1322.0 L 709.0 1315.0 L 709.0 1313.0 L 704.0 1309.0 L 702.0 1305.0 L 702.0 1295.0 L 699.0 1289.0 L 695.0 1284.0 L 695.0 1270.0 L 684.0 1270.0 L 678.0 1269.0 L 673.0 1273.0 L 668.0 1273.0 L 666.0 1270.0 Z",
      "position": {
        "x": 633.5,
        "y": 1327.5
      },
      "badgeAnchor": {
        "x": 649.17,
        "y": 1320.17
      },
      "adjacencies": [
        "crypt-094",
        "crypt-098",
        "crypt-102",
        "crypt-105",
        "crypt-107",
        "crypt-108"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-104",
      "name": "Shadow Cairn",
      "regionId": "left-mandible",
      "shape": "M 346.0 1283.0 L 344.0 1286.0 L 336.0 1285.0 L 328.0 1293.0 L 321.0 1295.0 L 315.0 1299.0 L 310.0 1300.0 L 297.0 1314.0 L 291.0 1316.0 L 288.0 1319.0 L 282.0 1321.0 L 283.0 1325.0 L 291.0 1332.0 L 291.0 1334.0 L 299.0 1341.0 L 299.0 1343.0 L 307.0 1350.0 L 312.0 1360.0 L 320.0 1370.0 L 321.0 1374.0 L 329.0 1384.0 L 330.0 1388.0 L 338.0 1398.0 L 341.0 1405.0 L 346.0 1410.0 L 356.0 1411.0 L 363.0 1415.0 L 373.0 1418.0 L 378.0 1422.0 L 382.0 1427.0 L 390.0 1429.0 L 393.0 1429.0 L 395.0 1425.0 L 395.0 1418.0 L 395.0 1412.0 L 392.0 1409.0 L 388.0 1401.0 L 388.0 1378.0 L 387.0 1371.0 L 389.0 1365.0 L 389.0 1351.0 L 390.0 1351.0 L 390.0 1336.0 L 393.0 1324.0 L 396.0 1318.0 L 404.0 1311.0 L 406.0 1305.0 L 400.0 1304.0 L 396.0 1301.0 L 390.0 1300.0 L 377.0 1300.0 L 371.0 1299.0 L 363.0 1295.0 L 354.0 1285.0 L 351.0 1283.0 Z",
      "position": {
        "x": 346,
        "y": 1348.9
      },
      "badgeAnchor": {
        "x": 346,
        "y": 1348.9
      },
      "adjacencies": [
        "crypt-097",
        "crypt-099",
        "crypt-106",
        "crypt-110"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-105",
      "name": "Shadow Haven",
      "regionId": "chin",
      "shape": "M 584.0 1293.0 L 579.0 1295.0 L 573.0 1301.0 L 569.0 1302.0 L 549.0 1302.0 L 547.0 1305.0 L 542.0 1304.0 L 531.0 1304.0 L 531.0 1305.0 L 521.0 1305.0 L 516.0 1299.0 L 508.0 1297.0 L 502.0 1297.0 L 499.0 1301.0 L 499.0 1306.0 L 494.0 1311.0 L 487.0 1313.0 L 487.0 1316.0 L 484.0 1319.0 L 485.0 1321.0 L 485.0 1336.0 L 488.0 1346.0 L 488.0 1368.0 L 487.0 1374.0 L 495.0 1380.0 L 497.0 1385.0 L 498.0 1385.0 L 504.0 1391.0 L 507.0 1391.0 L 520.0 1400.0 L 520.0 1401.0 L 530.0 1398.0 L 539.0 1397.0 L 548.0 1393.0 L 551.0 1389.0 L 560.0 1389.0 L 561.0 1388.0 L 561.0 1386.0 L 562.0 1381.0 L 564.0 1380.0 L 563.0 1369.0 L 567.0 1364.0 L 577.0 1357.0 L 586.0 1357.0 L 591.0 1352.0 L 600.0 1349.0 L 600.0 1344.0 L 602.0 1339.0 L 601.0 1331.0 L 596.0 1327.0 L 596.0 1325.0 L 591.0 1321.0 L 588.0 1313.0 L 586.0 1311.0 L 586.0 1297.0 L 587.0 1293.0 Z",
      "position": {
        "x": 531.1,
        "y": 1352.4
      },
      "badgeAnchor": {
        "x": 531.1,
        "y": 1352.4
      },
      "adjacencies": [
        "crypt-098",
        "crypt-100",
        "crypt-101",
        "crypt-103",
        "crypt-106",
        "crypt-108",
        "crypt-109",
        "crypt-110"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-106",
      "name": "Shadow Watch",
      "regionId": "chin",
      "shape": "M 406.0 1305.0 L 404.0 1311.0 L 396.0 1318.0 L 393.0 1324.0 L 390.0 1336.0 L 390.0 1351.0 L 389.0 1351.0 L 389.0 1365.0 L 387.0 1371.0 L 388.0 1378.0 L 388.0 1401.0 L 392.0 1409.0 L 395.0 1412.0 L 395.0 1418.0 L 395.0 1419.0 L 399.0 1418.0 L 402.0 1412.0 L 409.0 1406.0 L 418.0 1404.0 L 421.0 1401.0 L 433.0 1398.0 L 436.0 1394.0 L 443.0 1392.0 L 453.0 1392.0 L 453.0 1391.0 L 463.0 1391.0 L 463.0 1390.0 L 473.0 1390.0 L 473.0 1389.0 L 490.0 1389.0 L 496.0 1385.0 L 497.0 1385.0 L 495.0 1380.0 L 487.0 1374.0 L 488.0 1368.0 L 488.0 1346.0 L 485.0 1336.0 L 485.0 1321.0 L 484.0 1319.0 L 487.0 1316.0 L 487.0 1312.0 L 479.0 1308.0 L 464.0 1308.0 L 464.0 1309.0 L 450.0 1309.0 L 447.0 1306.0 L 441.0 1305.0 L 436.0 1301.0 L 420.0 1301.0 L 414.0 1306.0 Z",
      "position": {
        "x": 429,
        "y": 1352.7
      },
      "badgeAnchor": {
        "x": 440.76,
        "y": 1351.99
      },
      "adjacencies": [
        "crypt-101",
        "crypt-104",
        "crypt-105",
        "crypt-110"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-107",
      "name": "Shadow Sanctum",
      "regionId": "right-mandible",
      "shape": "M 709.0 1314.0 L 709.0 1315.0 L 706.0 1322.0 L 698.0 1326.0 L 688.0 1335.0 L 688.0 1337.0 L 682.0 1342.0 L 682.0 1345.0 L 676.0 1353.0 L 669.0 1358.0 L 664.0 1367.0 L 661.0 1369.0 L 659.0 1374.0 L 656.0 1376.0 L 653.0 1385.0 L 649.0 1390.0 L 648.0 1390.0 L 656.0 1416.0 L 657.0 1416.0 L 666.0 1420.0 L 671.0 1426.0 L 679.0 1429.0 L 683.0 1432.0 L 691.0 1423.0 L 693.0 1423.0 L 702.0 1413.0 L 710.0 1410.0 L 717.0 1400.0 L 721.0 1397.0 L 727.0 1387.0 L 747.0 1368.0 L 752.0 1358.0 L 756.0 1352.0 L 768.0 1341.0 L 775.0 1327.0 L 772.0 1329.0 L 759.0 1329.0 L 759.0 1328.0 L 743.0 1328.0 L 739.0 1330.0 L 728.0 1330.0 L 723.0 1326.0 L 723.0 1324.0 L 717.0 1317.0 Z",
      "position": {
        "x": 695.5,
        "y": 1376.3
      },
      "badgeAnchor": {
        "x": 695.5,
        "y": 1376.3
      },
      "adjacencies": [
        "crypt-102",
        "crypt-103",
        "crypt-108"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-108",
      "name": "Shadow Vault",
      "regionId": "chin",
      "shape": "M 561.0 1386.0 L 561.0 1390.0 L 562.0 1392.0 L 571.0 1400.0 L 576.0 1401.0 L 584.0 1405.0 L 584.0 1415.0 L 587.0 1418.0 L 595.0 1420.0 L 599.0 1425.0 L 601.0 1425.0 L 605.0 1430.0 L 609.0 1432.0 L 609.0 1448.0 L 611.0 1449.0 L 611.0 1455.0 L 613.0 1461.0 L 633.0 1454.0 L 635.0 1452.0 L 641.0 1451.0 L 653.0 1445.0 L 656.0 1445.0 L 660.0 1441.0 L 660.0 1432.0 L 659.0 1432.0 L 659.0 1422.0 L 657.0 1416.0 L 656.0 1416.0 L 648.0 1390.0 L 647.0 1390.0 L 645.0 1387.0 L 644.0 1378.0 L 630.0 1378.0 L 624.0 1376.0 L 621.0 1373.0 L 615.0 1364.0 L 613.0 1364.0 L 601.0 1353.0 L 600.0 1351.0 L 600.0 1349.0 L 591.0 1352.0 L 586.0 1357.0 L 577.0 1357.0 L 567.0 1364.0 L 563.0 1369.0 L 564.0 1380.0 L 562.0 1381.0 Z",
      "position": {
        "x": 620.9,
        "y": 1417.2
      },
      "badgeAnchor": {
        "x": 611.42,
        "y": 1401.31
      },
      "adjacencies": [
        "crypt-103",
        "crypt-105",
        "crypt-107",
        "crypt-109"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-109",
      "name": "Shadow Shrine",
      "regionId": "chin",
      "shape": "M 520.0 1401.0 L 520.0 1408.0 L 518.0 1409.0 L 518.0 1430.0 L 516.0 1432.0 L 516.0 1444.0 L 514.0 1448.0 L 515.0 1463.0 L 523.0 1460.0 L 561.0 1460.0 L 571.0 1464.0 L 591.0 1464.0 L 591.0 1463.0 L 609.0 1463.0 L 613.0 1461.0 L 611.0 1455.0 L 611.0 1449.0 L 609.0 1448.0 L 609.0 1432.0 L 605.0 1430.0 L 601.0 1425.0 L 599.0 1425.0 L 595.0 1420.0 L 587.0 1418.0 L 584.0 1415.0 L 584.0 1405.0 L 576.0 1401.0 L 571.0 1400.0 L 562.0 1392.0 L 561.0 1390.0 L 561.0 1388.0 L 560.0 1389.0 L 551.0 1389.0 L 548.0 1393.0 L 539.0 1397.0 L 530.0 1398.0 Z",
      "position": {
        "x": 548.5,
        "y": 1426.1
      },
      "badgeAnchor": {
        "x": 548.5,
        "y": 1426.1
      },
      "adjacencies": [
        "crypt-105",
        "crypt-108",
        "crypt-110"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "crypt-110",
      "name": "Shadow Tomb",
      "regionId": "chin",
      "shape": "M 496.0 1385.0 L 490.0 1389.0 L 473.0 1389.0 L 473.0 1390.0 L 463.0 1390.0 L 463.0 1391.0 L 453.0 1391.0 L 453.0 1392.0 L 443.0 1392.0 L 436.0 1394.0 L 433.0 1398.0 L 421.0 1401.0 L 418.0 1404.0 L 409.0 1406.0 L 402.0 1412.0 L 399.0 1418.0 L 395.0 1419.0 L 395.0 1425.0 L 393.0 1429.0 L 396.0 1435.0 L 408.0 1440.0 L 409.0 1442.0 L 421.0 1447.0 L 421.0 1448.0 L 433.0 1448.0 L 433.0 1449.0 L 456.0 1449.0 L 456.0 1450.0 L 466.0 1450.0 L 480.0 1455.0 L 488.0 1455.0 L 495.0 1458.0 L 498.0 1458.0 L 507.0 1463.0 L 515.0 1463.0 L 514.0 1448.0 L 516.0 1444.0 L 516.0 1432.0 L 518.0 1430.0 L 518.0 1409.0 L 520.0 1408.0 L 520.0 1400.0 L 507.0 1391.0 L 504.0 1391.0 L 498.0 1385.0 Z",
      "position": {
        "x": 462.6,
        "y": 1428.6
      },
      "badgeAnchor": {
        "x": 476.62,
        "y": 1415.75
      },
      "adjacencies": [
        "crypt-104",
        "crypt-105",
        "crypt-106",
        "crypt-109"
      ],
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-10910301-6bfee59a",
  "seaRoutes": []
}
